{
  "level": "ho01",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:ho01",
    "objects": "AREAS.E3:ho01.e3",
    "mesh": "TREES.E3:ho01.e3"
  },
  "spawn_point": {
    "position": [
      -238.21596074974124,
      1395.678007748553,
      -276.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      -238.21596074974124,
      1495.678007748553,
      -276.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -5545.388671875,
      -2323.521484375,
      -300.0
    ],
    "bbox_max": [
      4275.4052734375,
      7450.0,
      1179.1292724609375
    ],
    "vertex_count": 1069,
    "vertices": [
      [
        552.3253784179688,
        5985.7529296875,
        250.00003051757812
      ],
      [
        2191.17431640625,
        5913.06494140625,
        250.0
      ],
      [
        664.39111328125,
        7248.0986328125,
        250.00003051757812
      ],
      [
        552.3253784179688,
        5985.7529296875,
        250.00003051757812
      ],
      [
        427.0267028808594,
        7267.0830078125,
        -58.07279968261719
      ],
      [
        231.02947998046875,
        7173.888671875,
        -300.0
      ],
      [
        0.0,
        7259.48291015625,
        0.0
      ],
      [
        3.814697265625e-06,
        7159.283203125,
        -300.0
      ],
      [
        200.0,
        7450.0,
        250.00003051757812
      ],
      [
        0.0,
        7410.2177734375,
        -22.699951171875
      ],
      [
        0.0,
        7410.2177734375,
        250.00003051757812
      ],
      [
        3034.4052734375,
        5777.3857421875,
        250.00001525878906
      ],
      [
        2191.17431640625,
        5913.06494140625,
        250.00003051757812
      ],
      [
        3956.20703125,
        5048.34375,
        54.11042022705078
      ],
      [
        3932.455322265625,
        5039.92822265625,
        28.535202026367188
      ],
      [
        3639.71728515625,
        5723.3046875,
        250.00003051757812
      ],
      [
        3680.427490234375,
        5673.4384765625,
        250.00003051757812
      ],
      [
        4097.28857421875,
        5162.82421875,
        250.0
      ],
      [
        4047.874755859375,
        5080.82177734375,
        152.81637573242188
      ],
      [
        4047.874755859375,
        5080.82177734375,
        152.8163604736328
      ],
      [
        4097.28857421875,
        5162.82421875,
        250.0
      ],
      [
        4145.146484375,
        5112.7666015625,
        250.0
      ],
      [
        4275.4052734375,
        4976.5205078125,
        249.99998474121094
      ],
      [
        -2379.3076171875,
        6956.58251953125,
        250.0
      ],
      [
        -305.4644775390625,
        5176.8955078125,
        250.00001525878906
      ],
      [
        -2700.0,
        6873.154296875,
        -22.699951171875
      ],
      [
        -2700.0,
        6873.154296875,
        43.83366394042969
      ],
      [
        -2360.73046875,
        6940.63916015625,
        249.9999542236328
      ],
      [
        -248.8677978515625,
        4693.4443359375,
        0.0
      ],
      [
        -248.8677978515625,
        4693.4443359375,
        0.0
      ],
      [
        -246.8081817626953,
        4169.818359375,
        -300.0
      ],
      [
        -302.08367919921875,
        3879.621826171875,
        -300.0
      ],
      [
        -366.4575500488281,
        3873.98974609375,
        -113.45060729980469
      ],
      [
        -2700.0,
        6873.154296875,
        249.99993896484375
      ],
      [
        -475.55438232421875,
        3864.445068359375,
        0.0
      ],
      [
        -619.7982788085938,
        3851.8251953125,
        150.0
      ],
      [
        -475.5544128417969,
        3864.445068359375,
        0.0
      ],
      [
        -366.4575500488281,
        3873.98974609375,
        -113.45060729980469
      ],
      [
        -1850.0,
        1750.0,
        60.000003814697266
      ],
      [
        -1850.0,
        1330.0,
        60.0
      ],
      [
        -300.0,
        1140.0,
        52.500030517578125
      ],
      [
        -300.0,
        1132.5,
        60.0
      ],
      [
        -300.0,
        1134.6966552734375,
        54.696746826171875
      ],
      [
        -370.0,
        1132.5,
        60.0
      ],
      [
        -370.0,
        1140.0,
        52.500030517578125
      ],
      [
        -370.0,
        1134.6966552734375,
        54.696746826171875
      ],
      [
        -370.0,
        1121.893310546875,
        60.0
      ],
      [
        -300.0,
        1121.893310546875,
        60.0
      ],
      [
        -351.793701171875,
        1121.8931884765625,
        60.0
      ],
      [
        -350.0,
        1125.0,
        58.71314239501953
      ],
      [
        -358.206298828125,
        1121.8931884765625,
        60.0
      ],
      [
        -360.0,
        1125.0,
        58.71314239501953
      ],
      [
        -369.0,
        1121.893310546875,
        60.0
      ],
      [
        -369.0,
        1123.0,
        59.54158020019531
      ],
      [
        -369.0,
        1123.0,
        59.54158401489258
      ],
      [
        -370.0,
        1123.0,
        59.54158020019531
      ],
      [
        -330.0,
        1124.3074951171875,
        59.0
      ],
      [
        -320.0,
        1124.3074951171875,
        59.0
      ],
      [
        -315.0,
        1124.3074951171875,
        59.0
      ],
      [
        -305.0,
        1124.3074951171875,
        59.0
      ],
      [
        -345.0,
        1124.3074951171875,
        59.0
      ],
      [
        -335.0,
        1124.3074951171875,
        59.0
      ],
      [
        -320.0,
        1121.8931884765625,
        60.0
      ],
      [
        -320.0,
        1124.3074951171875,
        59.0
      ],
      [
        -335.0,
        1121.8931884765625,
        60.0
      ],
      [
        -335.0,
        1124.3074951171875,
        59.0
      ],
      [
        -345.0,
        1124.3074951171875,
        59.0
      ],
      [
        -345.0,
        1121.8931884765625,
        60.0
      ],
      [
        -330.0,
        1124.3074951171875,
        59.0
      ],
      [
        -330.0,
        1121.8931884765625,
        60.0
      ],
      [
        -305.0,
        1121.8931884765625,
        60.0
      ],
      [
        -305.0,
        1124.3074951171875,
        59.0
      ],
      [
        -315.0,
        1124.3074951171875,
        59.0
      ],
      [
        -315.0,
        1121.8931884765625,
        60.0
      ],
      [
        -357.5,
        1129.330078125,
        56.919578552246094
      ],
      [
        -352.5,
        1129.330078125,
        56.91957473754883
      ],
      [
        -360.0,
        1125.0,
        58.71314239501953
      ],
      [
        -357.5,
        1129.330078125,
        56.91957473754883
      ],
      [
        -352.5,
        1129.330078125,
        56.919578552246094
      ],
      [
        -350.0,
        1125.0,
        58.71314239501953
      ],
      [
        -300.0,
        1039.800048828125,
        60.0
      ],
      [
        -325.0,
        1103.0,
        35.0
      ],
      [
        -335.6065979003906,
        1107.3934326171875,
        35.0
      ],
      [
        -314.3934020996094,
        1107.3934326171875,
        35.0
      ],
      [
        -325.0,
        1103.0,
        35.0
      ],
      [
        -314.3934020996094,
        1128.6065673828125,
        35.0
      ],
      [
        -310.0,
        1118.0,
        35.0
      ],
      [
        -340.0,
        1118.0,
        35.0
      ],
      [
        -335.6065979003906,
        1128.6065673828125,
        35.0
      ],
      [
        -335.6065979003906,
        1107.3934326171875,
        35.0
      ],
      [
        -340.0,
        1118.0,
        35.0
      ],
      [
        -310.0,
        1118.0,
        35.0
      ],
      [
        -314.3934020996094,
        1107.3934326171875,
        35.0
      ],
      [
        -314.3934020996094,
        1128.6065673828125,
        35.0
      ],
      [
        -335.6065979003906,
        1128.6065673828125,
        35.0
      ],
      [
        -310.0,
        1039.800048828125,
        60.0
      ],
      [
        -310.0,
        1084.0,
        50.0
      ],
      [
        -310.0,
        1084.0,
        60.0
      ],
      [
        -370.0,
        1112.0,
        36.0
      ],
      [
        -369.0,
        1112.0,
        36.0
      ],
      [
        -369.0,
        1108.0,
        36.0
      ],
      [
        -369.0,
        1108.0,
        35.0
      ],
      [
        -369.0,
        1108.0,
        36.0
      ],
      [
        -370.0,
        1123.0,
        36.0
      ],
      [
        -369.0,
        1123.0,
        36.0
      ],
      [
        -369.0,
        1127.0,
        36.0
      ],
      [
        -369.0,
        1127.0,
        36.0
      ],
      [
        -369.0,
        1127.0,
        35.0
      ],
      [
        -310.0,
        1110.0,
        59.489715576171875
      ],
      [
        -310.0,
        1084.0,
        59.489715576171875
      ],
      [
        -311.0,
        1110.0,
        60.0
      ],
      [
        -310.0,
        1110.0,
        60.0
      ],
      [
        -310.0,
        1110.0,
        59.489715576171875
      ],
      [
        -311.0,
        1110.0,
        59.489715576171875
      ],
      [
        -326.0,
        1110.0,
        60.0
      ],
      [
        -324.0,
        1110.0,
        60.0
      ],
      [
        -324.0,
        1110.0,
        59.489715576171875
      ],
      [
        -326.0,
        1110.0,
        59.489715576171875
      ],
      [
        -320.0,
        1110.0,
        59.489715576171875
      ],
      [
        -320.0,
        1123.1251220703125,
        59.489715576171875
      ],
      [
        -320.0,
        1110.0,
        59.489715576171875
      ],
      [
        -315.0,
        1123.1251220703125,
        59.489715576171875
      ],
      [
        -315.0,
        1110.0,
        59.489715576171875
      ],
      [
        -315.0,
        1110.0,
        59.489715576171875
      ],
      [
        -341.0,
        1110.0,
        59.489715576171875
      ],
      [
        -341.0,
        1110.0,
        60.0
      ],
      [
        -339.0,
        1110.0,
        60.0
      ],
      [
        -339.0,
        1110.0,
        59.489715576171875
      ],
      [
        -335.0,
        1110.0,
        59.489715576171875
      ],
      [
        -335.0,
        1123.1251220703125,
        59.489715576171875
      ],
      [
        -335.0,
        1110.0,
        59.489715576171875
      ],
      [
        -330.0,
        1123.1251220703125,
        59.489715576171875
      ],
      [
        -330.0,
        1110.0,
        59.489715576171875
      ],
      [
        -330.0,
        1110.0,
        59.489715576171875
      ],
      [
        -325.0,
        1135.164794921875,
        43.0
      ],
      [
        -312.8626708984375,
        1130.1373291015625,
        43.0
      ],
      [
        -310.0,
        1112.7738037109375,
        43.0
      ],
      [
        -310.0,
        1112.7738037109375,
        35.0
      ],
      [
        -312.8626708984375,
        1105.8626708984375,
        43.0
      ],
      [
        -312.8626708984375,
        1105.8626708984375,
        43.0
      ],
      [
        -313.6280212402344,
        1105.545654296875,
        35.0
      ],
      [
        -313.6280212402344,
        1105.545654296875,
        43.0
      ],
      [
        -314.3934020996094,
        1128.6065673828125,
        40.0
      ],
      [
        -314.3934020996094,
        1128.6065673828125,
        41.0
      ],
      [
        -310.0,
        1118.0,
        41.0
      ],
      [
        -310.0,
        1118.0,
        40.0
      ],
      [
        -312.8626708984375,
        1130.1373291015625,
        41.0
      ],
      [
        -312.8626708984375,
        1130.1373291015625,
        40.0
      ],
      [
        -310.0,
        1123.2261962890625,
        40.0
      ],
      [
        -310.0,
        1123.2261962890625,
        41.0
      ],
      [
        -317.63677978515625,
        1129.9500732421875,
        41.0
      ],
      [
        -318.44732666015625,
        1130.2857666015625,
        40.0
      ],
      [
        -325.0,
        1133.0,
        40.0
      ],
      [
        -325.0,
        1133.0,
        41.0
      ],
      [
        -318.44732666015625,
        1130.2857666015625,
        40.0
      ],
      [
        -317.63677978515625,
        1129.9500732421875,
        41.0
      ],
      [
        -314.3934020996094,
        1128.6065673828125,
        41.0
      ],
      [
        -314.3934020996094,
        1128.6065673828125,
        40.0
      ],
      [
        -325.7653503417969,
        1134.8477783203125,
        41.0
      ],
      [
        -325.7653503417969,
        1134.8477783203125,
        40.0
      ],
      [
        -325.0,
        1135.164794921875,
        40.0
      ],
      [
        -325.0,
        1135.164794921875,
        41.0
      ],
      [
        -310.0,
        1123.2261962890625,
        35.0
      ],
      [
        -325.7653503417969,
        1134.8477783203125,
        35.0
      ],
      [
        -312.8626708984375,
        1130.1373291015625,
        43.0
      ],
      [
        -310.0,
        1123.2261962890625,
        43.0
      ],
      [
        -325.7653503417969,
        1134.8477783203125,
        43.0
      ],
      [
        -325.0,
        1135.164794921875,
        43.0
      ],
      [
        -310.0,
        1110.0,
        59.0
      ],
      [
        -310.0,
        1124.3074951171875,
        59.0
      ],
      [
        -320.0,
        1120.928955078125,
        59.0
      ],
      [
        -321.3994140625,
        1124.3074951171875,
        59.0
      ],
      [
        -310.0,
        1110.0,
        59.0
      ],
      [
        -320.0,
        1120.9290771484375,
        59.489715576171875
      ],
      [
        -320.0,
        1120.928955078125,
        59.0
      ],
      [
        -310.0,
        1112.7738037109375,
        45.0
      ],
      [
        -310.0,
        1123.2261962890625,
        45.0
      ],
      [
        -325.7653503417969,
        1134.8477783203125,
        45.0
      ],
      [
        -313.6280212402344,
        1105.545654296875,
        45.0
      ],
      [
        -310.0,
        1112.7738037109375,
        45.0
      ],
      [
        -313.6280212402344,
        1105.545654296875,
        45.0
      ],
      [
        -310.0,
        1123.2261962890625,
        45.0
      ],
      [
        -325.7653503417969,
        1134.8477783203125,
        45.0
      ],
      [
        -325.0,
        1100.835205078125,
        43.0
      ],
      [
        -337.1373291015625,
        1105.8626708984375,
        43.0
      ],
      [
        -313.6280212402344,
        1105.545654296875,
        43.0
      ],
      [
        -325.0,
        1100.835205078125,
        43.0
      ],
      [
        -337.1373291015625,
        1130.1373291015625,
        43.0
      ],
      [
        -325.7653503417969,
        1134.8477783203125,
        43.0
      ],
      [
        -341.0,
        1120.81201171875,
        43.0
      ],
      [
        -341.0,
        1120.81201171875,
        35.0
      ],
      [
        -337.1373291015625,
        1130.1373291015625,
        43.0
      ],
      [
        -337.1373291015625,
        1105.8626708984375,
        43.0
      ],
      [
        -341.0,
        1115.18798828125,
        35.0
      ],
      [
        -341.0,
        1115.18798828125,
        43.0
      ],
      [
        -341.0,
        1110.0,
        59.0
      ],
      [
        -341.0,
        1124.3074951171875,
        59.0
      ],
      [
        -341.0,
        1110.0,
        59.0
      ],
      [
        -341.0,
        1118.0,
        45.0
      ],
      [
        -341.0,
        1120.81201171875,
        45.0
      ],
      [
        -341.0,
        1115.18798828125,
        45.0
      ],
      [
        -341.0,
        1118.0,
        45.0
      ],
      [
        -341.0,
        1120.81201171875,
        45.0
      ],
      [
        -341.0,
        1115.18798828125,
        45.0
      ],
      [
        -300.0,
        1039.800048828125,
        60.0
      ],
      [
        -310.0,
        1039.800048828125,
        60.0
      ],
      [
        -310.0,
        1110.0,
        59.489715576171875
      ],
      [
        -309.0,
        1110.0,
        60.0
      ],
      [
        -309.0,
        1110.0,
        59.489715576171875
      ],
      [
        -309.0,
        1084.0,
        60.0
      ],
      [
        -310.0,
        1084.0,
        59.489715576171875
      ],
      [
        -309.0,
        1084.0,
        59.489715576171875
      ],
      [
        -305.0,
        1110.0,
        59.489715576171875
      ],
      [
        -305.0,
        1123.1251220703125,
        59.489715576171875
      ],
      [
        -305.0,
        1110.0,
        59.489715576171875
      ],
      [
        -305.0,
        1084.0,
        60.0
      ],
      [
        -305.0,
        1084.0,
        59.489715576171875
      ],
      [
        -300.0,
        1084.0,
        59.489715576171875
      ],
      [
        0.0,
        1490.0,
        60.0
      ],
      [
        0.0,
        1490.0,
        214.0
      ],
      [
        -1850.0,
        1490.0,
        200.0
      ],
      [
        -1850.0,
        1490.0,
        60.0
      ],
      [
        -595.0115356445312,
        1430.0,
        60.0
      ],
      [
        -595.0115356445312,
        1430.0,
        214.0
      ],
      [
        -1850.0,
        1430.0,
        200.0
      ],
      [
        -1850.0,
        1430.0,
        60.0
      ],
      [
        -50.843994140625,
        1250.0,
        60.0
      ],
      [
        -50.843994140625,
        1250.0,
        120.0
      ],
      [
        -330.0,
        1040.0,
        70.0
      ],
      [
        -320.0,
        1040.0,
        70.0
      ],
      [
        -320.0,
        1040.0,
        70.0
      ],
      [
        -320.0,
        1040.0,
        60.0
      ],
      [
        -330.0,
        1040.0,
        60.0
      ],
      [
        -330.0,
        1040.0,
        70.0
      ],
      [
        -136.8179473876953,
        1200.363037109375,
        95.0
      ],
      [
        -144.0623016357422,
        1143.5941162109375,
        95.0
      ],
      [
        -161.6405487060547,
        1186.03173828125,
        95.0
      ],
      [
        -136.8179473876953,
        1200.363037109375,
        95.0
      ],
      [
        -136.8179473876953,
        1200.363037109375,
        120.0
      ],
      [
        -136.8179473876953,
        1200.363037109375,
        120.0
      ],
      [
        -154.16317749023438,
        1190.3486328125,
        131.0
      ],
      [
        -144.0623016357422,
        1143.5941162109375,
        95.0
      ],
      [
        -144.0623016357422,
        1143.5941162109375,
        120.0
      ],
      [
        -144.0623016357422,
        1143.5941162109375,
        120.0
      ],
      [
        -151.8478546142578,
        1162.39013671875,
        131.0
      ],
      [
        -152.8858184814453,
        1164.89599609375,
        131.0
      ],
      [
        -157.3835906982422,
        1188.4893798828125,
        131.0
      ],
      [
        -161.64051818847656,
        1186.0316162109375,
        131.0
      ],
      [
        -154.16317749023438,
        1190.3486328125,
        131.0
      ],
      [
        -157.3835906982422,
        1188.4893798828125,
        131.0
      ],
      [
        -152.8858184814453,
        1164.89599609375,
        131.0
      ],
      [
        -151.8478546142578,
        1162.39013671875,
        131.0
      ],
      [
        -154.61732482910156,
        1169.076171875,
        95.0
      ],
      [
        -154.61732482910156,
        1169.076171875,
        106.0
      ],
      [
        -169.12689208984375,
        1181.70947265625,
        95.0
      ],
      [
        -157.92893981933594,
        1177.0711669921875,
        95.0
      ],
      [
        -161.8411102294922,
        1185.915771484375,
        131.0
      ],
      [
        -161.8411102294922,
        1185.915771484375,
        131.0
      ],
      [
        -169.12673950195312,
        1181.70947265625,
        131.0
      ],
      [
        -190.0837860107422,
        1169.6099853515625,
        95.0
      ],
      [
        -165.00003051757812,
        1180.0001220703125,
        95.0
      ],
      [
        -179.36158752441406,
        1175.8004150390625,
        131.0
      ],
      [
        -184.49166870117188,
        1172.8385009765625,
        131.0
      ],
      [
        -183.21275329589844,
        1172.4560546875,
        131.0
      ],
      [
        -183.21275329589844,
        1172.4560546875,
        131.0
      ],
      [
        -184.49166870117188,
        1172.8385009765625,
        131.0
      ],
      [
        -190.08363342285156,
        1169.6099853515625,
        131.0
      ],
      [
        -179.36158752441406,
        1175.8004150390625,
        131.0
      ],
      [
        -173.2484588623047,
        1125.9443359375,
        95.0
      ],
      [
        -154.99998474121094,
        1170.0,
        95.0
      ],
      [
        -160.47933959960938,
        1156.7716064453125,
        131.0
      ],
      [
        -172.72410583496094,
        1127.210205078125,
        121.0477066040039
      ],
      [
        -173.2484588623047,
        1125.9443359375,
        120.0
      ],
      [
        -173.2484588623047,
        1125.9443359375,
        95.0
      ],
      [
        -160.47933959960938,
        1156.7716064453125,
        131.0
      ],
      [
        -173.2484588623047,
        1125.9443359375,
        120.0
      ],
      [
        -172.72410583496094,
        1127.210205078125,
        121.0477066040039
      ],
      [
        -315.0,
        1086.665771484375,
        75.0
      ],
      [
        -315.0,
        1075.0986328125,
        75.0
      ],
      [
        -315.0,
        1051.800048828125,
        75.0
      ],
      [
        -315.0,
        1060.0672607421875,
        75.0
      ],
      [
        -315.0,
        1075.0986328125,
        75.0
      ],
      [
        -315.0,
        1060.0672607421875,
        75.0
      ],
      [
        -315.0,
        1086.665771484375,
        75.0
      ],
      [
        -315.0,
        1096.7496337890625,
        75.0
      ],
      [
        -308.4855041503906,
        1100.5657958984375,
        75.0
      ],
      [
        -315.0,
        1051.800048828125,
        75.0
      ],
      [
        -315.0,
        1097.489501953125,
        75.0
      ],
      [
        -312.68304443359375,
        1098.8271484375,
        75.0
      ],
      [
        -234.8848114013672,
        1131.052490234375,
        75.0
      ],
      [
        -308.4855041503906,
        1100.5657958984375,
        75.0
      ],
      [
        -296.28228759765625,
        1079.42919921875,
        75.0
      ],
      [
        -307.16021728515625,
        1073.14892578125,
        75.0
      ],
      [
        -307.16021728515625,
        1073.14892578125,
        73.0
      ],
      [
        -307.16021728515625,
        1073.14892578125,
        73.0
      ],
      [
        -311.1120300292969,
        1070.8673095703125,
        73.0
      ],
      [
        -315.0,
        1065.104248046875,
        73.0
      ],
      [
        -315.0,
        1062.1451416015625,
        73.0
      ],
      [
        -315.0,
        1061.800048828125,
        73.0
      ],
      [
        -315.0,
        1062.1451416015625,
        73.0
      ],
      [
        -315.0,
        1065.104248046875,
        73.0
      ],
      [
        -311.1120300292969,
        1070.8673095703125,
        73.0
      ],
      [
        -311.1120300292969,
        1070.8673095703125,
        75.0
      ],
      [
        -315.0,
        1065.104248046875,
        75.0
      ],
      [
        -315.0,
        1061.800048828125,
        75.0
      ],
      [
        -315.0,
        1061.800048828125,
        73.0
      ],
      [
        -315.0,
        1051.800048828125,
        60.0
      ],
      [
        -315.0,
        1051.800048828125,
        70.0
      ],
      [
        -315.0,
        1051.800048828125,
        75.0
      ],
      [
        -315.0,
        1051.800048828125,
        70.0
      ],
      [
        -315.0,
        1053.0,
        68.0
      ],
      [
        -315.0,
        1053.0,
        64.0
      ],
      [
        -315.0,
        1051.800048828125,
        68.0
      ],
      [
        -315.0,
        1053.0,
        68.0
      ],
      [
        -315.0,
        1053.0,
        64.0
      ],
      [
        -315.0,
        1051.800048828125,
        64.0
      ],
      [
        -245.23561096191406,
        1126.7650146484375,
        70.0
      ],
      [
        -235.4326934814453,
        1130.8255615234375,
        70.0
      ],
      [
        -277.2930908203125,
        1113.486328125,
        70.0
      ],
      [
        -245.23561096191406,
        1126.7650146484375,
        70.0
      ],
      [
        -315.0,
        1086.7496337890625,
        73.0
      ],
      [
        -315.0,
        1084.7496337890625,
        73.0
      ],
      [
        -314.3651428222656,
        1086.7496337890625,
        75.0
      ],
      [
        -314.3651428222656,
        1086.7496337890625,
        73.0
      ],
      [
        -315.0,
        1084.7496337890625,
        73.0
      ],
      [
        -315.0,
        1084.7496337890625,
        75.0
      ],
      [
        -315.0,
        1086.7496337890625,
        75.0
      ],
      [
        -315.0,
        1086.7496337890625,
        73.0
      ],
      [
        -315.0,
        1096.7496337890625,
        70.0
      ],
      [
        -315.0,
        1096.7496337890625,
        75.0
      ],
      [
        -277.2930908203125,
        1113.486328125,
        60.0
      ],
      [
        -277.2930908203125,
        1113.486328125,
        70.0
      ],
      [
        -315.0,
        1096.7496337890625,
        60.0
      ],
      [
        -235.4326934814453,
        1130.8255615234375,
        70.0
      ],
      [
        -235.4326934814453,
        1130.8255615234375,
        60.0
      ],
      [
        -234.8848114013672,
        1131.052490234375,
        120.0
      ],
      [
        -206.69088745117188,
        1142.73095703125,
        120.0
      ],
      [
        -315.0,
        1051.800048828125,
        120.0
      ],
      [
        -308.4855041503906,
        1100.5657958984375,
        120.0
      ],
      [
        -312.68304443359375,
        1098.8271484375,
        120.0
      ],
      [
        -315.0,
        1097.489501953125,
        120.0
      ],
      [
        -234.8848114013672,
        1131.052490234375,
        120.0
      ],
      [
        -308.4855041503906,
        1100.5657958984375,
        120.0
      ],
      [
        -206.69088745117188,
        1142.73095703125,
        120.0
      ],
      [
        -187.8948974609375,
        1150.5166015625,
        131.0
      ],
      [
        -172.29017639160156,
        1156.9803466796875,
        131.0
      ],
      [
        -187.8948974609375,
        1150.5166015625,
        131.0
      ],
      [
        -172.29017639160156,
        1156.9803466796875,
        131.0
      ],
      [
        -197.011962890625,
        1130.9688720703125,
        95.0
      ],
      [
        -163.04396057128906,
        1150.5802001953125,
        95.0
      ],
      [
        -315.0,
        1051.800048828125,
        95.0
      ],
      [
        -315.0,
        1051.800048828125,
        75.0
      ],
      [
        -315.0,
        1056.88671875,
        76.0
      ],
      [
        -315.0,
        1054.7132568359375,
        76.0
      ],
      [
        -315.0,
        1054.7132568359375,
        76.0
      ],
      [
        -315.0,
        1055.71337890625,
        75.0
      ],
      [
        -315.0,
        1056.88671875,
        76.0
      ],
      [
        -315.0,
        1055.88671875,
        75.0
      ],
      [
        -315.0,
        1054.16015625,
        76.0
      ],
      [
        -315.0,
        1054.16015625,
        85.0
      ],
      [
        -315.0,
        1054.16015625,
        85.0
      ],
      [
        -315.0,
        1054.16015625,
        76.0
      ],
      [
        -313.3529968261719,
        1055.80712890625,
        85.0
      ],
      [
        -313.3529968261719,
        1055.80712890625,
        76.0
      ],
      [
        -313.3529968261719,
        1055.80712890625,
        76.0
      ],
      [
        -313.3529968261719,
        1055.80712890625,
        85.0
      ],
      [
        -315.0,
        1054.1455078125,
        76.0
      ],
      [
        -315.0,
        1054.16015625,
        76.0088119506836
      ],
      [
        -315.0,
        1057.4542236328125,
        85.0
      ],
      [
        -315.0,
        1057.4542236328125,
        76.0
      ],
      [
        -315.0,
        1057.4542236328125,
        76.0
      ],
      [
        -315.0,
        1057.4542236328125,
        85.0
      ],
      [
        -315.0,
        1057.4542236328125,
        76.04925537109375
      ],
      [
        -315.0,
        1054.16015625,
        76.0088119506836
      ],
      [
        -315.0,
        1057.53955078125,
        76.0
      ],
      [
        -315.0,
        1057.4542236328125,
        76.04925537109375
      ],
      [
        -197.011962890625,
        1130.9688720703125,
        120.0
      ],
      [
        -197.011962890625,
        1130.9688720703125,
        95.0
      ],
      [
        -315.0,
        1051.800048828125,
        95.0
      ],
      [
        -315.0,
        1051.800048828125,
        120.0
      ],
      [
        -206.69088745117188,
        1142.73095703125,
        95.0
      ],
      [
        -157.92893981933594,
        1162.928955078125,
        95.0
      ],
      [
        -206.69090270996094,
        1142.73095703125,
        95.0
      ],
      [
        -234.8848876953125,
        1131.0526123046875,
        75.0
      ],
      [
        -313.5,
        1098.3555908203125,
        75.0
      ],
      [
        -313.5,
        1098.3555908203125,
        78.33777618408203
      ],
      [
        -314.5,
        1097.7783203125,
        78.04911804199219
      ],
      [
        -314.5,
        1097.7783203125,
        75.0
      ],
      [
        -313.5,
        1098.3555908203125,
        78.33777618408203
      ],
      [
        -314.5,
        1097.7783203125,
        78.04911804199219
      ],
      [
        -214.8716278076172,
        1155.2987060546875,
        120.0
      ],
      [
        -214.8716278076172,
        1155.2987060546875,
        120.0
      ],
      [
        -197.52635192871094,
        1165.31298828125,
        131.0
      ],
      [
        -197.52635192871094,
        1165.31298828125,
        131.0
      ],
      [
        -165.0,
        1160.0,
        120.0
      ],
      [
        -172.07107543945312,
        1162.928955078125,
        120.0
      ],
      [
        -175.0,
        1170.0,
        120.0
      ],
      [
        -172.07107543945312,
        1177.071044921875,
        120.0
      ],
      [
        -172.07107543945312,
        1162.928955078125,
        120.0
      ],
      [
        -175.0,
        1170.0,
        120.0
      ],
      [
        -309.53204345703125,
        1100.646484375,
        78.0
      ],
      [
        -309.53204345703125,
        1100.646484375,
        78.0
      ],
      [
        -309.53204345703125,
        1100.646484375,
        75.0
      ],
      [
        -240.8894805908203,
        1140.2772216796875,
        78.0
      ],
      [
        -240.61631774902344,
        1139.8575439453125,
        78.0
      ],
      [
        -240.61631774902344,
        1139.8575439453125,
        75.0
      ],
      [
        -214.8716278076172,
        1155.2987060546875,
        95.0
      ],
      [
        -214.59840393066406,
        1154.8790283203125,
        95.0
      ],
      [
        -240.61631774902344,
        1139.8575439453125,
        95.0
      ],
      [
        -214.59840393066406,
        1154.87890625,
        95.0
      ],
      [
        -214.8716278076172,
        1155.2987060546875,
        95.0
      ],
      [
        -186.54383850097656,
        1171.0762939453125,
        95.0
      ],
      [
        -240.61631774902344,
        1139.8575439453125,
        95.0
      ],
      [
        -353.78216552734375,
        1075.0986328125,
        75.0
      ],
      [
        -334.2353210449219,
        1086.384033203125,
        75.0
      ],
      [
        -353.78216552734375,
        1075.0986328125,
        75.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        75.0
      ],
      [
        -316.2815856933594,
        1096.7496337890625,
        75.0
      ],
      [
        -334.2353210449219,
        1086.384033203125,
        75.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        75.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        60.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        75.0
      ],
      [
        -330.0,
        1050.0,
        60.0
      ],
      [
        -330.0,
        1050.0,
        70.0
      ],
      [
        -330.0,
        1050.0,
        70.0
      ],
      [
        -320.0,
        1050.0,
        70.0
      ],
      [
        -320.0,
        1050.0,
        70.0
      ],
      [
        -320.0,
        1050.0,
        60.0
      ],
      [
        -333.60223388671875,
        1086.74951171875,
        75.0
      ],
      [
        -333.60223388671875,
        1086.74951171875,
        73.0
      ],
      [
        -336.10882568359375,
        1085.3023681640625,
        73.0
      ],
      [
        -337.06640625,
        1084.74951171875,
        73.0
      ],
      [
        -333.60223388671875,
        1086.74951171875,
        73.0
      ],
      [
        -336.10882568359375,
        1085.3023681640625,
        73.0
      ],
      [
        -316.281494140625,
        1096.7496337890625,
        60.0
      ],
      [
        -316.281494140625,
        1096.7496337890625,
        75.0
      ],
      [
        -338.6153259277344,
        1083.855224609375,
        73.0
      ],
      [
        -342.3205261230469,
        1077.4376220703125,
        75.0
      ],
      [
        -342.3205261230469,
        1077.4376220703125,
        73.0
      ],
      [
        -338.6153259277344,
        1083.855224609375,
        75.0
      ],
      [
        -338.6153259277344,
        1083.855224609375,
        73.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        120.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        95.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        75.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        80.00016021728516
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        100.00016021728516
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        95.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        120.0
      ],
      [
        -336.6470031738281,
        1055.80712890625,
        76.0
      ],
      [
        -336.6470031738281,
        1055.80712890625,
        85.0
      ],
      [
        -336.6470031738281,
        1055.80712890625,
        85.0
      ],
      [
        -336.6470031738281,
        1055.80712890625,
        76.0
      ],
      [
        -620.4532470703125,
        1262.8734130859375,
        60.0
      ],
      [
        -620.4532470703125,
        1262.8734130859375,
        214.0
      ],
      [
        -1853.5714111328125,
        1333.5714111328125,
        250.0
      ],
      [
        -1866.4285888671875,
        1333.5714111328125,
        250.0
      ],
      [
        -1853.5714111328125,
        1333.5714111328125,
        250.0
      ],
      [
        -1853.5714111328125,
        1346.4285888671875,
        250.0
      ],
      [
        -497.0710754394531,
        1177.071044921875,
        250.0
      ],
      [
        -490.0,
        1180.0,
        250.00001525878906
      ],
      [
        -525.5997924804688,
        1165.2540283203125,
        95.0
      ],
      [
        -513.3609008789062,
        1201.0435791015625,
        95.0
      ],
      [
        -482.3796081542969,
        1183.156494140625,
        95.0
      ],
      [
        -513.3609008789062,
        1201.0435791015625,
        95.0
      ],
      [
        -513.3609008789062,
        1201.0435791015625,
        120.0
      ],
      [
        -513.3609008789062,
        1201.0435791015625,
        120.0
      ],
      [
        -517.015869140625,
        1168.8095703125,
        127.16272735595703
      ],
      [
        -506.3941955566406,
        1173.209228515625,
        131.0
      ],
      [
        -496.0403137207031,
        1191.0435791015625,
        131.0
      ],
      [
        -525.5997924804688,
        1165.2540283203125,
        120.0
      ],
      [
        -525.5997924804688,
        1165.2540283203125,
        95.0
      ],
      [
        -495.941162109375,
        1190.986328125,
        131.0
      ],
      [
        -495.7098388671875,
        1190.852783203125,
        131.0
      ],
      [
        -496.0403137207031,
        1191.0435791015625,
        131.0
      ],
      [
        -506.3941955566406,
        1173.209228515625,
        131.0
      ],
      [
        -495.941162109375,
        1190.986328125,
        131.0
      ],
      [
        -495.7098388671875,
        1190.852783203125,
        131.0
      ],
      [
        -482.37957763671875,
        1183.1566162109375,
        131.0
      ],
      [
        -517.015869140625,
        1168.8095703125,
        127.16272735595703
      ],
      [
        -525.5997924804688,
        1165.2540283203125,
        120.0
      ],
      [
        -498.377685546875,
        1176.52978515625,
        105.0
      ],
      [
        -490.0,
        1180.0,
        250.0
      ],
      [
        -482.9289245605469,
        1177.071044921875,
        250.00001525878906
      ],
      [
        -490.0,
        1180.0,
        95.0
      ],
      [
        -443.68133544921875,
        1160.8140869140625,
        95.0
      ],
      [
        -473.26373291015625,
        1173.067626953125,
        131.0
      ],
      [
        -468.59075927734375,
        1175.195556640625,
        131.0
      ],
      [
        -468.8244934082031,
        1175.33056640625,
        131.0
      ],
      [
        -468.8244934082031,
        1175.33056640625,
        131.0
      ],
      [
        -453.430419921875,
        1164.8524169921875,
        131.0
      ],
      [
        -452.7389221191406,
        1166.04345703125,
        131.0
      ],
      [
        -468.59075927734375,
        1175.195556640625,
        131.0
      ],
      [
        -473.26373291015625,
        1173.067626953125,
        131.0
      ],
      [
        -443.6815490722656,
        1160.814208984375,
        125.24781799316406
      ],
      [
        -452.7389221191406,
        1166.04345703125,
        131.0
      ],
      [
        -453.430419921875,
        1164.8524169921875,
        131.0
      ],
      [
        -500.0,
        1170.0,
        250.0
      ],
      [
        -497.0710754394531,
        1177.071044921875,
        250.00001525878906
      ],
      [
        -511.4183044433594,
        1142.4337158203125,
        95.0
      ],
      [
        -497.0710754394531,
        1177.071044921875,
        95.0
      ],
      [
        -511.4183044433594,
        1142.4337158203125,
        120.0
      ],
      [
        -503.6961364746094,
        1161.07666015625,
        131.0
      ],
      [
        -511.4183044433594,
        1142.4337158203125,
        105.0
      ],
      [
        -511.4183044433594,
        1142.4337158203125,
        95.0
      ],
      [
        -511.4183044433594,
        1142.4337158203125,
        120.0
      ],
      [
        -511.4183044433594,
        1142.4337158203125,
        105.0
      ],
      [
        -502.5416259765625,
        1163.864013671875,
        131.0
      ],
      [
        -502.5416259765625,
        1163.864013671875,
        131.0
      ],
      [
        -503.6961364746094,
        1161.07666015625,
        131.0
      ],
      [
        -500.3826599121094,
        1169.076171875,
        106.0
      ],
      [
        -500.3826599121094,
        1169.076171875,
        95.0
      ],
      [
        -497.0710754394531,
        1162.928955078125,
        250.0
      ],
      [
        -500.0,
        1170.0,
        250.00001525878906
      ],
      [
        -471.0050354003906,
        1100.0,
        95.0
      ],
      [
        -479.289306640625,
        1120.0,
        95.0
      ],
      [
        -481.35125732421875,
        1124.97802734375,
        95.0
      ],
      [
        -500.0,
        1170.0,
        95.0
      ],
      [
        -487.30767822265625,
        1110.0,
        95.0
      ],
      [
        -487.30767822265625,
        1100.0,
        95.0
      ],
      [
        -471.0050354003906,
        1100.0,
        105.0
      ],
      [
        -471.0050354003906,
        1100.0,
        95.0
      ],
      [
        -471.0050354003906,
        1100.0,
        105.0
      ],
      [
        -471.0050354003906,
        1100.0,
        140.0
      ],
      [
        -481.35125732421875,
        1124.97802734375,
        120.0
      ],
      [
        -493.9633483886719,
        1155.4261474609375,
        131.0
      ],
      [
        -481.35125732421875,
        1124.97802734375,
        105.0
      ],
      [
        -481.35125732421875,
        1124.97802734375,
        95.0
      ],
      [
        -481.35125732421875,
        1124.97802734375,
        120.0
      ],
      [
        -481.35125732421875,
        1124.97802734375,
        105.0
      ],
      [
        -475.1471862792969,
        1110.0,
        99.51676177978516
      ],
      [
        -471.0050354003906,
        1100.0,
        101.0552749633789
      ],
      [
        -493.96337890625,
        1155.42626953125,
        131.0
      ],
      [
        -339.4679260253906,
        1100.646484375,
        78.0
      ],
      [
        -334.49993896484375,
        1097.7781982421875,
        75.0
      ],
      [
        -335.49993896484375,
        1097.7781982421875,
        75.0
      ],
      [
        -340.46795654296875,
        1100.646484375,
        75.0
      ],
      [
        -409.6885070800781,
        1140.611083984375,
        75.0
      ],
      [
        -340.46795654296875,
        1100.646484375,
        75.0
      ],
      [
        -409.6875,
        1140.6104736328125,
        70.0
      ],
      [
        -400.25,
        1135.1617431640625,
        70.0
      ],
      [
        -400.25,
        1135.1617431640625,
        70.0
      ],
      [
        -400.25,
        1135.1617431640625,
        60.0
      ],
      [
        -409.6874694824219,
        1140.6104736328125,
        60.0
      ],
      [
        -409.6875,
        1140.6104736328125,
        70.0
      ],
      [
        -336.5,
        1098.6800537109375,
        78.0
      ],
      [
        -336.5,
        1098.3555908203125,
        78.0
      ],
      [
        -336.5,
        1098.3555908203125,
        75.0
      ],
      [
        -336.5,
        1098.6800537109375,
        78.0
      ],
      [
        -336.5,
        1098.9329833984375,
        75.0
      ],
      [
        -336.5,
        1098.9329833984375,
        78.0
      ],
      [
        -335.5,
        1098.3555908203125,
        75.0
      ],
      [
        -335.5,
        1097.7781982421875,
        75.0
      ],
      [
        -335.5,
        1097.7781982421875,
        78.0
      ],
      [
        -335.5,
        1098.3555908203125,
        78.0
      ],
      [
        -339.4679260253906,
        1100.646484375,
        75.0
      ],
      [
        -339.46795654296875,
        1100.646484375,
        78.0
      ],
      [
        -409.4375,
        1141.04345703125,
        78.0
      ],
      [
        -409.6885070800781,
        1140.611083984375,
        75.0
      ],
      [
        -409.6885070800781,
        1140.611083984375,
        78.0
      ],
      [
        -342.1239318847656,
        1097.7781982421875,
        75.0
      ],
      [
        -342.1239318847656,
        1097.7781982421875,
        75.0
      ],
      [
        -394.5001220703125,
        1097.7781982421875,
        75.0
      ],
      [
        -344.49957275390625,
        1097.7781982421875,
        70.0
      ],
      [
        -344.49957275390625,
        1097.7781982421875,
        60.0
      ],
      [
        -384.4997253417969,
        1097.7781982421875,
        70.0
      ],
      [
        -344.49957275390625,
        1097.7781982421875,
        70.0
      ],
      [
        -384.4997253417969,
        1097.7781982421875,
        60.0
      ],
      [
        -384.4997253417969,
        1097.7781982421875,
        70.0
      ],
      [
        -424.5,
        1115.0986328125,
        78.0
      ],
      [
        -394.5001220703125,
        1097.7781982421875,
        75.0
      ],
      [
        -394.5001220703125,
        1097.7781982421875,
        78.0
      ],
      [
        -417.09478759765625,
        1136.816650390625,
        78.0
      ],
      [
        -424.6260986328125,
        1123.84423828125,
        78.0
      ],
      [
        -424.5,
        1115.0986328125,
        78.0
      ],
      [
        -420.7344055175781,
        1121.5848388671875,
        78.0
      ],
      [
        -413.2030944824219,
        1134.5572509765625,
        78.0
      ],
      [
        -424.6260986328125,
        1123.84423828125,
        78.0
      ],
      [
        -420.7344055175781,
        1121.5848388671875,
        78.0
      ],
      [
        -413.2030944824219,
        1134.5572509765625,
        78.0
      ],
      [
        -417.09478759765625,
        1136.816650390625,
        78.0
      ],
      [
        -336.5,
        1097.7781982421875,
        78.0
      ],
      [
        -336.5,
        1097.7781982421875,
        75.0
      ],
      [
        -435.4183654785156,
        1156.04345703125,
        120.0
      ],
      [
        -334.49993896484375,
        1097.7781982421875,
        120.0
      ],
      [
        -342.1239318847656,
        1097.7781982421875,
        120.0
      ],
      [
        -394.5001220703125,
        1097.7781982421875,
        120.0
      ],
      [
        -342.1239318847656,
        1097.7781982421875,
        120.0
      ],
      [
        -445.0,
        1100.0,
        120.0
      ],
      [
        -471.0050354003906,
        1100.0,
        120.0
      ],
      [
        -435.4183654785156,
        1156.04345703125,
        120.0
      ],
      [
        -490.0,
        1160.0,
        120.0
      ],
      [
        -497.0710754394531,
        1162.928955078125,
        120.0
      ],
      [
        -497.0710754394531,
        1162.928955078125,
        120.0
      ],
      [
        -490.0,
        1160.0,
        120.0
      ],
      [
        -482.9289245605469,
        1162.928955078125,
        120.0
      ],
      [
        -490.0,
        1160.0,
        120.0
      ],
      [
        -480.0,
        1170.0,
        120.0
      ],
      [
        -482.9289245605469,
        1162.928955078125,
        120.0
      ],
      [
        -482.9289245605469,
        1177.071044921875,
        120.0
      ],
      [
        -480.0,
        1170.0,
        120.0
      ],
      [
        -435.4183654785156,
        1156.04345703125,
        95.0
      ],
      [
        -435.4183654785156,
        1156.04345703125,
        95.0
      ],
      [
        -394.5001220703125,
        1097.7781982421875,
        95.0
      ],
      [
        -336.5,
        1097.7781982421875,
        78.049072265625
      ],
      [
        -336.5,
        1098.9329833984375,
        78.5
      ],
      [
        -336.0618896484375,
        1098.6800537109375,
        78.5
      ],
      [
        -335.5,
        1098.3555908203125,
        78.33779907226562
      ],
      [
        -335.5,
        1097.7781982421875,
        78.04907989501953
      ],
      [
        -336.5,
        1097.7781982421875,
        78.049072265625
      ],
      [
        -335.5,
        1097.7781982421875,
        78.04907989501953
      ],
      [
        -335.5,
        1098.3555908203125,
        78.33779907226562
      ],
      [
        -336.0618896484375,
        1098.6800537109375,
        78.5
      ],
      [
        -336.5,
        1098.9329833984375,
        78.5
      ],
      [
        -394.5001220703125,
        1097.7781982421875,
        95.0
      ],
      [
        -394.5001220703125,
        1097.7781982421875,
        120.0
      ],
      [
        -450.54339599609375,
        1130.134765625,
        120.0
      ],
      [
        -450.54339599609375,
        1130.134765625,
        95.0
      ],
      [
        -430.0,
        1118.2740478515625,
        105.0
      ],
      [
        -435.0,
        1121.160888671875,
        105.0
      ],
      [
        -435.0,
        1121.160888671875,
        105.0
      ],
      [
        -435.0,
        1121.160888671875,
        95.0
      ],
      [
        -430.0,
        1118.2740478515625,
        95.0
      ],
      [
        -430.0,
        1118.2740478515625,
        105.0
      ],
      [
        -430.0,
        1118.291748046875,
        105.0
      ],
      [
        -332.71826171875,
        1096.74951171875,
        75.0
      ],
      [
        -324.4999694824219,
        1092.0047607421875,
        75.0
      ],
      [
        -324.5,
        1092.0047607421875,
        75.0
      ],
      [
        -355.21795654296875,
        1075.0986328125,
        70.0
      ],
      [
        -332.7183532714844,
        1096.7496337890625,
        75.0
      ],
      [
        -332.7183532714844,
        1096.7496337890625,
        70.0
      ],
      [
        -355.21795654296875,
        1075.0986328125,
        70.0
      ],
      [
        -354.81549072265625,
        1074.5020751953125,
        70.0
      ],
      [
        -332.7183532714844,
        1096.7496337890625,
        60.0
      ],
      [
        -324.5,
        1092.0047607421875,
        120.0
      ],
      [
        -394.65386962890625,
        1410.0,
        60.0
      ],
      [
        -400.42303466796875,
        1420.0,
        120.0
      ],
      [
        -340.0,
        1239.0,
        80.0
      ],
      [
        -340.0,
        1239.0,
        60.0
      ],
      [
        -340.0,
        1239.0,
        60.0
      ],
      [
        -340.0,
        1239.0,
        65.0
      ],
      [
        -340.0,
        1239.0,
        80.0
      ],
      [
        -340.0,
        1239.0,
        125.0
      ],
      [
        -350.5,
        1239.0,
        80.0
      ],
      [
        -350.5,
        1239.0,
        60.0
      ],
      [
        -422.9655456542969,
        1239.0,
        60.02784729003906
      ],
      [
        -422.9404602050781,
        1239.0,
        60.00611877441406
      ],
      [
        -336.0,
        1239.0,
        65.0
      ],
      [
        -320.5,
        1240.0,
        65.0
      ],
      [
        -320.5,
        1239.0,
        65.0
      ],
      [
        -320.5,
        1270.0,
        65.0
      ],
      [
        -320.5,
        1265.0,
        65.0
      ],
      [
        -340.0,
        1239.0,
        65.0
      ],
      [
        -336.0,
        1239.0,
        65.0
      ],
      [
        -320.5,
        1240.0,
        65.0
      ],
      [
        -320.5,
        1265.0,
        65.0
      ],
      [
        -320.5,
        1240.0,
        85.0
      ],
      [
        -320.5,
        1240.0,
        65.0
      ],
      [
        -320.5,
        1240.0,
        80.0
      ],
      [
        -340.0,
        1239.0,
        80.0
      ],
      [
        -320.5,
        1239.0,
        80.0
      ],
      [
        -320.5,
        1101.0794677734375,
        75.0
      ],
      [
        -320.5,
        1101.0794677734375,
        72.0
      ],
      [
        -320.5,
        1101.0794677734375,
        60.0
      ],
      [
        -320.5,
        1101.0794677734375,
        64.0
      ],
      [
        -320.5,
        1101.0794677734375,
        95.0
      ],
      [
        -320.5,
        1101.0794677734375,
        120.0
      ],
      [
        -320.5,
        1096.7496337890625,
        75.0
      ],
      [
        -320.5,
        1094.3140869140625,
        75.0
      ],
      [
        -320.5,
        1101.0794677734375,
        75.0
      ],
      [
        -320.5,
        1094.3140869140625,
        75.0
      ],
      [
        -320.5,
        1096.7496337890625,
        75.0
      ],
      [
        -320.5,
        1096.7496337890625,
        72.0
      ],
      [
        -320.5,
        1096.7496337890625,
        60.0
      ],
      [
        -320.5,
        1096.7496337890625,
        64.0
      ],
      [
        -320.5,
        1101.0794677734375,
        64.0
      ],
      [
        -320.5,
        1096.7496337890625,
        64.0
      ],
      [
        -320.5,
        1101.0794677734375,
        72.0
      ],
      [
        -320.5,
        1096.7496337890625,
        72.0
      ],
      [
        -320.5,
        1094.3140869140625,
        120.0
      ],
      [
        -320.5,
        1101.0794677734375,
        120.0
      ],
      [
        -399.5,
        1158.39990234375,
        249.99998474121094
      ],
      [
        -434.5,
        1219.021728515625,
        250.0
      ],
      [
        -390.3024597167969,
        1142.4693603515625,
        95.0
      ],
      [
        -379.5000915527344,
        1123.759033203125,
        95.0
      ],
      [
        -399.43072509765625,
        1158.2799072265625,
        95.0
      ],
      [
        -390.3024597167969,
        1142.4693603515625,
        95.0
      ],
      [
        -399.43072509765625,
        1158.2799072265625,
        60.0
      ],
      [
        -399.43072509765625,
        1158.2799072265625,
        75.0
      ],
      [
        -399.43072509765625,
        1158.2799072265625,
        75.0
      ],
      [
        -399.43072509765625,
        1158.2799072265625,
        95.0
      ],
      [
        -320.5,
        1101.0794677734375,
        95.0
      ],
      [
        -320.5,
        1200.361328125,
        95.0
      ],
      [
        -399.5,
        1158.39990234375,
        95.0
      ],
      [
        -369.49993896484375,
        1210.4000244140625,
        95.0
      ],
      [
        -340.0,
        1210.4000244140625,
        95.0
      ],
      [
        -340.0,
        1239.0,
        95.0
      ],
      [
        -387.81402587890625,
        1178.6614990234375,
        95.0
      ],
      [
        -396.4754638671875,
        1183.659423828125,
        95.0
      ],
      [
        -387.9537353515625,
        1178.4134521484375,
        60.0
      ],
      [
        -387.84814453125,
        1178.2305908203125,
        60.0
      ],
      [
        -396.53240966796875,
        1163.272216796875,
        75.0
      ],
      [
        -396.53240966796875,
        1163.272216796875,
        75.0
      ],
      [
        -399.43072509765625,
        1158.2799072265625,
        80.00614929199219
      ],
      [
        -373.6650695800781,
        1147.25,
        63.2073974609375
      ],
      [
        -374.520751953125,
        1147.1468505859375,
        64.0
      ],
      [
        -373.8036804199219,
        1145.9049072265625,
        64.0
      ],
      [
        -374.520751953125,
        1147.1468505859375,
        64.0
      ],
      [
        -372.53173828125,
        1143.7017822265625,
        64.0
      ],
      [
        -373.8036804199219,
        1145.9049072265625,
        64.0
      ],
      [
        -373.6650695800781,
        1147.25,
        63.2073974609375
      ],
      [
        -369.06597900390625,
        1145.6988525390625,
        60.0
      ],
      [
        -366.796142578125,
        1141.7674560546875,
        60.0
      ],
      [
        -372.53173828125,
        1143.7017822265625,
        64.0
      ],
      [
        -355.11932373046875,
        1121.5426025390625,
        60.0
      ],
      [
        -356.9383850097656,
        1122.5928955078125,
        61.05021667480469
      ],
      [
        -356.9383850097656,
        1122.5928955078125,
        61.05021667480469
      ],
      [
        -356.6471862792969,
        1124.18896484375,
        60.0
      ],
      [
        -320.5,
        1200.361328125,
        75.0
      ],
      [
        -320.5,
        1200.361328125,
        95.0
      ],
      [
        -320.5,
        1210.4000244140625,
        80.0
      ],
      [
        -320.5,
        1210.4000244140625,
        75.0
      ],
      [
        -320.5,
        1210.4000244140625,
        80.0
      ],
      [
        -320.5,
        1210.4000244140625,
        75.0
      ],
      [
        -320.5,
        1200.361328125,
        75.0
      ],
      [
        -320.5,
        1235.0,
        60.0
      ],
      [
        -320.5,
        1235.0,
        65.0
      ],
      [
        -320.5,
        1235.0,
        65.0
      ],
      [
        -321.5,
        1125.5,
        60.99046325683594
      ],
      [
        -322.5,
        1125.5,
        60.99046325683594
      ],
      [
        -320.5,
        1101.080078125,
        75.0
      ],
      [
        -320.5,
        1122.0,
        60.0
      ],
      [
        -320.5,
        1118.0,
        60.0
      ],
      [
        -320.5,
        1101.080078125,
        72.0
      ],
      [
        -327.5,
        1125.5,
        60.99046325683594
      ],
      [
        -328.5,
        1125.5,
        60.99046325683594
      ],
      [
        -329.5,
        1122.0,
        60.0
      ],
      [
        -329.5,
        1101.080078125,
        75.0
      ],
      [
        -329.5,
        1101.080078125,
        72.0
      ],
      [
        -329.5,
        1118.0,
        60.0
      ],
      [
        -354.17950439453125,
        1121.0,
        60.71708679199219
      ],
      [
        -355.4501647949219,
        1121.733642578125,
        60.191009521484375
      ],
      [
        -353.9970397949219,
        1122.0001220703125,
        60.0
      ],
      [
        -354.17950439453125,
        1121.0,
        60.71708679199219
      ],
      [
        -335.5,
        1125.5,
        60.99046325683594
      ],
      [
        -336.5,
        1125.5,
        60.99046325683594
      ],
      [
        -336.5,
        1140.0,
        70.0
      ],
      [
        -335.5,
        1140.0,
        70.0
      ],
      [
        -335.5,
        1140.0,
        60.0
      ],
      [
        -336.5,
        1140.0,
        60.0
      ],
      [
        -336.5,
        1147.0,
        70.0
      ],
      [
        -335.5,
        1147.0,
        70.0
      ],
      [
        -335.5,
        1140.0,
        70.0
      ],
      [
        -336.5,
        1140.0,
        70.0
      ],
      [
        -373.6908264160156,
        1147.0,
        64.0
      ],
      [
        -374.43597412109375,
        1147.0,
        64.0
      ],
      [
        -373.6908264160156,
        1147.0,
        64.0
      ],
      [
        -372.9237976074219,
        1147.0,
        64.0
      ],
      [
        -372.923828125,
        1147.0,
        62.69045639038086
      ],
      [
        -372.9237976074219,
        1147.0,
        64.0
      ],
      [
        -362.3756103515625,
        1140.2108154296875,
        64.6800537109375
      ],
      [
        -362.1967468261719,
        1142.2021484375,
        64.99999237060547
      ],
      [
        -363.267578125,
        1141.0135498046875,
        64.67999267578125
      ],
      [
        -362.97027587890625,
        1140.7459716796875,
        64.68002319335938
      ],
      [
        -362.7027893066406,
        1141.0430908203125,
        64.7599868774414
      ],
      [
        -362.7027893066406,
        1141.0430908203125,
        64.7599868774414
      ],
      [
        -362.9999084472656,
        1141.3106689453125,
        64.7599868774414
      ],
      [
        -362.7321472167969,
        1141.60791015625,
        63.999996185302734
      ],
      [
        -362.6730041503906,
        1140.4783935546875,
        63.999996185302734
      ],
      [
        -362.90350341796875,
        1140.8201904296875,
        64.69998168945312
      ],
      [
        -363.8622741699219,
        1141.5487060546875,
        64.6799545288086
      ],
      [
        -363.56494140625,
        1141.2811279296875,
        63.999996185302734
      ],
      [
        -320.5,
        1181.5,
        62.0
      ],
      [
        -320.5,
        1177.5,
        62.0
      ],
      [
        -320.5,
        1149.0,
        62.0
      ],
      [
        -320.5,
        1175.5,
        62.0
      ],
      [
        -340.0,
        1177.5,
        62.0
      ],
      [
        -320.5,
        1177.5,
        60.0
      ],
      [
        -320.5,
        1177.5,
        62.0
      ],
      [
        -320.5,
        1181.5,
        61.5
      ],
      [
        -320.5,
        1177.5,
        61.5
      ],
      [
        -320.5,
        1181.5,
        62.0
      ],
      [
        -320.5,
        1181.5,
        61.5
      ],
      [
        -320.5,
        1147.0,
        65.0
      ],
      [
        -320.5,
        1149.0,
        65.0
      ],
      [
        -320.5,
        1177.5,
        65.0
      ],
      [
        -320.5,
        1175.5,
        65.0
      ],
      [
        -338.0,
        1177.5,
        65.0
      ],
      [
        -338.0,
        1177.5,
        62.0
      ],
      [
        -320.5,
        1175.5,
        65.0
      ],
      [
        -320.5,
        1175.5,
        62.0
      ],
      [
        -320.5,
        1177.5,
        65.0
      ],
      [
        -320.5,
        1149.0,
        65.0
      ],
      [
        -320.5,
        1149.0,
        62.0
      ],
      [
        -367.7679443359375,
        1185.794189453125,
        62.0
      ],
      [
        -369.5,
        1182.794189453125,
        62.0
      ],
      [
        -360.5,
        1182.794189453125,
        62.0
      ],
      [
        -360.5,
        1182.794189453125,
        62.0
      ],
      [
        -356.0,
        1175.0,
        62.0
      ],
      [
        -357.035888671875,
        1182.794189453125,
        62.5
      ],
      [
        -367.7679443359375,
        1185.794189453125,
        62.5
      ],
      [
        -364.75,
        1175.0,
        65.0
      ],
      [
        -364.75,
        1175.0,
        90.75
      ],
      [
        -364.75,
        1175.0,
        90.75
      ],
      [
        -364.75,
        1175.0,
        65.0
      ],
      [
        -364.75,
        1187.7750244140625,
        82.40657806396484
      ],
      [
        -364.75,
        1175.0,
        77.33158111572266
      ],
      [
        -364.75,
        1175.0,
        77.33158111572266
      ],
      [
        -364.75,
        1187.7750244140625,
        82.40657806396484
      ],
      [
        -364.75,
        1175.0,
        83.4843978881836
      ],
      [
        -364.75,
        1185.219970703125,
        87.54440307617188
      ],
      [
        -364.75,
        1185.219970703125,
        87.54440307617188
      ],
      [
        -364.75,
        1175.0,
        83.4843978881836
      ],
      [
        -364.75,
        1175.0,
        88.43566131591797
      ],
      [
        -364.75,
        1183.176025390625,
        91.68366241455078
      ],
      [
        -364.75,
        1183.176025390625,
        91.68366241455078
      ],
      [
        -364.75,
        1175.0,
        88.43566131591797
      ],
      [
        -367.7679138183594,
        1164.205810546875,
        62.5
      ],
      [
        -360.5,
        1167.205810546875,
        62.5
      ],
      [
        -369.5,
        1167.205810546875,
        62.5
      ],
      [
        -356.0,
        1175.0,
        62.5
      ],
      [
        -360.5,
        1167.205810546875,
        62.5
      ],
      [
        -357.035888671875,
        1167.205810546875,
        62.0
      ],
      [
        -367.7679138183594,
        1164.205810546875,
        62.0
      ],
      [
        -364.75,
        1162.2249755859375,
        82.40657806396484
      ],
      [
        -364.75,
        1175.0,
        77.33158111572266
      ],
      [
        -364.75,
        1175.0,
        77.33158111572266
      ],
      [
        -364.75,
        1162.2249755859375,
        82.40657806396484
      ],
      [
        -364.75,
        1164.780029296875,
        87.54440307617188
      ],
      [
        -364.75,
        1175.0,
        83.4843978881836
      ],
      [
        -364.75,
        1175.0,
        83.4843978881836
      ],
      [
        -364.75,
        1164.780029296875,
        87.54440307617188
      ],
      [
        -364.75,
        1166.823974609375,
        91.68366241455078
      ],
      [
        -364.75,
        1175.0,
        88.43566131591797
      ],
      [
        -364.75,
        1175.0,
        88.43566131591797
      ],
      [
        -364.75,
        1166.823974609375,
        91.68366241455078
      ],
      [
        -299.5,
        1239.0,
        60.0
      ],
      [
        -299.5,
        1239.0,
        80.0
      ],
      [
        -299.5,
        1239.0,
        125.0
      ],
      [
        -299.5,
        1239.0,
        80.0
      ],
      [
        -320.5,
        1239.0,
        65.0
      ],
      [
        -314.0,
        1239.0,
        65.0
      ],
      [
        -315.0000305175781,
        1270.0,
        65.0
      ],
      [
        -313.3333435058594,
        1266.666748046875,
        65.0
      ],
      [
        -310.0,
        1260.0,
        65.0
      ],
      [
        -310.0,
        1239.0,
        65.0
      ],
      [
        -314.0,
        1239.0,
        65.0
      ],
      [
        -313.3333435058594,
        1266.666748046875,
        65.0
      ],
      [
        -310.0,
        1239.0,
        60.0
      ],
      [
        -310.0,
        1240.0,
        65.0
      ],
      [
        -310.0,
        1239.0,
        65.0
      ],
      [
        -310.0,
        1239.0,
        65.0
      ],
      [
        -310.0,
        1260.0,
        65.0
      ],
      [
        -310.0,
        1260.0,
        60.0
      ],
      [
        -310.0,
        1239.0,
        60.0
      ],
      [
        -310.0,
        1239.0,
        80.0
      ],
      [
        -320.5,
        1239.0,
        80.0
      ],
      [
        -310.0,
        1239.0,
        80.0
      ],
      [
        -313.88458251953125,
        1270.0,
        65.0
      ],
      [
        -312.4634094238281,
        1267.53662109375,
        65.0
      ],
      [
        -310.0,
        1263.2667236328125,
        65.0
      ],
      [
        -312.4634094238281,
        1267.53662109375,
        65.0
      ],
      [
        -310.0,
        1263.2667236328125,
        65.0
      ],
      [
        -310.0,
        1263.2667236328125,
        60.0
      ],
      [
        -239.5482177734375,
        1141.1502685546875,
        95.0
      ],
      [
        -239.50550842285156,
        1141.0762939453125,
        95.0
      ],
      [
        -295.0,
        1230.0,
        95.0
      ],
      [
        -295.0,
        1210.4000244140625,
        95.0
      ],
      [
        -299.5,
        1239.0,
        95.0
      ],
      [
        -295.0,
        1230.0,
        95.0
      ],
      [
        -279.5,
        1210.4000244140625,
        95.0
      ],
      [
        -295.0,
        1210.4000244140625,
        95.0
      ],
      [
        -239.5482177734375,
        1141.1502685546875,
        120.0
      ],
      [
        -239.5482177734375,
        1141.1502685546875,
        95.0
      ],
      [
        -239.50550842285156,
        1141.0762939453125,
        120.0
      ],
      [
        -239.5482177734375,
        1141.1502685546875,
        120.0
      ],
      [
        -261.042724609375,
        1178.4073486328125,
        60.00611877441406
      ],
      [
        -286.5345458984375,
        1210.4000244140625,
        80.0
      ],
      [
        -286.5345458984375,
        1210.4000244140625,
        60.0
      ],
      [
        -286.5345458984375,
        1210.4000244140625,
        95.0
      ],
      [
        -286.5345458984375,
        1210.4000244140625,
        80.0
      ],
      [
        -299.2926940917969,
        1230.0,
        60.0
      ],
      [
        -299.2926940917969,
        1230.0,
        80.0
      ],
      [
        -295.0,
        1223.4052734375,
        80.0
      ],
      [
        -295.0,
        1223.4052734375,
        95.0
      ],
      [
        -295.0,
        1223.4052734375,
        80.0
      ],
      [
        -299.2926940917969,
        1230.0,
        80.0
      ],
      [
        -312.0,
        1177.5,
        65.0
      ],
      [
        -312.0,
        1177.5,
        60.0
      ],
      [
        -312.0,
        1147.0,
        60.0
      ],
      [
        -310.0,
        1147.0,
        60.0
      ],
      [
        -310.0,
        1147.0,
        65.0
      ],
      [
        -312.0,
        1147.0,
        65.0
      ],
      [
        -310.0,
        1140.0,
        60.0
      ],
      [
        -312.0,
        1140.0,
        60.0
      ],
      [
        -312.0,
        1140.0,
        65.0
      ],
      [
        -310.0,
        1140.0,
        65.0
      ],
      [
        -312.0,
        1181.5,
        62.0
      ],
      [
        -312.0,
        1177.5,
        62.0
      ],
      [
        -312.0,
        1181.5,
        61.5
      ],
      [
        -312.0,
        1177.5,
        61.5
      ],
      [
        -312.0,
        1181.5,
        62.0
      ],
      [
        -312.0,
        1181.5,
        61.5
      ],
      [
        -320.5,
        1140.0,
        62.0
      ],
      [
        -312.0,
        1140.0,
        62.0
      ],
      [
        -320.5,
        1177.5,
        62.0
      ],
      [
        -312.0,
        1177.5,
        62.0
      ],
      [
        -320.5,
        1147.0,
        62.0
      ],
      [
        -312.0,
        1147.0,
        62.0
      ],
      [
        -314.5,
        1125.5,
        62.0
      ],
      [
        -314.5,
        1124.5,
        62.0
      ],
      [
        -314.5,
        1124.5,
        62.0
      ],
      [
        -314.5,
        1122.0,
        62.0
      ],
      [
        -314.5,
        1119.210693359375,
        62.0
      ],
      [
        -314.5,
        1122.0,
        62.0
      ],
      [
        -313.5,
        1125.5,
        62.0
      ],
      [
        -313.5,
        1124.5,
        62.0
      ],
      [
        -313.5,
        1124.5,
        62.0
      ],
      [
        -313.5,
        1122.0,
        62.0
      ],
      [
        -313.5,
        1122.0,
        62.0
      ],
      [
        -313.5,
        1119.210693359375,
        62.0
      ],
      [
        -313.5,
        1125.5,
        62.0
      ],
      [
        -314.5,
        1125.5,
        62.0
      ],
      [
        -320.5,
        1140.0,
        65.0
      ],
      [
        -320.5,
        1147.0,
        65.0
      ],
      [
        -314.5,
        1115.0267333984375,
        65.0
      ],
      [
        -314.5,
        1119.907958984375,
        65.0
      ],
      [
        -313.5,
        1119.907958984375,
        65.0
      ],
      [
        -313.5,
        1115.0267333984375,
        65.0
      ],
      [
        -314.5,
        1119.907958984375,
        65.0
      ],
      [
        -313.5,
        1119.907958984375,
        65.0
      ],
      [
        -310.0,
        1140.0,
        70.0
      ],
      [
        -310.0,
        1147.0,
        70.0
      ],
      [
        -310.0,
        1147.0,
        70.0
      ],
      [
        -310.0,
        1140.0,
        70.0
      ],
      [
        -310.0,
        1147.0,
        62.0
      ],
      [
        -310.0,
        1147.0,
        61.5
      ],
      [
        -306.0,
        1147.0,
        61.5
      ],
      [
        -306.0,
        1147.0,
        62.0
      ],
      [
        -310.0,
        1140.0,
        61.5
      ],
      [
        -310.0,
        1140.0,
        62.0
      ],
      [
        -306.0,
        1140.0,
        62.0
      ],
      [
        -306.0,
        1140.0,
        61.5
      ],
      [
        -287.7679443359375,
        1185.794189453125,
        62.5
      ],
      [
        -289.5,
        1182.794189453125,
        62.5
      ],
      [
        -280.5,
        1182.794189453125,
        62.5
      ],
      [
        -280.5,
        1182.794189453125,
        62.5
      ],
      [
        -276.0,
        1175.0,
        62.5
      ],
      [
        -277.035888671875,
        1182.794189453125,
        62.0
      ],
      [
        -287.7679443359375,
        1185.794189453125,
        62.0
      ],
      [
        -285.25,
        1175.0,
        65.0
      ],
      [
        -285.25,
        1175.0,
        88.75
      ],
      [
        -285.25,
        1175.0,
        88.75
      ],
      [
        -285.25,
        1175.0,
        65.0
      ],
      [
        -285.25,
        1187.7750244140625,
        79.90657806396484
      ],
      [
        -285.25,
        1175.0,
        74.83158111572266
      ],
      [
        -285.25,
        1175.0,
        74.83158111572266
      ],
      [
        -285.25,
        1187.7750244140625,
        79.90657806396484
      ],
      [
        -285.25,
        1185.219970703125,
        85.04440307617188
      ],
      [
        -285.25,
        1175.0,
        80.9843978881836
      ],
      [
        -285.25,
        1175.0,
        80.9843978881836
      ],
      [
        -285.25,
        1185.219970703125,
        85.04440307617188
      ],
      [
        -285.25,
        1183.176025390625,
        89.18366241455078
      ],
      [
        -285.25,
        1175.0,
        85.93566131591797
      ],
      [
        -285.25,
        1175.0,
        85.93566131591797
      ],
      [
        -285.25,
        1183.176025390625,
        89.18366241455078
      ],
      [
        -285.25,
        1175.0,
        85.93565368652344
      ],
      [
        -285.25,
        1172.5,
        86.92877197265625
      ],
      [
        -285.25,
        1172.5,
        86.92877197265625
      ],
      [
        -285.25,
        1175.0,
        85.93565368652344
      ],
      [
        -285.25,
        1175.0,
        80.98442077636719
      ],
      [
        -285.25,
        1172.5,
        81.97756958007812
      ],
      [
        -285.25,
        1172.5,
        81.97756958007812
      ],
      [
        -285.25,
        1175.0,
        80.98442077636719
      ],
      [
        -285.25,
        1175.0,
        74.83157348632812
      ],
      [
        -285.25,
        1172.5,
        75.82475280761719
      ],
      [
        -285.25,
        1172.5,
        75.82475280761719
      ],
      [
        -285.25,
        1175.0,
        74.83157348632812
      ],
      [
        -287.7679138183594,
        1164.205810546875,
        62.5
      ],
      [
        -280.5,
        1167.205810546875,
        62.5
      ],
      [
        -289.5,
        1167.205810546875,
        62.5
      ],
      [
        -276.0,
        1175.0,
        62.5
      ],
      [
        -280.5,
        1167.205810546875,
        62.5
      ],
      [
        -277.035888671875,
        1167.205810546875,
        62.0
      ],
      [
        -287.7679138183594,
        1164.205810546875,
        62.0
      ],
      [
        -285.8616943359375,
        1141.756591796875,
        64.6800537109375
      ],
      [
        -287.81683349609375,
        1142.1766357421875,
        64.99999237060547
      ],
      [
        -286.76715087890625,
        1140.9691162109375,
        64.68000793457031
      ],
      [
        -286.4653015136719,
        1141.2315673828125,
        64.67999267578125
      ],
      [
        -286.7277526855469,
        1141.5333251953125,
        64.75997924804688
      ],
      [
        -286.7277526855469,
        1141.5333251953125,
        64.75997924804688
      ],
      [
        -287.029541015625,
        1141.27099609375,
        64.75999450683594
      ],
      [
        -287.2919616699219,
        1141.5728759765625,
        63.999996185302734
      ],
      [
        -286.1634826660156,
        1141.4940185546875,
        63.999996185302734
      ],
      [
        -286.5308837890625,
        1141.3070068359375,
        64.69998168945312
      ],
      [
        -287.3708190917969,
        1140.444091796875,
        64.67997741699219
      ],
      [
        -287.0689697265625,
        1140.70654296875,
        63.999996185302734
      ],
      [
        -226.05955505371094,
        1239.0,
        60.00611877441406
      ],
      [
        -226.0344696044922,
        1239.0,
        60.02783966064453
      ],
      [
        -214.5,
        1219.021728515625,
        249.99998474121094
      ],
      [
        -249.5,
        1158.4000244140625,
        250.0
      ],
      [
        120.0,
        1490.0,
        60.0
      ],
      [
        120.0,
        1490.0,
        214.0
      ],
      [
        210.0,
        1240.0,
        250.0
      ],
      [
        210.0,
        980.0,
        250.0
      ],
      [
        1030.0,
        1460.0,
        250.00001525878906
      ],
      [
        1030.0,
        1550.0,
        250.00003051757812
      ],
      [
        1050.0,
        1475.0,
        250.00001525878906
      ],
      [
        1050.0,
        1525.0,
        250.00003051757812
      ],
      [
        1070.0,
        1540.0,
        250.0
      ],
      [
        1070.0,
        1525.0,
        250.00001525878906
      ],
      [
        230.0,
        1460.0,
        250.0
      ],
      [
        260.0,
        1460.0,
        250.0
      ],
      [
        260.0,
        1460.0,
        250.0
      ],
      [
        431.0,
        1460.0,
        250.0
      ],
      [
        246.7465057373047,
        1584.1903076171875,
        250.0
      ],
      [
        230.1444549560547,
        1502.9405517578125,
        250.0
      ],
      [
        230.1444549560547,
        1502.9405517578125,
        250.0
      ],
      [
        230.0,
        1460.0,
        250.0
      ],
      [
        582.7122802734375,
        1384.3714599609375,
        250.00003051757812
      ],
      [
        530.4696044921875,
        1346.4150390625,
        250.0
      ],
      [
        518.6376342773438,
        1310.0,
        160.0
      ],
      [
        530.4696044921875,
        1346.4150390625,
        250.00003051757812
      ],
      [
        518.6376342773438,
        1310.0,
        250.00001525878906
      ],
      [
        300.0,
        1380.0096435546875,
        250.0
      ],
      [
        300.0,
        1380.0096435546875,
        240.0
      ],
      [
        510.5146179199219,
        1285.0,
        250.00003051757812
      ],
      [
        530.4696044921875,
        1223.5849609375,
        250.0
      ],
      [
        510.5146179199219,
        1285.0,
        250.0
      ],
      [
        2769.303955078125,
        7185.4150390625,
        710.5693969726562
      ],
      [
        3020.6171875,
        6729.98193359375,
        570.58251953125
      ],
      [
        569.0435180664062,
        6174.07177734375,
        250.00003051757812
      ],
      [
        200.0,
        7450.0,
        660.3674926757812
      ],
      [
        0.0,
        7410.2177734375,
        250.00003051757812
      ],
      [
        0.0,
        7410.2177734375,
        636.0927734375
      ],
      [
        200.0,
        7450.0,
        680.7955322265625
      ],
      [
        0.0,
        7410.2177734375,
        666.3270263671875
      ],
      [
        0.0,
        7410.2177734375,
        976.300048828125
      ],
      [
        -2700.0,
        6873.154296875,
        976.300048828125
      ],
      [
        -2282.540771484375,
        6956.19140625,
        297.51312255859375
      ],
      [
        -2360.728759765625,
        6940.63916015625,
        250.0
      ],
      [
        1975.4892578125,
        1830.0,
        1060.0
      ],
      [
        1975.800048828125,
        1830.0,
        1059.6484375
      ],
      [
        1968.06494140625,
        1837.4248046875,
        1060.0
      ],
      [
        1975.4896240234375,
        1830.0,
        1060.0
      ],
      [
        1917.370849609375,
        1888.1185302734375,
        1060.0
      ],
      [
        1865.3892822265625,
        1940.0999755859375,
        1060.0
      ],
      [
        1968.0648193359375,
        1837.4248046875,
        1060.0
      ],
      [
        1917.370849609375,
        1888.1185302734375,
        1060.0
      ],
      [
        1913.6177978515625,
        1830.0,
        1130.0
      ],
      [
        1961.243408203125,
        1830.0,
        1130.0
      ],
      [
        1892.56787109375,
        1851.050048828125,
        1130.0
      ],
      [
        1973.3603515625,
        1830.0,
        1130.0
      ],
      [
        1961.243408203125,
        1830.0,
        1130.0
      ],
      [
        1956.5875244140625,
        1830.0,
        1060.0
      ],
      [
        1723.412353515625,
        1830.0,
        1060.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1060.0
      ],
      [
        1956.5875244140625,
        1830.0,
        1060.0
      ],
      [
        1723.412353515625,
        1830.0,
        1060.0
      ],
      [
        1787.0577392578125,
        1830.0,
        1060.0
      ],
      [
        1913.2431640625,
        1830.3746337890625,
        1130.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1060.0
      ],
      [
        1892.9427490234375,
        1830.0,
        1106.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1130.0
      ],
      [
        1926.6507568359375,
        1772.5001220703125,
        1110.0
      ],
      [
        1921.2918701171875,
        1792.5001220703125,
        1110.0
      ],
      [
        -3714.042724609375,
        -2323.521484375,
        1179.1292724609375
      ],
      [
        -5545.388671875,
        4741.15380859375,
        334.1224365234375
      ],
      [
        -2707.393310546875,
        1337.393310546875,
        303.50665283203125
      ],
      [
        -2707.33984375,
        1342.6600341796875,
        302.7590026855469
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -0.004390379413962364,
        -0.9486730098724365,
        0.31622809171676636
      ],
      "plane_d": 4789.4853515625,
      "bbox_min": [
        0.0,
        4934.54296875,
        -300.0
      ],
      "bbox_max": [
        4275.4052734375,
        7450.0,
        250.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01264164224267006,
        -0.2850233018398285,
        0.9584372639656067
      ],
      "plane_d": 1473.4520263671875,
      "bbox_min": [
        0.0,
        5034.5224609375,
        -300.0
      ],
      "bbox_max": [
        4145.146484375,
        7450.0,
        250.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7881146669387817,
        0.06996545940637589,
        0.6115390658378601
      ],
      "plane_d": -136.38499450683594,
      "bbox_min": [
        0.0,
        5047.4609375,
        -300.0
      ],
      "bbox_max": [
        664.39111328125,
        7450.0,
        250.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05985559523105621,
        -0.9467930197715759,
        0.3162282705307007
      ],
      "plane_d": 6873.22802734375,
      "bbox_min": [
        231.02947998046875,
        7173.888671875,
        -300.0
      ],
      "bbox_max": [
        427.0267028808594,
        7267.0830078125,
        -58.07279968261719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05985559523105621,
        -0.9467930197715759,
        0.3162282705307007
      ],
      "plane_d": 6873.22802734375,
      "bbox_min": [
        0.0,
        7159.283203125,
        -300.0
      ],
      "bbox_max": [
        448.3017578125,
        7450.0,
        250.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        0.0,
        7410.2177734375,
        -22.699951171875
      ],
      "bbox_max": [
        200.0,
        7450.0,
        250.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05136118829250336,
        -0.319204717874527,
        0.9462930560112
      ],
      "plane_d": 1763.4462890625,
      "bbox_min": [
        2191.17431640625,
        5034.5224609375,
        0.0
      ],
      "bbox_max": [
        4145.146484375,
        5913.06494140625,
        250.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        3639.71728515625,
        5039.92822265625,
        28.535202026367188
      ],
      "bbox_max": [
        3956.20703125,
        5723.3046875,
        250.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        3680.427490234375,
        5048.34375,
        54.11042022705078
      ],
      "bbox_max": [
        4145.146484375,
        5673.4384765625,
        250.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5238755941390991,
        -0.5008544921875,
        0.6889841556549072
      ],
      "plane_d": 4560.046875,
      "bbox_min": [
        4047.874755859375,
        5080.82177734375,
        152.8163604736328
      ],
      "bbox_max": [
        4145.146484375,
        5162.82421875,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5238755941390991,
        -0.5008544921875,
        0.6889841556549072
      ],
      "plane_d": 4560.046875,
      "bbox_min": [
        3932.455322265625,
        4951.876953125,
        0.0
      ],
      "bbox_max": [
        4275.4052734375,
        5112.7666015625,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        3932.455322265625,
        4951.876953125,
        0.0
      ],
      "bbox_max": [
        4047.874755859375,
        5080.82177734375,
        152.81637573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3932375907897949,
        -0.4582340121269226,
        0.797110915184021
      ],
      "plane_d": 2052.83154296875,
      "bbox_min": [
        -2700.0,
        3851.8251953125,
        -300.0
      ],
      "bbox_max": [
        3.814697265625e-06,
        7410.2177734375,
        250.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -2700.0,
        4169.818359375,
        -300.0
      ],
      "bbox_max": [
        3.814697265625e-06,
        7410.2177734375,
        250.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05985559523105621,
        -0.9467930197715759,
        0.3162282705307007
      ],
      "plane_d": 6873.22802734375,
      "bbox_min": [
        -150.0,
        7155.99462890625,
        -300.0
      ],
      "bbox_max": [
        3.814697265625e-06,
        7259.48291015625,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9319281578063965,
        -0.1775101125240326,
        0.31622785329818726
      ],
      "plane_d": 1065.0606689453125,
      "bbox_min": [
        -2700.0,
        3851.8251953125,
        -300.0
      ],
      "bbox_max": [
        -246.8081817626953,
        6940.63916015625,
        249.9999542236328
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -2700.0,
        3851.8251953125,
        -113.45060729980469
      ],
      "bbox_max": [
        -366.4575500488281,
        6940.63916015625,
        249.9999542236328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40394648909568787,
        -0.8583862781524658,
        0.31622806191444397
      ],
      "plane_d": 3509.28515625,
      "bbox_min": [
        -619.7982788085938,
        3851.8251953125,
        -113.45060729980469
      ],
      "bbox_max": [
        -366.4575500488281,
        3934.389892578125,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.40394654870033264,
        -0.8583863973617554,
        0.31622761487960815
      ],
      "plane_d": 3509.285400390625,
      "bbox_min": [
        -1263.684326171875,
        3402.360107421875,
        -300.0
      ],
      "bbox_max": [
        -302.08367919921875,
        3879.621826171875,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9319282174110413,
        -0.1775101274251938,
        0.31622785329818726
      ],
      "plane_d": 1065.060791015625,
      "bbox_min": [
        -366.4575500488281,
        3831.220458984375,
        -300.0
      ],
      "bbox_max": [
        -302.08367919921875,
        3879.621826171875,
        -113.45060729980469
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1850.0,
      "bbox_min": [
        -1850.0,
        1019.800048828125,
        0.0
      ],
      "bbox_max": [
        -300.0,
        1750.0,
        60.000003814697266
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.3826804459095001,
        -0.9238807559013367
      ],
      "plane_d": 484.75946044921875,
      "bbox_min": [
        -370.0,
        1019.800048828125,
        28.0
      ],
      "bbox_max": [
        -300.0,
        1147.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9238823056221008,
        -0.38267678022384644
      ],
      "plane_d": 1069.25732421875,
      "bbox_min": [
        -370.0,
        1121.8931884765625,
        52.500030517578125
      ],
      "bbox_max": [
        -300.0,
        1140.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 370.0,
      "bbox_min": [
        -370.0,
        1121.8931884765625,
        54.696746826171875
      ],
      "bbox_max": [
        -300.0,
        1134.6966552734375,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -370.0,
        1121.8931884765625,
        54.696746826171875
      ],
      "bbox_max": [
        -300.0,
        1134.6966552734375,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1125.0,
      "bbox_min": [
        -370.0,
        1121.8931884765625,
        56.91957473754883
      ],
      "bbox_max": [
        -305.0,
        1129.330078125,
        60.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8660229444503784,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 865.61279296875,
      "bbox_min": [
        -370.0,
        1121.8931884765625,
        58.71314239501953
      ],
      "bbox_max": [
        -305.0,
        1125.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660229444503784,
        -0.500004231929779,
        -0.0
      ],
      "plane_d": 250.7364959716797,
      "bbox_min": [
        -370.0,
        1121.8931884765625,
        58.71314239501953
      ],
      "bbox_max": [
        -358.206298828125,
        1125.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -370.0,
        1121.893310546875,
        59.54158020019531
      ],
      "bbox_max": [
        -369.0,
        1123.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1123.0,
      "bbox_min": [
        -370.0,
        1123.0,
        59.54158020019531
      ],
      "bbox_max": [
        -369.0,
        1123.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 59.0,
      "bbox_min": [
        -345.0,
        1121.8931884765625,
        59.0
      ],
      "bbox_max": [
        -305.0,
        1125.0,
        60.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 320.0,
      "bbox_min": [
        -345.0,
        1121.8931884765625,
        59.0
      ],
      "bbox_max": [
        -305.0,
        1125.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 335.0,
      "bbox_min": [
        -345.0,
        1121.8931884765625,
        59.0
      ],
      "bbox_max": [
        -330.0,
        1125.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -345.0,
      "bbox_min": [
        -345.0,
        1121.8931884765625,
        59.0
      ],
      "bbox_max": [
        -345.0,
        1125.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -330.0,
      "bbox_min": [
        -330.0,
        1121.8931884765625,
        59.0
      ],
      "bbox_max": [
        -330.0,
        1125.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 305.0,
      "bbox_min": [
        -315.0,
        1121.8931884765625,
        59.0
      ],
      "bbox_max": [
        -305.0,
        1125.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -315.0,
      "bbox_min": [
        -315.0,
        1121.8931884765625,
        59.0
      ],
      "bbox_max": [
        -315.0,
        1125.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1129.330078125,
      "bbox_min": [
        -360.0,
        1125.0,
        56.91957473754883
      ],
      "bbox_max": [
        -350.0,
        1129.330078125,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660229444503784,
        0.500004231929779,
        0.0
      ],
      "plane_d": -874.2730102539062,
      "bbox_min": [
        -360.0,
        1125.0,
        56.91957473754883
      ],
      "bbox_max": [
        -350.0,
        1129.330078125,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660229444503784,
        0.500004231929779,
        0.0
      ],
      "plane_d": -259.396728515625,
      "bbox_min": [
        -352.5,
        1125.0,
        56.919578552246094
      ],
      "bbox_max": [
        -350.0,
        1129.330078125,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": -509.73406982421875,
      "bbox_min": [
        -370.0,
        1019.800048828125,
        28.0
      ],
      "bbox_max": [
        -300.0,
        1147.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        -370.0,
        1019.800048828125,
        28.0
      ],
      "bbox_max": [
        -300.0,
        1147.0,
        60.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1147.0,
      "bbox_min": [
        -329.5,
        1140.0,
        28.0
      ],
      "bbox_max": [
        -320.5,
        1147.0,
        35.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -28.0,
      "bbox_min": [
        -329.5,
        1140.0,
        28.0
      ],
      "bbox_max": [
        -320.5,
        1147.0,
        35.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -320.5,
      "bbox_min": [
        -320.5,
        1140.0,
        28.0
      ],
      "bbox_max": [
        -320.5,
        1147.0,
        35.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -370.0,
        1019.800048828125,
        28.0
      ],
      "bbox_max": [
        -300.0,
        1140.0,
        60.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -35.0,
      "bbox_min": [
        -370.0,
        1019.800048828125,
        28.0
      ],
      "bbox_max": [
        -300.0,
        1140.0,
        60.0
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -28.0,
      "bbox_min": [
        -340.0,
        1103.0,
        28.0
      ],
      "bbox_max": [
        -310.0,
        1140.0,
        35.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.3826861083507538,
        0.9238784313201904,
        0.0
      ],
      "plane_d": -894.6649169921875,
      "bbox_min": [
        -340.0,
        1103.0,
        28.0
      ],
      "bbox_max": [
        -310.0,
        1140.0,
        35.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826861083507538,
        0.9238784313201904,
        0.0
      ],
      "plane_d": -1143.410888671875,
      "bbox_min": [
        -340.0,
        1103.0,
        28.0
      ],
      "bbox_max": [
        -310.0,
        1140.0,
        35.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238789677619934,
        -0.38268476724624634,
        -0.0
      ],
      "plane_d": 141.4390869140625,
      "bbox_min": [
        -340.0,
        1107.3934326171875,
        28.0
      ],
      "bbox_max": [
        -310.0,
        1140.0,
        35.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238789677619934,
        -0.38268476724624634,
        0.0
      ],
      "plane_d": 741.96044921875,
      "bbox_min": [
        -340.0,
        1107.3934326171875,
        28.0
      ],
      "bbox_max": [
        -310.0,
        1140.0,
        35.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238789677619934,
        0.38268476724624634,
        0.0
      ],
      "plane_d": -113.72271728515625,
      "bbox_min": [
        -340.0,
        1107.3934326171875,
        28.0
      ],
      "bbox_max": [
        -310.0,
        1140.0,
        35.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238789677619934,
        0.38268476724624634,
        0.0
      ],
      "plane_d": -714.2440795898438,
      "bbox_min": [
        -335.6065979003906,
        1107.3934326171875,
        28.0
      ],
      "bbox_max": [
        -310.0,
        1140.0,
        35.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.382688045501709,
        -0.9238775968551636,
        0.0
      ],
      "plane_d": 922.3796997070312,
      "bbox_min": [
        -335.6065979003906,
        1128.6065673828125,
        28.0
      ],
      "bbox_max": [
        -314.3934020996094,
        1140.0,
        35.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9703943133354187,
        0.24152612686157227,
        0.0
      ],
      "plane_d": -586.3511352539062,
      "bbox_min": [
        -322.5,
        1131.9644775390625,
        28.0
      ],
      "bbox_max": [
        -320.5,
        1140.0,
        35.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826894760131836,
        -0.9238770604133606,
        0.0
      ],
      "plane_d": 1171.1268310546875,
      "bbox_min": [
        -335.6065979003906,
        1128.6065673828125,
        28.0
      ],
      "bbox_max": [
        -327.5,
        1131.9644775390625,
        35.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 370.0,
      "bbox_min": [
        -370.0,
        1019.800048828125,
        35.0
      ],
      "bbox_max": [
        -300.0,
        1140.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        -370.0,
        1019.800048828125,
        35.0
      ],
      "bbox_max": [
        -300.0,
        1135.164794921875,
        60.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1079.0,
      "bbox_min": [
        -346.0,
        1074.0,
        35.0
      ],
      "bbox_max": [
        -314.0,
        1084.0,
        50.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1074.0,
      "bbox_min": [
        -346.0,
        1074.0,
        35.0
      ],
      "bbox_max": [
        -314.0,
        1079.0,
        50.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.923880398273468,
        0.0,
        -0.38268133997917175
      ],
      "plane_d": 320.2206115722656,
      "bbox_min": [
        -346.0,
        1074.0,
        35.0
      ],
      "bbox_max": [
        -314.0,
        1079.0,
        50.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268232345581055,
        -0.0,
        -0.9238799810409546
      ],
      "plane_d": -83.34396362304688,
      "bbox_min": [
        -346.0,
        1074.0,
        35.0
      ],
      "bbox_max": [
        -331.0,
        1079.0,
        50.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268232345581055,
        0.0,
        -0.9238799810409546
      ],
      "plane_d": 175.73196411132812,
      "bbox_min": [
        -346.0,
        1074.0,
        35.0
      ],
      "bbox_max": [
        -331.0,
        1079.0,
        50.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268232345581055,
        0.0,
        0.9238799810409546
      ],
      "plane_d": 97.20216369628906,
      "bbox_min": [
        -346.0,
        1074.0,
        35.0
      ],
      "bbox_max": [
        -331.0,
        1079.0,
        47.80330276489258
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268232345581055,
        0.0,
        0.9238799810409546
      ],
      "plane_d": -161.87376403808594,
      "bbox_min": [
        -346.0,
        1074.0,
        35.0
      ],
      "bbox_max": [
        -331.0,
        1079.0,
        47.80330276489258
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923880398273468,
        -0.0,
        -0.38268133997917175
      ],
      "plane_d": -289.54046630859375,
      "bbox_min": [
        -346.0,
        1074.0,
        37.19669723510742
      ],
      "bbox_max": [
        -331.0,
        1079.0,
        47.80330276489258
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923880398273468,
        0.0,
        -0.38268133997917175
      ],
      "plane_d": 335.92657470703125,
      "bbox_min": [
        -346.0,
        1074.0,
        37.19669723510742
      ],
      "bbox_max": [
        -331.0,
        1079.0,
        47.80330276489258
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923880398273468,
        0.0,
        0.38268133997917175
      ],
      "plane_d": 303.3986511230469,
      "bbox_min": [
        -346.0,
        1074.0,
        37.19669723510742
      ],
      "bbox_max": [
        -331.0,
        1079.0,
        42.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923880398273468,
        0.0,
        0.38268133997917175
      ],
      "plane_d": -322.068359375,
      "bbox_min": [
        -333.1966857910156,
        1074.0,
        37.19669723510742
      ],
      "bbox_max": [
        -331.0,
        1079.0,
        42.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268232345581055,
        -0.0,
        -0.9238799810409546
      ],
      "plane_d": -76.83837127685547,
      "bbox_min": [
        -329.0,
        1074.0,
        35.0
      ],
      "bbox_max": [
        -314.0,
        1079.0,
        50.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268232345581055,
        0.0,
        -0.9238799810409546
      ],
      "plane_d": 169.2263641357422,
      "bbox_min": [
        -329.0,
        1074.0,
        35.0
      ],
      "bbox_max": [
        -314.0,
        1079.0,
        50.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268232345581055,
        0.0,
        0.9238799810409546
      ],
      "plane_d": 90.69657135009766,
      "bbox_min": [
        -329.0,
        1074.0,
        35.0
      ],
      "bbox_max": [
        -314.0,
        1079.0,
        47.80330276489258
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268232345581055,
        0.0,
        0.9238799810409546
      ],
      "plane_d": -155.3681640625,
      "bbox_min": [
        -329.0,
        1074.0,
        35.0
      ],
      "bbox_max": [
        -314.0,
        1079.0,
        47.80330276489258
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923880398273468,
        -0.0,
        -0.38268133997917175
      ],
      "plane_d": -273.8345031738281,
      "bbox_min": [
        -329.0,
        1074.0,
        37.19669723510742
      ],
      "bbox_max": [
        -314.0,
        1079.0,
        47.80330276489258
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923880398273468,
        0.0,
        0.38268133997917175
      ],
      "plane_d": 287.69268798828125,
      "bbox_min": [
        -329.0,
        1074.0,
        37.19669723510742
      ],
      "bbox_max": [
        -314.0,
        1079.0,
        42.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923880398273468,
        0.0,
        0.38268133997917175
      ],
      "plane_d": -306.3623962402344,
      "bbox_min": [
        -316.1966857910156,
        1074.0,
        37.19669723510742
      ],
      "bbox_max": [
        -314.0,
        1079.0,
        42.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923880398273468,
        0.0,
        -0.38268133997917175
      ],
      "plane_d": 320.2206115722656,
      "bbox_min": [
        -346.0,
        1079.0,
        35.0
      ],
      "bbox_max": [
        -314.0,
        1084.0,
        50.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268232345581055,
        -0.0,
        -0.9238799810409546
      ],
      "plane_d": -83.34396362304688,
      "bbox_min": [
        -346.0,
        1079.0,
        35.0
      ],
      "bbox_max": [
        -331.0,
        1084.0,
        50.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268232345581055,
        0.0,
        -0.9238799810409546
      ],
      "plane_d": 175.73196411132812,
      "bbox_min": [
        -346.0,
        1079.0,
        35.0
      ],
      "bbox_max": [
        -331.0,
        1084.0,
        50.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268232345581055,
        0.0,
        0.9238799810409546
      ],
      "plane_d": 97.20216369628906,
      "bbox_min": [
        -346.0,
        1079.0,
        35.0
      ],
      "bbox_max": [
        -331.0,
        1084.0,
        47.80330276489258
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268232345581055,
        0.0,
        0.9238799810409546
      ],
      "plane_d": -161.87376403808594,
      "bbox_min": [
        -346.0,
        1079.0,
        35.0
      ],
      "bbox_max": [
        -331.0,
        1084.0,
        47.80330276489258
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923880398273468,
        -0.0,
        -0.38268133997917175
      ],
      "plane_d": -289.54046630859375,
      "bbox_min": [
        -346.0,
        1079.0,
        37.19669723510742
      ],
      "bbox_max": [
        -331.0,
        1084.0,
        47.80330276489258
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923880398273468,
        0.0,
        -0.38268133997917175
      ],
      "plane_d": 335.92657470703125,
      "bbox_min": [
        -346.0,
        1079.0,
        37.19669723510742
      ],
      "bbox_max": [
        -331.0,
        1084.0,
        47.80330276489258
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923880398273468,
        0.0,
        0.38268133997917175
      ],
      "plane_d": 303.3986511230469,
      "bbox_min": [
        -346.0,
        1079.0,
        37.19669723510742
      ],
      "bbox_max": [
        -331.0,
        1084.0,
        42.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923880398273468,
        0.0,
        0.38268133997917175
      ],
      "plane_d": -322.068359375,
      "bbox_min": [
        -333.1966857910156,
        1079.0,
        37.19669723510742
      ],
      "bbox_max": [
        -331.0,
        1084.0,
        42.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268232345581055,
        -0.0,
        -0.9238799810409546
      ],
      "plane_d": -76.83837127685547,
      "bbox_min": [
        -329.0,
        1079.0,
        35.0
      ],
      "bbox_max": [
        -314.0,
        1084.0,
        50.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268232345581055,
        0.0,
        -0.9238799810409546
      ],
      "plane_d": 169.2263641357422,
      "bbox_min": [
        -329.0,
        1079.0,
        35.0
      ],
      "bbox_max": [
        -314.0,
        1084.0,
        50.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268232345581055,
        0.0,
        0.9238799810409546
      ],
      "plane_d": 90.69657135009766,
      "bbox_min": [
        -329.0,
        1079.0,
        35.0
      ],
      "bbox_max": [
        -314.0,
        1084.0,
        47.80330276489258
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268232345581055,
        0.0,
        0.9238799810409546
      ],
      "plane_d": -155.3681640625,
      "bbox_min": [
        -329.0,
        1079.0,
        35.0
      ],
      "bbox_max": [
        -314.0,
        1084.0,
        47.80330276489258
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923880398273468,
        -0.0,
        -0.38268133997917175
      ],
      "plane_d": -273.8345031738281,
      "bbox_min": [
        -329.0,
        1079.0,
        37.19669723510742
      ],
      "bbox_max": [
        -314.0,
        1084.0,
        47.80330276489258
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923880398273468,
        0.0,
        0.38268133997917175
      ],
      "plane_d": 287.69268798828125,
      "bbox_min": [
        -329.0,
        1079.0,
        37.19669723510742
      ],
      "bbox_max": [
        -314.0,
        1084.0,
        42.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923880398273468,
        0.0,
        0.38268133997917175
      ],
      "plane_d": -306.3623962402344,
      "bbox_min": [
        -316.1966857910156,
        1079.0,
        37.19669723510742
      ],
      "bbox_max": [
        -314.0,
        1084.0,
        42.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        -370.0,
        1084.0,
        35.0
      ],
      "bbox_max": [
        -310.0,
        1135.164794921875,
        60.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1094.0,
      "bbox_min": [
        -370.0,
        1094.0,
        35.0
      ],
      "bbox_max": [
        -350.0,
        1130.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -360.0,
      "bbox_min": [
        -370.0,
        1105.0,
        35.0
      ],
      "bbox_max": [
        -350.0,
        1130.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -40.0,
      "bbox_min": [
        -360.0,
        1105.0,
        35.0
      ],
      "bbox_max": [
        -350.0,
        1130.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1105.0,
      "bbox_min": [
        -360.0,
        1105.0,
        35.0
      ],
      "bbox_max": [
        -350.0,
        1130.0,
        40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        -360.0,
        1130.0,
        35.0
      ],
      "bbox_max": [
        -350.0,
        1130.0,
        40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1120.669921875,
      "bbox_min": [
        -360.0,
        1105.669921875,
        40.0
      ],
      "bbox_max": [
        -350.0,
        1129.330078125,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660229444503784,
        -0.500004231929779,
        -0.0
      ],
      "plane_d": 250.7364959716797,
      "bbox_min": [
        -360.0,
        1120.669921875,
        40.0
      ],
      "bbox_max": [
        -350.0,
        1129.330078125,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660229444503784,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 865.61279296875,
      "bbox_min": [
        -360.0,
        1120.669921875,
        40.0
      ],
      "bbox_max": [
        -350.0,
        1129.330078125,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660229444503784,
        0.500004231929779,
        0.0
      ],
      "plane_d": -259.396728515625,
      "bbox_min": [
        -360.0,
        1125.0,
        40.0
      ],
      "bbox_max": [
        -350.0,
        1129.330078125,
        58.71314239501953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660229444503784,
        0.500004231929779,
        0.0
      ],
      "plane_d": -874.2730102539062,
      "bbox_min": [
        -360.0,
        1125.0,
        40.0
      ],
      "bbox_max": [
        -352.5,
        1129.330078125,
        58.71314239501953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1129.330078125,
      "bbox_min": [
        -357.5,
        1129.330078125,
        40.0
      ],
      "bbox_max": [
        -352.5,
        1129.330078125,
        56.919578552246094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1114.330078125,
      "bbox_min": [
        -360.0,
        1105.669921875,
        40.0
      ],
      "bbox_max": [
        -350.0,
        1114.330078125,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1105.669921875,
      "bbox_min": [
        -360.0,
        1105.669921875,
        40.0
      ],
      "bbox_max": [
        -350.0,
        1114.330078125,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660229444503784,
        0.500004231929779,
        0.0
      ],
      "plane_d": -251.89666748046875,
      "bbox_min": [
        -360.0,
        1105.669921875,
        40.0
      ],
      "bbox_max": [
        -350.0,
        1114.330078125,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660229444503784,
        0.500004231929779,
        0.0
      ],
      "plane_d": -866.77294921875,
      "bbox_min": [
        -360.0,
        1105.669921875,
        40.0
      ],
      "bbox_max": [
        -350.0,
        1114.330078125,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660229444503784,
        -0.500004231929779,
        -0.0
      ],
      "plane_d": 243.23643493652344,
      "bbox_min": [
        -360.0,
        1105.669921875,
        40.0
      ],
      "bbox_max": [
        -350.0,
        1110.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660229444503784,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 858.1127319335938,
      "bbox_min": [
        -352.5,
        1105.669921875,
        40.0
      ],
      "bbox_max": [
        -350.0,
        1110.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1114.0,
      "bbox_min": [
        -370.0,
        1108.0,
        35.0
      ],
      "bbox_max": [
        -364.0,
        1127.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -370.0,
        1108.0,
        35.0
      ],
      "bbox_max": [
        -364.0,
        1114.0,
        60.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1112.0,
      "bbox_min": [
        -370.0,
        1108.0,
        35.0
      ],
      "bbox_max": [
        -369.0,
        1114.0,
        60.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -36.0,
      "bbox_min": [
        -370.0,
        1112.0,
        36.0
      ],
      "bbox_max": [
        -369.0,
        1114.0,
        36.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -36.0,
      "bbox_min": [
        -370.0,
        1108.0,
        35.0
      ],
      "bbox_max": [
        -369.0,
        1112.0,
        36.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1108.0,
      "bbox_min": [
        -370.0,
        1108.0,
        35.0
      ],
      "bbox_max": [
        -369.0,
        1108.0,
        36.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -36.0,
      "bbox_min": [
        -369.0,
        1108.0,
        35.0
      ],
      "bbox_max": [
        -364.0,
        1114.0,
        36.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1108.0,
      "bbox_min": [
        -369.0,
        1108.0,
        35.0
      ],
      "bbox_max": [
        -364.0,
        1108.0,
        36.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1121.0,
      "bbox_min": [
        -370.0,
        1114.0,
        35.0
      ],
      "bbox_max": [
        -364.0,
        1127.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -370.0,
        1121.0,
        35.0
      ],
      "bbox_max": [
        -364.0,
        1127.0,
        60.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1123.0,
      "bbox_min": [
        -370.0,
        1121.0,
        35.0
      ],
      "bbox_max": [
        -369.0,
        1127.0,
        59.54158401489258
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -36.0,
      "bbox_min": [
        -370.0,
        1121.0,
        36.0
      ],
      "bbox_max": [
        -369.0,
        1123.0,
        36.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -36.0,
      "bbox_min": [
        -370.0,
        1123.0,
        35.0
      ],
      "bbox_max": [
        -369.0,
        1127.0,
        36.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1127.0,
      "bbox_min": [
        -370.0,
        1127.0,
        35.0
      ],
      "bbox_max": [
        -369.0,
        1127.0,
        36.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -36.0,
      "bbox_min": [
        -369.0,
        1121.0,
        35.0
      ],
      "bbox_max": [
        -364.0,
        1127.0,
        36.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1127.0,
      "bbox_min": [
        -369.0,
        1127.0,
        35.0
      ],
      "bbox_max": [
        -364.0,
        1127.0,
        36.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -370.0,
        1114.0,
        35.0
      ],
      "bbox_max": [
        -364.0,
        1121.0,
        46.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -46.0,
      "bbox_min": [
        -370.0,
        1114.0,
        46.0
      ],
      "bbox_max": [
        -369.0,
        1121.0,
        46.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -36.0,
      "bbox_min": [
        -369.0,
        1114.0,
        35.0
      ],
      "bbox_max": [
        -364.0,
        1121.0,
        41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 364.0,
      "bbox_min": [
        -364.0,
        1114.0,
        35.0
      ],
      "bbox_max": [
        -364.0,
        1121.0,
        36.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 368.5,
      "bbox_min": [
        -369.0,
        1116.0,
        39.0
      ],
      "bbox_max": [
        -368.5,
        1119.0,
        41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -41.0,
      "bbox_min": [
        -369.0,
        1116.0,
        39.0
      ],
      "bbox_max": [
        -368.5,
        1119.0,
        41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 39.0,
      "bbox_min": [
        -369.0,
        1116.0,
        39.0
      ],
      "bbox_max": [
        -368.5,
        1119.0,
        41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1116.0,
      "bbox_min": [
        -369.0,
        1116.0,
        39.0
      ],
      "bbox_max": [
        -368.5,
        1119.0,
        41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1119.0,
      "bbox_min": [
        -369.0,
        1119.0,
        39.0
      ],
      "bbox_max": [
        -368.5,
        1119.0,
        41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -341.0,
      "bbox_min": [
        -345.0,
        1084.0,
        35.0
      ],
      "bbox_max": [
        -310.0,
        1135.164794921875,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 59.489715576171875,
      "bbox_min": [
        -341.0,
        1084.0,
        35.0
      ],
      "bbox_max": [
        -310.0,
        1135.164794921875,
        60.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -326.0,
      "bbox_min": [
        -341.0,
        1084.0,
        59.489715576171875
      ],
      "bbox_max": [
        -310.0,
        1123.1251220703125,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -311.0,
      "bbox_min": [
        -326.0,
        1084.0,
        59.489715576171875
      ],
      "bbox_max": [
        -310.0,
        1123.1251220703125,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        -311.0,
        1110.0,
        59.489715576171875
      ],
      "bbox_max": [
        -310.0,
        1110.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 324.0,
      "bbox_min": [
        -326.0,
        1084.0,
        59.489715576171875
      ],
      "bbox_max": [
        -311.0,
        1123.1251220703125,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        -326.0,
        1110.0,
        59.489715576171875
      ],
      "bbox_max": [
        -324.0,
        1110.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 320.0,
      "bbox_min": [
        -324.0,
        1110.0,
        59.489715576171875
      ],
      "bbox_max": [
        -311.0,
        1123.1251220703125,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        -315.0,
        1110.0,
        59.489715576171875
      ],
      "bbox_max": [
        -311.0,
        1110.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 339.0,
      "bbox_min": [
        -341.0,
        1084.0,
        59.489715576171875
      ],
      "bbox_max": [
        -326.0,
        1123.1251220703125,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        -341.0,
        1110.0,
        59.489715576171875
      ],
      "bbox_max": [
        -339.0,
        1110.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 335.0,
      "bbox_min": [
        -339.0,
        1110.0,
        59.489715576171875
      ],
      "bbox_max": [
        -326.0,
        1123.1251220703125,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        -330.0,
        1110.0,
        59.489715576171875
      ],
      "bbox_max": [
        -326.0,
        1110.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238793849945068,
        -0.38268375396728516,
        -0.0
      ],
      "plane_d": 133.3199005126953,
      "bbox_min": [
        -341.0,
        1100.835205078125,
        35.0
      ],
      "bbox_max": [
        -310.0,
        1135.164794921875,
        59.489715576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -43.0,
      "bbox_min": [
        -325.7653503417969,
        1105.545654296875,
        35.0
      ],
      "bbox_max": [
        -310.0,
        1135.164794921875,
        59.489715576171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.38268470764160156,
        0.9238790273666382,
        0.0
      ],
      "plane_d": -924.3824462890625,
      "bbox_min": [
        -325.7653503417969,
        1105.545654296875,
        35.0
      ],
      "bbox_max": [
        -310.0,
        1135.164794921875,
        43.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238789677619934,
        0.38268476724624634,
        0.0
      ],
      "plane_d": -714.2440795898438,
      "bbox_min": [
        -325.7653503417969,
        1105.545654296875,
        35.0
      ],
      "bbox_max": [
        -310.0,
        1135.164794921875,
        43.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238790273666382,
        -0.38268470764160156,
        0.0
      ],
      "plane_d": 712.2440185546875,
      "bbox_min": [
        -313.6280212402344,
        1105.545654296875,
        35.0
      ],
      "bbox_max": [
        -310.0,
        1112.7738037109375,
        43.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 40.0,
      "bbox_min": [
        -325.7653503417969,
        1107.3934326171875,
        35.0
      ],
      "bbox_max": [
        -310.0,
        1135.164794921875,
        41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238789677619934,
        -0.38268476724624634,
        -0.0
      ],
      "plane_d": 141.4390869140625,
      "bbox_min": [
        -325.7653503417969,
        1118.0,
        40.0
      ],
      "bbox_max": [
        -310.0,
        1135.164794921875,
        41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238790273666382,
        0.38268470764160156,
        0.0
      ],
      "plane_d": -143.4390106201172,
      "bbox_min": [
        -312.8626708984375,
        1123.2261962890625,
        40.0
      ],
      "bbox_max": [
        -310.0,
        1130.1373291015625,
        41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268551230430603,
        -0.9238786697387695,
        -2.1012406250520144e-06
      ],
      "plane_d": 922.3818359375,
      "bbox_min": [
        -325.7653503417969,
        1128.6065673828125,
        40.0
      ],
      "bbox_max": [
        -314.3934020996094,
        1135.164794921875,
        41.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.38268470764160156,
        0.9238790273666382,
        0.0
      ],
      "plane_d": -1173.12744140625,
      "bbox_min": [
        -325.7653503417969,
        1134.8477783203125,
        40.0
      ],
      "bbox_max": [
        -325.0,
        1135.164794921875,
        41.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238789677619934,
        -0.38268476724624634,
        -0.0
      ],
      "plane_d": 141.4390869140625,
      "bbox_min": [
        -325.7653503417969,
        1118.0,
        35.0
      ],
      "bbox_max": [
        -310.0,
        1135.164794921875,
        40.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.382688045501709,
        -0.9238775968551636,
        0.0
      ],
      "plane_d": 922.3796997070312,
      "bbox_min": [
        -325.7653503417969,
        1128.6065673828125,
        35.0
      ],
      "bbox_max": [
        -314.3934020996094,
        1135.164794921875,
        40.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9238790273666382,
        0.38268470764160156,
        0.0
      ],
      "plane_d": -143.4390106201172,
      "bbox_min": [
        -312.8626708984375,
        1123.2261962890625,
        41.0
      ],
      "bbox_max": [
        -310.0,
        1130.1373291015625,
        43.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268551230430603,
        -0.9238786697387695,
        -2.1012406250520144e-06
      ],
      "plane_d": 922.3818359375,
      "bbox_min": [
        -325.7653503417969,
        1128.6065673828125,
        41.0
      ],
      "bbox_max": [
        -314.3934020996094,
        1135.164794921875,
        43.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.38268470764160156,
        0.9238790273666382,
        0.0
      ],
      "plane_d": -1173.12744140625,
      "bbox_min": [
        -325.7653503417969,
        1134.8477783203125,
        41.0
      ],
      "bbox_max": [
        -325.0,
        1135.164794921875,
        43.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        -315.0,
        1110.0,
        59.0
      ],
      "bbox_max": [
        -310.0,
        1110.0,
        59.489715576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238789677619934,
        0.38268476724624634,
        0.0
      ],
      "plane_d": -714.2440795898438,
      "bbox_min": [
        -325.7653503417969,
        1105.545654296875,
        43.0
      ],
      "bbox_max": [
        -310.0,
        1135.164794921875,
        45.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238790273666382,
        -0.38268470764160156,
        0.0
      ],
      "plane_d": 712.2440185546875,
      "bbox_min": [
        -313.6280212402344,
        1105.545654296875,
        43.0
      ],
      "bbox_max": [
        -310.0,
        1112.7738037109375,
        45.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826894760131836,
        -0.9238770604133606,
        0.0
      ],
      "plane_d": 922.378662109375,
      "bbox_min": [
        -325.7653503417969,
        1128.6065673828125,
        43.0
      ],
      "bbox_max": [
        -314.3934020996094,
        1135.164794921875,
        45.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268470764160156,
        0.9238790273666382,
        0.0
      ],
      "plane_d": -1173.12744140625,
      "bbox_min": [
        -325.7653503417969,
        1134.8477783203125,
        43.0
      ],
      "bbox_max": [
        -325.0,
        1135.164794921875,
        45.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -43.0,
      "bbox_min": [
        -341.0,
        1100.835205078125,
        35.0
      ],
      "bbox_max": [
        -313.6280212402344,
        1134.8477783203125,
        59.489715576171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.38268470764160156,
        -0.9238790273666382,
        -0.0
      ],
      "plane_d": 892.666015625,
      "bbox_min": [
        -341.0,
        1100.835205078125,
        35.0
      ],
      "bbox_max": [
        -313.6280212402344,
        1134.8477783203125,
        43.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268470764160156,
        -0.9238790273666382,
        0.0
      ],
      "plane_d": 1141.4111328125,
      "bbox_min": [
        -341.0,
        1100.835205078125,
        35.0
      ],
      "bbox_max": [
        -313.6280212402344,
        1134.8477783203125,
        43.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238789677619934,
        0.38268476724624634,
        0.0
      ],
      "plane_d": -113.72271728515625,
      "bbox_min": [
        -341.0,
        1103.0,
        35.0
      ],
      "bbox_max": [
        -314.3934020996094,
        1133.0,
        43.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238790273666382,
        -0.38268470764160156,
        -0.0
      ],
      "plane_d": 111.72262573242188,
      "bbox_min": [
        -341.0,
        1105.8626708984375,
        35.0
      ],
      "bbox_max": [
        -337.1373291015625,
        1115.18798828125,
        43.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -330.0,
      "bbox_min": [
        -341.0,
        1110.0,
        59.0
      ],
      "bbox_max": [
        -320.0,
        1124.3074951171875,
        59.489715576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 320.0,
      "bbox_min": [
        -330.0,
        1110.0,
        59.0
      ],
      "bbox_max": [
        -320.0,
        1120.9290771484375,
        59.489715576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        -330.0,
        1110.0,
        59.0
      ],
      "bbox_max": [
        -320.0,
        1110.0,
        59.489715576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        -341.0,
        1110.0,
        59.0
      ],
      "bbox_max": [
        -335.0,
        1110.0,
        59.489715576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268470764160156,
        -0.9238790273666382,
        -0.0
      ],
      "plane_d": 892.666015625,
      "bbox_min": [
        -341.0,
        1100.835205078125,
        43.0
      ],
      "bbox_max": [
        -313.6280212402344,
        1134.8477783203125,
        45.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268470764160156,
        -0.9238790273666382,
        0.0
      ],
      "plane_d": 1141.4111328125,
      "bbox_min": [
        -341.0,
        1100.835205078125,
        43.0
      ],
      "bbox_max": [
        -313.6280212402344,
        1134.8477783203125,
        45.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238789677619934,
        0.38268476724624634,
        -0.0
      ],
      "plane_d": -113.72271728515625,
      "bbox_min": [
        -341.0,
        1103.0,
        43.0
      ],
      "bbox_max": [
        -314.3934020996094,
        1133.0,
        45.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238790273666382,
        -0.38268470764160156,
        -0.0
      ],
      "plane_d": 111.72262573242188,
      "bbox_min": [
        -341.0,
        1105.8626708984375,
        43.0
      ],
      "bbox_max": [
        -337.1373291015625,
        1115.18798828125,
        45.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268548250198364,
        -0.9238786697387695,
        0.0
      ],
      "plane_d": 1171.1273193359375,
      "bbox_min": [
        -335.6065979003906,
        1128.6065673828125,
        43.0
      ],
      "bbox_max": [
        -325.0,
        1133.0,
        45.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 59.0,
      "bbox_min": [
        -345.0,
        1110.0,
        35.0
      ],
      "bbox_max": [
        -341.0,
        1124.3074951171875,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        -345.0,
        1110.0,
        59.0
      ],
      "bbox_max": [
        -341.0,
        1110.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238790273666382,
        0.38268470764160156,
        0.0
      ],
      "plane_d": -743.9603881835938,
      "bbox_min": [
        -342.164794921875,
        1115.18798828125,
        35.0
      ],
      "bbox_max": [
        -341.0,
        1120.81201171875,
        45.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238790273666382,
        -0.38268470764160156,
        -0.0
      ],
      "plane_d": 111.72262573242188,
      "bbox_min": [
        -342.164794921875,
        1115.18798828125,
        35.0
      ],
      "bbox_max": [
        -341.0,
        1120.81201171875,
        45.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -45.0,
      "bbox_min": [
        -342.164794921875,
        1115.18798828125,
        45.0
      ],
      "bbox_max": [
        -341.0,
        1120.81201171875,
        45.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.4472135901451111,
        -0.8944271802902222
      ],
      "plane_d": 518.6783447265625,
      "bbox_min": [
        -310.0,
        1039.800048828125,
        35.0
      ],
      "bbox_max": [
        -300.0,
        1124.3074951171875,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 59.489715576171875,
      "bbox_min": [
        -310.0,
        1069.800048828125,
        35.0
      ],
      "bbox_max": [
        -300.0,
        1124.3074951171875,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 309.0,
      "bbox_min": [
        -310.0,
        1084.0,
        59.489715576171875
      ],
      "bbox_max": [
        -300.0,
        1123.1251220703125,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        -310.0,
        1084.0,
        59.489715576171875
      ],
      "bbox_max": [
        -309.0,
        1110.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1084.0,
      "bbox_min": [
        -310.0,
        1084.0,
        59.489715576171875
      ],
      "bbox_max": [
        -309.0,
        1084.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 305.0,
      "bbox_min": [
        -309.0,
        1084.0,
        59.489715576171875
      ],
      "bbox_max": [
        -300.0,
        1123.1251220703125,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        -309.0,
        1084.0,
        59.489715576171875
      ],
      "bbox_max": [
        -305.0,
        1110.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1084.0,
      "bbox_min": [
        -309.0,
        1084.0,
        59.489715576171875
      ],
      "bbox_max": [
        -305.0,
        1084.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1084.0,
      "bbox_min": [
        -305.0,
        1084.0,
        59.489715576171875
      ],
      "bbox_max": [
        -300.0,
        1084.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 305.0,
      "bbox_min": [
        -310.0,
        1110.0,
        59.0
      ],
      "bbox_max": [
        -305.0,
        1124.3074951171875,
        59.489715576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -48.0,
      "bbox_min": [
        -306.0,
        1084.0,
        46.0
      ],
      "bbox_max": [
        -302.0,
        1084.5,
        48.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 46.0,
      "bbox_min": [
        -306.0,
        1084.0,
        46.0
      ],
      "bbox_max": [
        -302.0,
        1084.5,
        48.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -306.0,
      "bbox_min": [
        -306.0,
        1084.0,
        46.0
      ],
      "bbox_max": [
        -306.0,
        1084.5,
        48.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238790273666382,
        -0.38268470764160156,
        0.0
      ],
      "plane_d": 712.2440185546875,
      "bbox_min": [
        -310.0,
        1112.7738037109375,
        35.0
      ],
      "bbox_max": [
        -307.835205078125,
        1123.2261962890625,
        45.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238790273666382,
        0.38268470764160156,
        0.0
      ],
      "plane_d": -143.4390106201172,
      "bbox_min": [
        -310.0,
        1118.0,
        35.0
      ],
      "bbox_max": [
        -307.835205078125,
        1123.2261962890625,
        45.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 0.0,
      "bbox_min": [
        -1870.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        1070.0,
        2540.0,
        250.00003051757812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1490.0,
      "bbox_min": [
        -1850.0,
        1430.0,
        60.0
      ],
      "bbox_max": [
        0.0,
        1750.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1850.0,
      "bbox_min": [
        -1850.0,
        1490.0,
        60.0
      ],
      "bbox_max": [
        -1850.0,
        1750.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9700985550880432,
        -0.2427113950252533,
        0.0
      ],
      "plane_d": 924.297119140625,
      "bbox_min": [
        -1850.0,
        1430.0,
        60.0
      ],
      "bbox_max": [
        -580.0,
        1490.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1850.0,
      "bbox_min": [
        -1850.0,
        1430.0,
        60.0
      ],
      "bbox_max": [
        -1850.0,
        1490.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999999403953552,
        0.866025447845459,
        0.0
      ],
      "plane_d": -1107.953857421875,
      "bbox_min": [
        -1870.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1430.0,
        250.00003051757812
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        -50.843994140625,
        1250.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1250.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1040.0,
      "bbox_min": [
        -354.81549072265625,
        1007.300048828125,
        60.0
      ],
      "bbox_max": [
        -123.92950439453125,
        1200.363037109375,
        250.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": -871.8876342773438,
      "bbox_min": [
        -330.0,
        1007.300048828125,
        60.0
      ],
      "bbox_max": [
        -300.0,
        1040.0,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -930.0254516601562,
      "bbox_min": [
        -330.0,
        1007.300048828125,
        60.0
      ],
      "bbox_max": [
        -300.0,
        1040.0,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 70.0,
      "bbox_min": [
        -330.0,
        1007.300048828125,
        60.0
      ],
      "bbox_max": [
        -300.0,
        1040.0,
        70.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -320.0,
      "bbox_min": [
        -330.0,
        1007.300048828125,
        60.0
      ],
      "bbox_max": [
        -300.0,
        1040.0,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.4472135901451111,
        -0.8944271802902222
      ],
      "plane_d": 518.6783447265625,
      "bbox_min": [
        -320.0,
        1007.300048828125,
        60.0
      ],
      "bbox_max": [
        -300.0,
        1039.800048828125,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        -320.0,
        1007.300048828125,
        60.0
      ],
      "bbox_max": [
        -300.0,
        1039.800048828125,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1019.800048828125,
      "bbox_min": [
        -320.0,
        1019.800048828125,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1019.800048828125,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -300.0,
        1007.300048828125,
        60.0
      ],
      "bbox_max": [
        -300.0,
        1039.800048828125,
        70.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 330.0,
      "bbox_min": [
        -330.0,
        1007.300048828125,
        60.0
      ],
      "bbox_max": [
        -330.0,
        1040.0,
        70.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -315.0,
      "bbox_min": [
        -354.81549072265625,
        1040.0,
        60.0
      ],
      "bbox_max": [
        -123.92950439453125,
        1200.363037109375,
        250.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": 304.5385437011719,
      "bbox_min": [
        -315.0,
        1051.800048828125,
        60.0
      ],
      "bbox_max": [
        -123.92950439453125,
        1200.363037109375,
        250.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -161.6405487060547,
        1143.5941162109375,
        95.0
      ],
      "bbox_max": [
        -123.92950439453125,
        1200.363037109375,
        131.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8380875587463379,
        -0.5455357432365417,
        0.0
      ],
      "plane_d": 540.175537109375,
      "bbox_min": [
        -161.64051818847656,
        1143.5941162109375,
        95.0
      ],
      "bbox_max": [
        -123.92950439453125,
        1200.363037109375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4038896858692169,
        -0.26290363073349,
        -0.8762161731719971
      ],
      "plane_d": 365.4664001464844,
      "bbox_min": [
        -161.64051818847656,
        1143.5941162109375,
        95.0
      ],
      "bbox_max": [
        -123.92950439453125,
        1200.363037109375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6006801724433899,
        0.12700723111629486,
        -0.7893367409706116
      ],
      "plane_d": -129.66162109375,
      "bbox_min": [
        -161.64051818847656,
        1143.5941162109375,
        95.0
      ],
      "bbox_max": [
        -123.92950439453125,
        1190.3486328125,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.545535147190094,
        0.8380879163742065,
        0.0
      ],
      "plane_d": -1037.0234375,
      "bbox_min": [
        -161.64051818847656,
        1143.5941162109375,
        95.0
      ],
      "bbox_max": [
        -129.78054809570312,
        1190.3486328125,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26290392875671387,
        0.40389078855514526,
        -0.8762155771255493
      ],
      "plane_d": -394.6158142089844,
      "bbox_min": [
        -161.64051818847656,
        1143.5941162109375,
        95.0
      ],
      "bbox_max": [
        -129.78054809570312,
        1190.3486328125,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -161.64051818847656,
        1162.39013671875,
        95.0
      ],
      "bbox_max": [
        -140.69125366210938,
        1190.3486328125,
        131.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 105.0,
      "bbox_min": [
        -157.92892456054688,
        1170.0,
        105.0
      ],
      "bbox_max": [
        -154.0761260986328,
        1177.4537353515625,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1027.03369140625,
      "bbox_min": [
        -315.0,
        1051.800048828125,
        60.0
      ],
      "bbox_max": [
        -144.0623016357422,
        1186.03173828125,
        250.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -169.12689208984375,
        1177.071044921875,
        95.0
      ],
      "bbox_max": [
        -157.92892456054688,
        1186.03173828125,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -169.12673950195312,
        1177.071044921875,
        131.0
      ],
      "bbox_max": [
        -157.92892456054688,
        1186.0316162109375,
        131.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1153.3199462890625,
      "bbox_min": [
        -315.0,
        1051.800048828125,
        60.0
      ],
      "bbox_max": [
        -144.0623016357422,
        1181.70947265625,
        250.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -190.0837860107422,
        1169.6099853515625,
        95.0
      ],
      "bbox_max": [
        -165.0,
        1181.70947265625,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -190.08363342285156,
        1169.6099853515625,
        131.0
      ],
      "bbox_max": [
        -165.0,
        1181.70947265625,
        131.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -173.2484588623047,
        1125.61376953125,
        95.0
      ],
      "bbox_max": [
        -144.0623016357422,
        1170.0,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26290392875671387,
        0.40389078855514526,
        -0.8762155771255493
      ],
      "plane_d": -394.6158142089844,
      "bbox_min": [
        -173.2484588623047,
        1125.61376953125,
        95.0
      ],
      "bbox_max": [
        -144.0623016357422,
        1170.0,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20686249434947968,
        0.9783700108528137,
        0.0
      ],
      "plane_d": -1065.7515869140625,
      "bbox_min": [
        -173.2484588623047,
        1125.61376953125,
        95.0
      ],
      "bbox_max": [
        -151.8478546142578,
        1170.0,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -173.2484588623047,
        1125.61376953125,
        95.0
      ],
      "bbox_max": [
        -151.8478546142578,
        1170.0,
        131.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3826940953731537,
        -0.923875093460083,
        0.0
      ],
      "plane_d": 1139.25146484375,
      "bbox_min": [
        -173.2484588623047,
        1125.61376953125,
        95.0
      ],
      "bbox_max": [
        -154.61732482910156,
        1169.076171875,
        121.0477066040039
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12700527906417847,
        0.6006799340248108,
        -0.7893372178077698
      ],
      "plane_d": -559.6082763671875,
      "bbox_min": [
        -173.2484588623047,
        1125.61376953125,
        120.0
      ],
      "bbox_max": [
        -171.68490600585938,
        1127.210205078125,
        121.0477066040039
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        0.9238786101341248,
        0.0
      ],
      "plane_d": -1134.84228515625,
      "bbox_min": [
        -315.0,
        1051.800048828125,
        60.0
      ],
      "bbox_max": [
        -154.99998474121094,
        1180.0001220703125,
        250.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -75.0,
      "bbox_min": [
        -315.0,
        1051.800048828125,
        60.0
      ],
      "bbox_max": [
        -157.92892456054688,
        1162.928955078125,
        131.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.49999430775642395,
        0.8660286664962769,
        0.0
      ],
      "plane_d": -1082.9560546875,
      "bbox_min": [
        -315.0,
        1051.800048828125,
        60.0
      ],
      "bbox_max": [
        -228.38961791992188,
        1130.8255615234375,
        75.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8289903402328491,
        0.5592629313468933,
        0.0
      ],
      "plane_d": -844.8052978515625,
      "bbox_min": [
        -315.0,
        1051.800048828125,
        60.0
      ],
      "bbox_max": [
        -293.78204345703125,
        1079.42919921875,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660288453102112,
        -0.4999940097332001,
        -0.0
      ],
      "plane_d": 283.119140625,
      "bbox_min": [
        -315.0,
        1051.800048828125,
        60.0
      ],
      "bbox_max": [
        -293.78204345703125,
        1079.42919921875,
        75.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 73.0,
      "bbox_min": [
        -315.0,
        1061.800048828125,
        73.0
      ],
      "bbox_max": [
        -307.16021728515625,
        1073.14892578125,
        75.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8289884924888611,
        0.5592656135559082,
        0.0
      ],
      "plane_d": -856.8075561523438,
      "bbox_min": [
        -315.0,
        1061.800048828125,
        73.0
      ],
      "bbox_max": [
        -311.1120300292969,
        1070.8673095703125,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1061.800048828125,
      "bbox_min": [
        -315.0,
        1061.800048828125,
        73.0
      ],
      "bbox_max": [
        -314.8165588378906,
        1061.800048828125,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1051.800048828125,
      "bbox_min": [
        -315.0,
        1051.800048828125,
        60.0
      ],
      "bbox_max": [
        -309.5,
        1053.0,
        75.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1053.0,
      "bbox_min": [
        -315.0,
        1051.800048828125,
        60.0
      ],
      "bbox_max": [
        -312.0,
        1053.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 312.0,
      "bbox_min": [
        -315.0,
        1051.800048828125,
        60.0
      ],
      "bbox_max": [
        -312.0,
        1053.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -68.0,
      "bbox_min": [
        -315.0,
        1051.800048828125,
        60.0
      ],
      "bbox_max": [
        -312.0,
        1053.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 64.0,
      "bbox_min": [
        -315.0,
        1051.800048828125,
        60.0
      ],
      "bbox_max": [
        -312.0,
        1053.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1052.5,
      "bbox_min": [
        -314.79998779296875,
        1051.800048828125,
        60.0
      ],
      "bbox_max": [
        -313.3999938964844,
        1052.5,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -314.79998779296875,
      "bbox_min": [
        -314.79998779296875,
        1051.800048828125,
        60.0
      ],
      "bbox_max": [
        -313.3999938964844,
        1052.5,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 313.3999938964844,
      "bbox_min": [
        -313.3999938964844,
        1051.800048828125,
        60.0
      ],
      "bbox_max": [
        -313.3999938964844,
        1052.5,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1052.5,
      "bbox_min": [
        -314.79998779296875,
        1051.800048828125,
        68.0
      ],
      "bbox_max": [
        -313.3999938964844,
        1052.5,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 313.3999938964844,
      "bbox_min": [
        -314.79998779296875,
        1051.800048828125,
        68.0
      ],
      "bbox_max": [
        -313.3999938964844,
        1052.5,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -314.79998779296875,
      "bbox_min": [
        -314.79998779296875,
        1051.800048828125,
        68.0
      ],
      "bbox_max": [
        -314.79998779296875,
        1052.5,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 70.0,
      "bbox_min": [
        -315.0,
        1070.8673095703125,
        60.0
      ],
      "bbox_max": [
        -228.38961791992188,
        1130.8255615234375,
        75.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8660258650779724,
        -0.49999919533729553,
        -5.957438133918913e-06
      ],
      "plane_d": 283.12603759765625,
      "bbox_min": [
        -315.0,
        1070.8673095703125,
        70.0
      ],
      "bbox_max": [
        -296.2822570800781,
        1096.7496337890625,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 73.0,
      "bbox_min": [
        -315.0,
        1070.8673095703125,
        73.0
      ],
      "bbox_max": [
        -305.5669250488281,
        1086.7496337890625,
        75.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8289884924888611,
        0.5592656135559082,
        0.0
      ],
      "plane_d": -856.8075561523438,
      "bbox_min": [
        -315.0,
        1070.8673095703125,
        73.0
      ],
      "bbox_max": [
        -305.5669250488281,
        1086.7496337890625,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8289889097213745,
        -0.5592650771141052,
        0.0
      ],
      "plane_d": 854.80712890625,
      "bbox_min": [
        -307.16021728515625,
        1073.14892578125,
        73.0
      ],
      "bbox_max": [
        -305.5669250488281,
        1075.5106201171875,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660272359848022,
        -0.49999678134918213,
        0.0
      ],
      "plane_d": 271.12255859375,
      "bbox_min": [
        -315.0,
        1075.593017578125,
        73.0
      ],
      "bbox_max": [
        -307.92388916015625,
        1086.7496337890625,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -4.904671641270397e-06,
        1.0,
        0.0
      ],
      "plane_d": -1086.751220703125,
      "bbox_min": [
        -314.3651428222656,
        1086.7496337890625,
        73.0
      ],
      "bbox_max": [
        -312.05572509765625,
        1086.7496337890625,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        5.406318450695835e-06,
        -1.0,
        0.0
      ],
      "plane_d": 1084.7513427734375,
      "bbox_min": [
        -315.0,
        1084.7496337890625,
        73.0
      ],
      "bbox_max": [
        -313.2104187011719,
        1086.7496337890625,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -4.904671641270397e-06,
        1.0,
        0.0
      ],
      "plane_d": -1086.751220703125,
      "bbox_min": [
        -315.0,
        1086.7496337890625,
        73.0
      ],
      "bbox_max": [
        -314.3651428222656,
        1086.7496337890625,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1096.7496337890625,
      "bbox_min": [
        -315.0,
        1096.7496337890625,
        70.0
      ],
      "bbox_max": [
        -306.2822265625,
        1096.7496337890625,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999529123306274,
        -0.8660281300544739,
        0.0
      ],
      "plane_d": 1102.9556884765625,
      "bbox_min": [
        -315.0,
        1096.7496337890625,
        60.0
      ],
      "bbox_max": [
        -228.38961791992188,
        1130.8255615234375,
        70.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1096.7496337890625,
      "bbox_min": [
        -315.0,
        1096.7496337890625,
        60.0
      ],
      "bbox_max": [
        -306.2822265625,
        1096.7496337890625,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660280108451843,
        -0.49999552965164185,
        -0.0
      ],
      "plane_d": 361.51641845703125,
      "bbox_min": [
        -235.4326934814453,
        1118.62646484375,
        60.0
      ],
      "bbox_max": [
        -228.38961791992188,
        1130.8255615234375,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        -315.0,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -157.92892456054688,
        1162.928955078125,
        131.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.26290392875671387,
        0.40389078855514526,
        -0.8762155771255493
      ],
      "plane_d": -394.6158142089844,
      "bbox_min": [
        -206.69088745117188,
        1125.9443359375,
        120.0
      ],
      "bbox_max": [
        -157.92892456054688,
        1162.928955078125,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12700527906417847,
        0.6006799340248108,
        -0.7893372178077698
      ],
      "plane_d": -559.6082763671875,
      "bbox_min": [
        -206.69088745117188,
        1125.9443359375,
        120.0
      ],
      "bbox_max": [
        -157.92892456054688,
        1162.928955078125,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4038896858692169,
        0.26290363073349,
        -0.8762161731719971
      ],
      "plane_d": -111.8018569946289,
      "bbox_min": [
        -206.69088745117188,
        1131.4647216796875,
        120.0
      ],
      "bbox_max": [
        -157.92892456054688,
        1162.928955078125,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -187.8948974609375,
        1142.37548828125,
        131.0
      ],
      "bbox_max": [
        -157.92892456054688,
        1162.928955078125,
        131.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.4999999403953552,
        0.866025447845459,
        0.0
      ],
      "plane_d": -1077.9537353515625,
      "bbox_min": [
        -315.0,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -157.92893981933594,
        1162.928955078125,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -315.0,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -163.04396057128906,
        1150.5802001953125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1051.800048828125,
      "bbox_min": [
        -315.0,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -309.5,
        1057.8154296875,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -76.0,
      "bbox_min": [
        -315.0,
        1053.784423828125,
        75.0
      ],
      "bbox_max": [
        -310.97265625,
        1057.8154296875,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7745960354804993,
        -0.44720351696014404,
        -0.4472247362136841
      ],
      "plane_d": 747.0247802734375,
      "bbox_min": [
        -315.0,
        1053.784423828125,
        75.0
      ],
      "bbox_max": [
        -310.97265625,
        1057.8154296875,
        76.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": -912.150634765625,
      "bbox_min": [
        -315.0,
        1053.784423828125,
        75.0
      ],
      "bbox_max": [
        -310.97265625,
        1057.8154296875,
        76.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7745699286460876,
        0.4472425878047943,
        -0.44723090529441833
      ],
      "plane_d": -197.33912658691406,
      "bbox_min": [
        -315.0,
        1053.784423828125,
        75.0
      ],
      "bbox_max": [
        -310.97265625,
        1057.8154296875,
        76.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7745887041091919,
        -0.4471992552280426,
        -0.44724172353744507
      ],
      "plane_d": 261.66192626953125,
      "bbox_min": [
        -315.0,
        1053.784423828125,
        75.0
      ],
      "bbox_max": [
        -314.175048828125,
        1057.8154296875,
        76.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7745679020881653,
        0.4472414255142212,
        -0.4472355842590332
      ],
      "plane_d": -682.6824951171875,
      "bbox_min": [
        -315.0,
        1055.88671875,
        75.0
      ],
      "bbox_max": [
        -314.175048828125,
        1057.8154296875,
        76.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": -968.1423950195312,
      "bbox_min": [
        -315.0,
        1054.145263671875,
        76.0
      ],
      "bbox_max": [
        -311.62060546875,
        1057.53955078125,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071195244789124,
        0.7070940732955933,
        -0.0
      ],
      "plane_d": -524.9769897460938,
      "bbox_min": [
        -315.0,
        1054.145263671875,
        76.0
      ],
      "bbox_max": [
        -311.62060546875,
        1057.53955078125,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -3.7876685382798314e-05,
        -0.5156152844429016,
        0.8568202257156372
      ],
      "plane_d": 478.40325927734375,
      "bbox_min": [
        -315.0,
        1054.145263671875,
        76.0
      ],
      "bbox_max": [
        -311.691162109375,
        1055.80712890625,
        77.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.507815420627594,
        -0.010555896908044815,
        0.8614012598991394
      ],
      "plane_d": 103.94253540039062,
      "bbox_min": [
        -313.3529052734375,
        1054.145263671875,
        76.0
      ],
      "bbox_max": [
        -311.62060546875,
        1057.53955078125,
        77.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071195244789124,
        0.7070940732955933,
        -0.0
      ],
      "plane_d": -524.9769897460938,
      "bbox_min": [
        -315.0,
        1054.16015625,
        76.0
      ],
      "bbox_max": [
        -311.62060546875,
        1057.53955078125,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5078026056289673,
        -0.010574648156762123,
        0.861408531665802
      ],
      "plane_d": -214.28509521484375,
      "bbox_min": [
        -315.0,
        1054.16015625,
        76.0088119506836
      ],
      "bbox_max": [
        -313.3529052734375,
        1057.4542236328125,
        77.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.49991968274116516,
        0.8660717606544495
      ],
      "plane_d": -594.5062866210938,
      "bbox_min": [
        -315.0,
        1055.80712890625,
        76.0
      ],
      "bbox_max": [
        -311.62060546875,
        1057.53955078125,
        77.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8289903402328491,
        0.5592629313468933,
        0.0
      ],
      "plane_d": -844.8052978515625,
      "bbox_min": [
        -315.0,
        1051.800048828125,
        95.0
      ],
      "bbox_max": [
        -173.2484588623047,
        1130.9688720703125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20686249434947968,
        0.9783700108528137,
        0.0
      ],
      "plane_d": -1065.7515869140625,
      "bbox_min": [
        -197.011962890625,
        1125.9443359375,
        95.0
      ],
      "bbox_max": [
        -173.2484588623047,
        1130.9688720703125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1051.800048828125,
      "bbox_min": [
        -315.0,
        1051.800048828125,
        95.0
      ],
      "bbox_max": [
        -309.5,
        1051.800048828125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -314.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -157.92893981933594,
        1162.928955078125,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.46488767862319946,
        -0.30260810256004333,
        0.8320503234863281
      ],
      "plane_d": 170.66680908203125,
      "bbox_min": [
        -314.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -203.4488983154297,
        1142.73095703125,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5455361604690552,
        0.838087260723114,
        0.0
      ],
      "plane_d": -1064.5228271484375,
      "bbox_min": [
        -314.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -203.4488983154297,
        1137.7503662109375,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8380868434906006,
        -0.5455368757247925,
        0.0
      ],
      "plane_d": 420.17694091796875,
      "bbox_min": [
        -228.59152221679688,
        1115.0986328125,
        75.0
      ],
      "bbox_max": [
        -224.5,
        1121.38427734375,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 313.5,
      "bbox_min": [
        -314.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -313.5,
        1098.3555908203125,
        78.33777618408203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1097.6800537109375,
      "bbox_min": [
        -314.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -313.5,
        1098.3555908203125,
        78.33777618408203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -314.5,
      "bbox_min": [
        -314.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -313.5,
        1098.3555908203125,
        78.33777618408203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 421.1321105957031,
      "bbox_min": [
        -314.5,
        1097.6800537109375,
        78.0
      ],
      "bbox_max": [
        -313.5,
        1098.3555908203125,
        78.33777618408203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5455361604690552,
        0.838087260723114,
        0.0
      ],
      "plane_d": -1057.0228271484375,
      "bbox_min": [
        -226.1999969482422,
        1115.0986328125,
        95.0
      ],
      "bbox_max": [
        -197.011962890625,
        1131.4647216796875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20686249434947968,
        0.9783700108528137,
        0.0
      ],
      "plane_d": -1065.7515869140625,
      "bbox_min": [
        -199.3573760986328,
        1130.9688720703125,
        95.0
      ],
      "bbox_max": [
        -197.011962890625,
        1131.4647216796875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1121.7320556640625,
      "bbox_min": [
        -226.1999969482422,
        1118.2679443359375,
        95.0
      ],
      "bbox_max": [
        -222.0,
        1121.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1118.2679443359375,
      "bbox_min": [
        -226.1999969482422,
        1118.2679443359375,
        95.0
      ],
      "bbox_max": [
        -222.0,
        1121.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8551382422447205,
        0.5184000730514526,
        0.0
      ],
      "plane_d": -774.0403442382812,
      "bbox_min": [
        -226.1999969482422,
        1118.2679443359375,
        95.0
      ],
      "bbox_max": [
        -222.0,
        1121.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8551382422447205,
        -0.5184000730514526,
        -0.0
      ],
      "plane_d": 387.1758117675781,
      "bbox_min": [
        -226.1999969482422,
        1118.2679443359375,
        95.0
      ],
      "bbox_max": [
        -222.0,
        1121.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8551382422447205,
        0.5184000730514526,
        0.0
      ],
      "plane_d": -390.76739501953125,
      "bbox_min": [
        -223.0500030517578,
        1118.2679443359375,
        95.0
      ],
      "bbox_max": [
        -222.0,
        1121.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8551382422447205,
        -0.5184000730514526,
        0.0
      ],
      "plane_d": 770.4487915039062,
      "bbox_min": [
        -223.0500030517578,
        1118.2679443359375,
        95.0
      ],
      "bbox_max": [
        -222.0,
        1120.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -75.0,
      "bbox_min": [
        -312.68304443359375,
        1098.8271484375,
        60.0
      ],
      "bbox_max": [
        -154.99998474121094,
        1180.0001220703125,
        131.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.49999529123306274,
        -0.8660281300544739,
        0.0
      ],
      "plane_d": 1102.9556884765625,
      "bbox_min": [
        -277.2930908203125,
        1113.486328125,
        60.0
      ],
      "bbox_max": [
        -235.4326934814453,
        1140.2772216796875,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 70.0,
      "bbox_min": [
        -250.0,
        1130.6871337890625,
        60.0
      ],
      "bbox_max": [
        -238.3895263671875,
        1140.2772216796875,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660317063331604,
        0.4999890923500061,
        -0.0
      ],
      "plane_d": -350.9883728027344,
      "bbox_min": [
        -250.0,
        1130.6871337890625,
        60.0
      ],
      "bbox_max": [
        -238.3895263671875,
        1140.2772216796875,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660317063331604,
        -0.4999890923500061,
        -1.3214595355748315e-06
      ],
      "plane_d": 361.5083312988281,
      "bbox_min": [
        -240.88949584960938,
        1135.947021484375,
        60.0
      ],
      "bbox_max": [
        -238.3895263671875,
        1140.2772216796875,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 70.0,
      "bbox_min": [
        -277.2930908203125,
        1113.486328125,
        60.0
      ],
      "bbox_max": [
        -235.4326934814453,
        1135.947021484375,
        70.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660280108451843,
        -0.49999552965164185,
        -0.0
      ],
      "plane_d": 361.51641845703125,
      "bbox_min": [
        -238.3895263671875,
        1130.8255615234375,
        60.0
      ],
      "bbox_max": [
        -235.4326934814453,
        1135.947021484375,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        -312.68304443359375,
        1098.8271484375,
        75.0
      ],
      "bbox_max": [
        -154.99998474121094,
        1180.0001220703125,
        131.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -197.52635192871094,
        1150.5166015625,
        120.0
      ],
      "bbox_max": [
        -165.0,
        1177.071044921875,
        131.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        -0.9238786101341248,
        -0.0
      ],
      "plane_d": 1008.5560302734375,
      "bbox_min": [
        -175.0,
        1160.0,
        120.0
      ],
      "bbox_max": [
        -165.0,
        1177.071044921875,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        0.3826836347579956,
        0.0
      ],
      "plane_d": -609.4187622070312,
      "bbox_min": [
        -175.0,
        1162.928955078125,
        120.0
      ],
      "bbox_max": [
        -172.07107543945312,
        1177.071044921875,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        -0.3826836347579956,
        -0.0
      ],
      "plane_d": 286.0609436035156,
      "bbox_min": [
        -175.0,
        1162.928955078125,
        120.0
      ],
      "bbox_max": [
        -172.07107543945312,
        1170.0,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999967217445374,
        -0.8660256266593933,
        0.0
      ],
      "plane_d": 1107.4539794921875,
      "bbox_min": [
        -309.53204345703125,
        1100.646484375,
        75.0
      ],
      "bbox_max": [
        -154.99998474121094,
        1180.0001220703125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -78.0,
      "bbox_min": [
        -309.53204345703125,
        1100.646484375,
        75.0
      ],
      "bbox_max": [
        -186.54383850097656,
        1171.0762939453125,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8380868434906006,
        -0.5455368757247925,
        -0.0
      ],
      "plane_d": 420.1769714355469,
      "bbox_min": [
        -240.8894805908203,
        1139.8575439453125,
        75.0
      ],
      "bbox_max": [
        -240.61631774902344,
        1140.2772216796875,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8380868434906006,
        -0.5455368757247925,
        -0.0
      ],
      "plane_d": 420.1769714355469,
      "bbox_min": [
        -240.8894805908203,
        1139.8575439453125,
        78.0
      ],
      "bbox_max": [
        -240.61631774902344,
        1140.2772216796875,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5455361604690552,
        -0.838087260723114,
        0.0
      ],
      "plane_d": 1079.5657958984375,
      "bbox_min": [
        -240.61631774902344,
        1133.9915771484375,
        75.0
      ],
      "bbox_max": [
        -211.65533447265625,
        1150.357666015625,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8380868434906006,
        -0.5455368757247925,
        -0.0
      ],
      "plane_d": 420.1769714355469,
      "bbox_min": [
        -240.61631774902344,
        1133.9915771484375,
        75.0
      ],
      "bbox_max": [
        -236.79795837402344,
        1139.8575439453125,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        -0.9238786101341248,
        -0.0
      ],
      "plane_d": 1008.5560302734375,
      "bbox_min": [
        -238.1999969482422,
        1136.2679443359375,
        95.0
      ],
      "bbox_max": [
        -165.0,
        1177.071044921875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        0.3826836347579956,
        0.0
      ],
      "plane_d": -609.4187622070312,
      "bbox_min": [
        -175.0,
        1162.928955078125,
        95.0
      ],
      "bbox_max": [
        -172.07107543945312,
        1177.071044921875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238794445991516,
        -0.3826836347579956,
        -0.0
      ],
      "plane_d": 286.0609436035156,
      "bbox_min": [
        -175.0,
        1162.928955078125,
        95.0
      ],
      "bbox_max": [
        -172.07107543945312,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1139.7320556640625,
      "bbox_min": [
        -238.1999969482422,
        1136.2679443359375,
        95.0
      ],
      "bbox_max": [
        -234.0,
        1139.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1136.2679443359375,
      "bbox_min": [
        -238.1999969482422,
        1136.2679443359375,
        95.0
      ],
      "bbox_max": [
        -234.0,
        1139.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8551382422447205,
        0.5184000730514526,
        0.0
      ],
      "plane_d": -793.6332397460938,
      "bbox_min": [
        -238.1999969482422,
        1136.2679443359375,
        95.0
      ],
      "bbox_max": [
        -234.0,
        1139.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8551382422447205,
        -0.5184000730514526,
        -0.0
      ],
      "plane_d": 386.245361328125,
      "bbox_min": [
        -238.1999969482422,
        1136.2679443359375,
        95.0
      ],
      "bbox_max": [
        -234.0,
        1139.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8551382422447205,
        -0.5184000730514526,
        0.0
      ],
      "plane_d": 790.0416259765625,
      "bbox_min": [
        -235.0500030517578,
        1136.2679443359375,
        95.0
      ],
      "bbox_max": [
        -234.0,
        1139.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8551382422447205,
        0.5184000730514526,
        0.0
      ],
      "plane_d": -389.8369445800781,
      "bbox_min": [
        -235.0500030517578,
        1138.0,
        95.0
      ],
      "bbox_max": [
        -234.0,
        1139.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1050.0,
      "bbox_min": [
        -354.81549072265625,
        1040.0,
        60.0
      ],
      "bbox_max": [
        -315.0,
        1097.489501953125,
        250.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -75.0,
      "bbox_min": [
        -354.81549072265625,
        1050.0,
        60.0
      ],
      "bbox_max": [
        -315.0,
        1097.489501953125,
        215.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1051.800048828125,
      "bbox_min": [
        -343.4330749511719,
        1050.0,
        60.0
      ],
      "bbox_max": [
        -315.0,
        1096.7496337890625,
        75.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 330.0,
      "bbox_min": [
        -330.0,
        1050.0,
        60.0
      ],
      "bbox_max": [
        -320.0,
        1051.800048828125,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 70.0,
      "bbox_min": [
        -330.0,
        1050.0,
        60.0
      ],
      "bbox_max": [
        -320.0,
        1051.800048828125,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -320.0,
      "bbox_min": [
        -320.0,
        1050.0,
        60.0
      ],
      "bbox_max": [
        -320.0,
        1051.800048828125,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        5.406318450695835e-06,
        -1.0,
        0.0
      ],
      "plane_d": 1084.7513427734375,
      "bbox_min": [
        -343.4330749511719,
        1051.800048828125,
        60.0
      ],
      "bbox_max": [
        -315.0,
        1096.7496337890625,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -4.904671641270397e-06,
        1.0,
        0.0
      ],
      "plane_d": -1086.751220703125,
      "bbox_min": [
        -337.06640625,
        1084.74951171875,
        60.0
      ],
      "bbox_max": [
        -315.0,
        1096.7496337890625,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 73.0,
      "bbox_min": [
        -337.06640625,
        1084.74951171875,
        73.0
      ],
      "bbox_max": [
        -315.0,
        1086.7496337890625,
        73.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1096.7496337890625,
      "bbox_min": [
        -316.281494140625,
        1096.7496337890625,
        60.0
      ],
      "bbox_max": [
        -315.0,
        1096.7496337890625,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1061.800048828125,
      "bbox_min": [
        -343.4330749511719,
        1051.800048828125,
        60.0
      ],
      "bbox_max": [
        -315.0,
        1084.74951171875,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 73.0,
      "bbox_min": [
        -343.4330749511719,
        1061.800048828125,
        73.0
      ],
      "bbox_max": [
        -315.0,
        1084.74951171875,
        75.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.8289889097213745,
        -0.5592650771141052,
        -0.0
      ],
      "plane_d": 316.7933044433594,
      "bbox_min": [
        -343.4330749511719,
        1061.800048828125,
        73.0
      ],
      "bbox_max": [
        -315.0,
        1084.74951171875,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1063.800048828125,
      "bbox_min": [
        -343.4330749511719,
        1063.800048828125,
        73.0
      ],
      "bbox_max": [
        -315.0,
        1084.74951171875,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8289895057678223,
        0.5592641234397888,
        -0.0
      ],
      "plane_d": -318.7920837402344,
      "bbox_min": [
        -343.4330749511719,
        1063.800048828125,
        73.0
      ],
      "bbox_max": [
        -315.0,
        1084.74951171875,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660256266593933,
        0.4999995827674866,
        0.0
      ],
      "plane_d": -835.1766967773438,
      "bbox_min": [
        -343.4330749511719,
        1075.5106201171875,
        73.0
      ],
      "bbox_max": [
        -342.3205261230469,
        1077.4376220703125,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660268783569336,
        -0.49999746680259705,
        0.0
      ],
      "plane_d": 833.1748657226562,
      "bbox_min": [
        -342.3205261230469,
        1063.800048828125,
        73.0
      ],
      "bbox_max": [
        -315.0,
        1084.74951171875,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660256266593933,
        0.4999995827674866,
        0.0
      ],
      "plane_d": -835.1766967773438,
      "bbox_min": [
        -342.3205261230469,
        1077.4376220703125,
        73.0
      ],
      "bbox_max": [
        -338.6153259277344,
        1083.855224609375,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8289884924888611,
        0.5592656135559082,
        0.0
      ],
      "plane_d": -856.8075561523438,
      "bbox_min": [
        -315.8798522949219,
        1063.800048828125,
        73.0
      ],
      "bbox_max": [
        -315.0,
        1065.104248046875,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -332.0,
      "bbox_min": [
        -338.0,
        1051.800048828125,
        60.0
      ],
      "bbox_max": [
        -315.0,
        1061.800048828125,
        75.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -320.0,
      "bbox_min": [
        -332.0,
        1051.800048828125,
        60.0
      ],
      "bbox_max": [
        -315.0,
        1061.800048828125,
        75.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 318.0,
      "bbox_min": [
        -320.0,
        1051.800048828125,
        60.0
      ],
      "bbox_max": [
        -315.0,
        1061.800048828125,
        75.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1052.5,
      "bbox_min": [
        -320.0,
        1052.5,
        60.0
      ],
      "bbox_max": [
        -318.0,
        1061.800048828125,
        74.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 74.5,
      "bbox_min": [
        -320.0,
        1052.5,
        74.5
      ],
      "bbox_max": [
        -318.0,
        1061.800048828125,
        74.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -316.0,
      "bbox_min": [
        -316.0,
        1051.800048828125,
        64.0
      ],
      "bbox_max": [
        -315.0,
        1053.0,
        68.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1053.0,
      "bbox_min": [
        -316.0,
        1051.800048828125,
        64.0
      ],
      "bbox_max": [
        -315.0,
        1053.0,
        68.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -68.0,
      "bbox_min": [
        -316.0,
        1051.800048828125,
        64.0
      ],
      "bbox_max": [
        -315.0,
        1053.0,
        68.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 64.0,
      "bbox_min": [
        -316.0,
        1051.800048828125,
        64.0
      ],
      "bbox_max": [
        -315.0,
        1053.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 330.0,
      "bbox_min": [
        -332.0,
        1051.800048828125,
        60.0
      ],
      "bbox_max": [
        -330.0,
        1061.800048828125,
        75.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1052.5,
      "bbox_min": [
        -332.0,
        1052.5,
        60.0
      ],
      "bbox_max": [
        -330.0,
        1061.800048828125,
        74.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 74.5,
      "bbox_min": [
        -332.0,
        1052.5,
        74.5
      ],
      "bbox_max": [
        -330.0,
        1061.800048828125,
        74.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1053.0,
      "bbox_min": [
        -338.0,
        1051.800048828125,
        60.0
      ],
      "bbox_max": [
        -334.0,
        1053.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -68.0,
      "bbox_min": [
        -338.0,
        1051.800048828125,
        60.0
      ],
      "bbox_max": [
        -334.0,
        1053.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 64.0,
      "bbox_min": [
        -338.0,
        1051.800048828125,
        60.0
      ],
      "bbox_max": [
        -334.0,
        1053.0,
        68.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 334.0,
      "bbox_min": [
        -338.0,
        1051.800048828125,
        64.0
      ],
      "bbox_max": [
        -334.0,
        1053.0,
        68.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -338.0,
      "bbox_min": [
        -338.0,
        1051.800048828125,
        64.0
      ],
      "bbox_max": [
        -338.0,
        1053.0,
        68.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1052.5,
      "bbox_min": [
        -336.6000061035156,
        1051.800048828125,
        60.0
      ],
      "bbox_max": [
        -335.20001220703125,
        1052.5,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 335.20001220703125,
      "bbox_min": [
        -336.6000061035156,
        1051.800048828125,
        60.0
      ],
      "bbox_max": [
        -335.20001220703125,
        1052.5,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -336.6000061035156,
      "bbox_min": [
        -336.6000061035156,
        1051.800048828125,
        60.0
      ],
      "bbox_max": [
        -336.6000061035156,
        1052.5,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1052.5,
      "bbox_min": [
        -336.6000061035156,
        1051.800048828125,
        68.0
      ],
      "bbox_max": [
        -335.20001220703125,
        1052.5,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 335.20001220703125,
      "bbox_min": [
        -336.6000061035156,
        1051.800048828125,
        68.0
      ],
      "bbox_max": [
        -335.20001220703125,
        1052.5,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -336.6000061035156,
      "bbox_min": [
        -336.6000061035156,
        1051.800048828125,
        68.0
      ],
      "bbox_max": [
        -336.6000061035156,
        1052.5,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        -354.81549072265625,
        1050.0,
        75.0
      ],
      "bbox_max": [
        -315.0,
        1097.489501953125,
        215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 215.0,
      "bbox_min": [
        -330.0,
        1050.0,
        215.0
      ],
      "bbox_max": [
        -320.0,
        1051.800048828125,
        215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8289903402328491,
        0.5592629313468933,
        -0.0
      ],
      "plane_d": -306.7905578613281,
      "bbox_min": [
        -354.81549072265625,
        1050.0,
        75.0
      ],
      "bbox_max": [
        -315.0,
        1074.5020751953125,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1051.800048828125,
      "bbox_min": [
        -339.5,
        1050.0,
        75.0
      ],
      "bbox_max": [
        -315.0,
        1057.8154296875,
        120.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -320.0,
      "bbox_min": [
        -330.0,
        1050.0,
        75.0
      ],
      "bbox_max": [
        -320.0,
        1051.800048828125,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 85.0,
      "bbox_min": [
        -330.0,
        1050.0,
        75.0
      ],
      "bbox_max": [
        -320.0,
        1051.800048828125,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 330.0,
      "bbox_min": [
        -330.0,
        1050.0,
        75.0
      ],
      "bbox_max": [
        -330.0,
        1051.800048828125,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -332.0,
      "bbox_min": [
        -339.02734375,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -315.0,
        1057.8154296875,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 318.0,
      "bbox_min": [
        -332.0,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -315.0,
        1057.53955078125,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -320.0,
      "bbox_min": [
        -332.0,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -318.0,
        1053.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1053.0,
      "bbox_min": [
        -320.0,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -318.0,
        1053.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8575021624565125,
        0.5144803524017334
      ],
      "plane_d": -946.6806030273438,
      "bbox_min": [
        -320.0,
        1051.800048828125,
        85.0
      ],
      "bbox_max": [
        -318.0,
        1053.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 330.0,
      "bbox_min": [
        -332.0,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -330.0,
        1053.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1053.0,
      "bbox_min": [
        -332.0,
        1051.800048828125,
        75.0
      ],
      "bbox_max": [
        -330.0,
        1053.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8575021624565125,
        0.5144803524017334
      ],
      "plane_d": -946.6806030273438,
      "bbox_min": [
        -332.0,
        1051.800048828125,
        85.0
      ],
      "bbox_max": [
        -330.0,
        1053.0,
        87.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071195244789124,
        0.7070940732955933,
        -0.0
      ],
      "plane_d": -524.9769897460938,
      "bbox_min": [
        -315.62744140625,
        1054.1455078125,
        75.0
      ],
      "bbox_max": [
        -315.0,
        1057.53955078125,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": -968.1423950195312,
      "bbox_min": [
        -315.62744140625,
        1054.1455078125,
        75.0
      ],
      "bbox_max": [
        -315.0,
        1057.53955078125,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -3.7876685382798314e-05,
        -0.5156152844429016,
        0.8568202257156372
      ],
      "plane_d": 478.40325927734375,
      "bbox_min": [
        -315.0146484375,
        1054.1455078125,
        76.0
      ],
      "bbox_max": [
        -315.0,
        1054.16015625,
        76.0088119506836
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -76.0,
      "bbox_min": [
        -315.62744140625,
        1054.1455078125,
        75.0
      ],
      "bbox_max": [
        -315.0,
        1057.53955078125,
        76.04925537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7745887041091919,
        -0.4471992552280426,
        -0.44724172353744507
      ],
      "plane_d": 261.66192626953125,
      "bbox_min": [
        -315.62744140625,
        1054.7132568359375,
        75.0
      ],
      "bbox_max": [
        -315.0,
        1056.88671875,
        76.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7745679020881653,
        0.4472414255142212,
        -0.4472355842590332
      ],
      "plane_d": -682.6824951171875,
      "bbox_min": [
        -315.62744140625,
        1055.800048828125,
        75.0
      ],
      "bbox_max": [
        -315.0,
        1056.88671875,
        76.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5078026056289673,
        -0.010574648156762123,
        0.861408531665802
      ],
      "plane_d": -214.28509521484375,
      "bbox_min": [
        -315.0853271484375,
        1054.1455078125,
        76.0
      ],
      "bbox_max": [
        -315.0,
        1057.53955078125,
        76.04925537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.49991968274116516,
        0.8660717606544495
      ],
      "plane_d": -594.5062866210938,
      "bbox_min": [
        -315.0853271484375,
        1057.4542236328125,
        76.0
      ],
      "bbox_max": [
        -315.0,
        1057.53955078125,
        76.04925537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -76.0,
      "bbox_min": [
        -339.02734375,
        1053.784423828125,
        75.0
      ],
      "bbox_max": [
        -334.37255859375,
        1057.8154296875,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7745935320854187,
        -0.44718804955482483,
        -0.4472445547580719
      ],
      "plane_d": 243.5233612060547,
      "bbox_min": [
        -339.02734375,
        1053.784423828125,
        75.0
      ],
      "bbox_max": [
        -334.37255859375,
        1057.8154296875,
        76.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7746033668518066,
        -0.4471936821937561,
        -0.44722193479537964
      ],
      "plane_d": 765.14208984375,
      "bbox_min": [
        -339.02734375,
        1053.784423828125,
        75.0
      ],
      "bbox_max": [
        -334.37255859375,
        1057.8154296875,
        76.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": -912.150634765625,
      "bbox_min": [
        -339.02734375,
        1055.800048828125,
        75.0
      ],
      "bbox_max": [
        -334.37255859375,
        1057.8154296875,
        76.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7745686173439026,
        0.44724565744400024,
        -0.44723013043403625
      ],
      "plane_d": -179.21800231933594,
      "bbox_min": [
        -339.02734375,
        1055.800048828125,
        75.0
      ],
      "bbox_max": [
        -334.37255859375,
        1057.8154296875,
        76.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7745659351348877,
        0.4472441077232361,
        -0.4472363591194153
      ],
      "plane_d": -700.8094482421875,
      "bbox_min": [
        -339.02734375,
        1055.800048828125,
        75.0
      ],
      "bbox_max": [
        -337.574951171875,
        1057.8154296875,
        76.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071195244789124,
        -0.7070940732955933,
        0.0
      ],
      "plane_d": 984.6046752929688,
      "bbox_min": [
        -338.37939453125,
        1054.145263671875,
        76.0
      ],
      "bbox_max": [
        -334.9146728515625,
        1057.53955078125,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": -508.52301025390625,
      "bbox_min": [
        -338.37939453125,
        1054.145263671875,
        76.0
      ],
      "bbox_max": [
        -334.9146728515625,
        1057.53955078125,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.507815420627594,
        -0.010555896908044815,
        0.8614012598991394
      ],
      "plane_d": -226.1374969482422,
      "bbox_min": [
        -338.37939453125,
        1054.145263671875,
        76.0
      ],
      "bbox_max": [
        -336.6470947265625,
        1057.53955078125,
        77.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        5.489622978416264e-09,
        0.49991968274116516,
        0.8660717606544495
      ],
      "plane_d": -594.5062866210938,
      "bbox_min": [
        -338.37939453125,
        1055.80712890625,
        76.0
      ],
      "bbox_max": [
        -334.9146728515625,
        1057.53955078125,
        77.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": 508.52301025390625,
      "bbox_min": [
        -338.308837890625,
        1054.145263671875,
        76.0
      ],
      "bbox_max": [
        -334.9146728515625,
        1057.53955078125,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5078026056289673,
        -0.01057465560734272,
        0.861408531665802
      ],
      "plane_d": 115.78661346435547,
      "bbox_min": [
        -336.6470947265625,
        1054.1455078125,
        76.0
      ],
      "bbox_max": [
        -334.9146728515625,
        1057.53955078125,
        77.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.7876685382798314e-05,
        -0.5156152844429016,
        0.8568202257156372
      ],
      "plane_d": 478.4278869628906,
      "bbox_min": [
        -338.308837890625,
        1054.145263671875,
        76.0
      ],
      "bbox_max": [
        -334.9853515625,
        1055.80712890625,
        77.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 335.0,
      "bbox_min": [
        -335.0,
        1040.0,
        60.0
      ],
      "bbox_max": [
        -315.0,
        1050.0,
        250.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -75.0,
      "bbox_min": [
        -335.0,
        1040.0,
        60.0
      ],
      "bbox_max": [
        -315.0,
        1050.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -320.0,
      "bbox_min": [
        -330.0,
        1040.0,
        60.0
      ],
      "bbox_max": [
        -320.0,
        1050.0,
        70.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 330.0,
      "bbox_min": [
        -330.0,
        1040.0,
        60.0
      ],
      "bbox_max": [
        -320.0,
        1050.0,
        70.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 70.0,
      "bbox_min": [
        -330.0,
        1040.0,
        70.0
      ],
      "bbox_max": [
        -320.0,
        1050.0,
        70.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4999999701976776,
        0.8660255074501038,
        0.0
      ],
      "plane_d": -783.4539794921875,
      "bbox_min": [
        -1870.0,
        1074.5020751953125,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1430.0,
        250.00003051757812
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9952487945556641,
        0.09736471623182297,
        -0.0
      ],
      "plane_d": 494.5460205078125,
      "bbox_min": [
        -1870.0,
        1097.7781982421875,
        60.0
      ],
      "bbox_max": [
        -334.49993896484375,
        1430.0,
        250.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1850.0,
      "bbox_min": [
        -1870.0,
        1330.0,
        60.0
      ],
      "bbox_max": [
        -1850.0,
        1430.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9974586963653564,
        -0.0,
        0.07124704867601395
      ],
      "plane_d": 1831.0491943359375,
      "bbox_min": [
        -1853.5714111328125,
        1330.0,
        200.0
      ],
      "bbox_max": [
        -1850.0,
        1350.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1277.6927490234375,
      "bbox_min": [
        -528.278564453125,
        1097.7781982421875,
        60.0
      ],
      "bbox_max": [
        -334.49993896484375,
        1201.0435791015625,
        250.00001525878906
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -528.278564453125,
        1165.2540283203125,
        95.0
      ],
      "bbox_max": [
        -482.37957763671875,
        1201.0435791015625,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.41677308082580566,
        -0.24196134507656097,
        -0.8762162327766418
      ],
      "plane_d": 609.7070922851562,
      "bbox_min": [
        -528.278564453125,
        1165.2540283203125,
        95.0
      ],
      "bbox_max": [
        -482.37957763671875,
        1201.0435791015625,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9665451049804688,
        0.256496787071228,
        0.0
      ],
      "plane_d": 209.1320037841797,
      "bbox_min": [
        -528.278564453125,
        1165.2540283203125,
        95.0
      ],
      "bbox_max": [
        -482.37957763671875,
        1191.0435791015625,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -528.278564453125,
        1165.2540283203125,
        105.0
      ],
      "bbox_max": [
        -482.37957763671875,
        1191.0435791015625,
        131.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 105.0,
      "bbox_min": [
        -498.377685546875,
        1176.52978515625,
        105.0
      ],
      "bbox_max": [
        -497.0710754394531,
        1177.4537353515625,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -490.0,
        1160.8140869140625,
        95.0
      ],
      "bbox_max": [
        -443.68133544921875,
        1183.1566162109375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -490.0,
        1160.814208984375,
        125.24781799316406
      ],
      "bbox_max": [
        -443.6815490722656,
        1183.1566162109375,
        131.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -525.5997924804688,
        1142.4337158203125,
        95.0
      ],
      "bbox_max": [
        -497.0710754394531,
        1177.071044921875,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2419619858264923,
        0.41677382588386536,
        -0.8762156963348389
      ],
      "plane_d": -247.24679565429688,
      "bbox_min": [
        -525.5997924804688,
        1142.4337158203125,
        95.0
      ],
      "bbox_max": [
        -497.0710754394531,
        1177.071044921875,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5934197306632996,
        0.1574786901473999,
        -0.7893373966217041
      ],
      "plane_d": 223.11911010742188,
      "bbox_min": [
        -525.5997924804688,
        1142.4337158203125,
        95.0
      ],
      "bbox_max": [
        -497.0710754394531,
        1177.071044921875,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5020800828933716,
        0.8648211359977722,
        0.0
      ],
      "plane_d": -731.2279052734375,
      "bbox_min": [
        -521.0237426757812,
        1142.4337158203125,
        95.0
      ],
      "bbox_max": [
        -497.0710754394531,
        1177.071044921875,
        131.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -517.015869140625,
        1161.07666015625,
        95.0
      ],
      "bbox_max": [
        -497.0710754394531,
        1177.071044921875,
        131.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 105.0,
      "bbox_min": [
        -500.92388916015625,
        1170.0,
        105.0
      ],
      "bbox_max": [
        -497.0710754394531,
        1177.071044921875,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -511.4183044433594,
        1100.0,
        94.0
      ],
      "bbox_max": [
        -471.0050354003906,
        1170.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.34818652272224426,
        0.0,
        -0.9374252557754517
      ],
      "plane_d": 258.7293701171875,
      "bbox_min": [
        -490.0,
        1100.0,
        94.0
      ],
      "bbox_max": [
        -487.30767822265625,
        1110.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        -511.4183044433594,
        1100.0,
        95.0
      ],
      "bbox_max": [
        -471.0050354003906,
        1170.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.2419619858264923,
        0.41677382588386536,
        -0.8762156963348389
      ],
      "plane_d": -247.24679565429688,
      "bbox_min": [
        -511.4183044433594,
        1100.0,
        95.0
      ],
      "bbox_max": [
        -471.0050354003906,
        1170.0,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5020800828933716,
        0.8648211359977722,
        0.0
      ],
      "plane_d": -731.2279052734375,
      "bbox_min": [
        -511.4183044433594,
        1100.0,
        95.0
      ],
      "bbox_max": [
        -471.0050354003906,
        1170.0,
        131.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 500.0,
      "bbox_min": [
        -500.0,
        1100.0,
        95.0
      ],
      "bbox_max": [
        -471.0050354003906,
        1135.8046875,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34818652272224426,
        0.0,
        -0.9374252557754517
      ],
      "plane_d": 258.7293701171875,
      "bbox_min": [
        -500.0,
        1100.0,
        95.0
      ],
      "bbox_max": [
        -471.0050354003906,
        1135.8046875,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 105.0,
      "bbox_min": [
        -500.0,
        1120.0,
        105.0
      ],
      "bbox_max": [
        -490.0,
        1135.8046875,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -503.6961364746094,
        1155.42626953125,
        95.0
      ],
      "bbox_max": [
        -493.96337890625,
        1170.0,
        131.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5000006556510925,
        -0.8660250306129456,
        0.0
      ],
      "plane_d": 782.9531860351562,
      "bbox_min": [
        -424.6260986328125,
        1097.7781982421875,
        60.0
      ],
      "bbox_max": [
        -334.49993896484375,
        1141.04345703125,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -75.0,
      "bbox_min": [
        -409.6885070800781,
        1097.7781982421875,
        60.0
      ],
      "bbox_max": [
        -334.49993896484375,
        1141.04345703125,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660229444503784,
        0.500004231929779,
        0.0
      ],
      "plane_d": -914.2113647460938,
      "bbox_min": [
        -409.6875,
        1135.1617431640625,
        60.0
      ],
      "bbox_max": [
        -400.0,
        1141.04345703125,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660203218460083,
        -0.5000088214874268,
        2.6428842829773203e-06
      ],
      "plane_d": 925.1128540039062,
      "bbox_min": [
        -409.6875,
        1140.6104736328125,
        60.0
      ],
      "bbox_max": [
        -409.4375,
        1141.04345703125,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 335.5,
      "bbox_min": [
        -335.5,
        1097.7781982421875,
        75.0
      ],
      "bbox_max": [
        -335.5,
        1098.3555908203125,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1100.646484375,
      "bbox_min": [
        -409.6885070800781,
        1100.646484375,
        75.0
      ],
      "bbox_max": [
        -339.4679260253906,
        1141.04345703125,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648231029510498,
        -0.5020767450332642,
        0.0
      ],
      "plane_d": 926.982421875,
      "bbox_min": [
        -409.6885070800781,
        1140.611083984375,
        75.0
      ],
      "bbox_max": [
        -409.4375,
        1141.04345703125,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999987781047821,
        -0.8660261034965515,
        -0.0
      ],
      "plane_d": 778.4552001953125,
      "bbox_min": [
        -421.9375,
        1097.7781982421875,
        60.0
      ],
      "bbox_max": [
        -344.49957275390625,
        1140.6104736328125,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 70.0,
      "bbox_min": [
        -411.9375305175781,
        1131.2646484375,
        60.0
      ],
      "bbox_max": [
        -400.25,
        1140.6104736328125,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660203218460083,
        -0.5000088214874268,
        2.6428842829773203e-06
      ],
      "plane_d": 925.1128540039062,
      "bbox_min": [
        -411.9375305175781,
        1131.2646484375,
        60.0
      ],
      "bbox_max": [
        -400.25,
        1140.6104736328125,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660229444503784,
        0.500004231929779,
        0.0
      ],
      "plane_d": -914.2113647460938,
      "bbox_min": [
        -402.5,
        1131.2646484375,
        60.0
      ],
      "bbox_max": [
        -400.25,
        1135.1617431640625,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 70.0,
      "bbox_min": [
        -421.9375,
        1097.7781982421875,
        60.0
      ],
      "bbox_max": [
        -344.49957275390625,
        1136.71337890625,
        70.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4999987781047821,
        0.8660261034965515,
        -0.0
      ],
      "plane_d": -758.4552001953125,
      "bbox_min": [
        -421.9375,
        1097.7781982421875,
        60.0
      ],
      "bbox_max": [
        -384.4997253417969,
        1136.71337890625,
        70.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660266995429993,
        -0.4999977946281433,
        0.0
      ],
      "plane_d": 925.1030883789062,
      "bbox_min": [
        -421.9375,
        1119.392822265625,
        60.0
      ],
      "bbox_max": [
        -411.9375305175781,
        1136.71337890625,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999999403953552,
        0.866025447845459,
        0.0
      ],
      "plane_d": -753.4537963867188,
      "bbox_min": [
        -424.6260986328125,
        1097.7781982421875,
        75.0
      ],
      "bbox_max": [
        -336.5,
        1140.611083984375,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648231029510498,
        -0.5020767450332642,
        0.0
      ],
      "plane_d": 926.9824829101562,
      "bbox_min": [
        -424.6260986328125,
        1097.7781982421875,
        75.0
      ],
      "bbox_max": [
        -336.5,
        1140.611083984375,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5020793676376343,
        -0.8648215532302856,
        -0.0
      ],
      "plane_d": 773.7288208007812,
      "bbox_min": [
        -417.09478759765625,
        1134.5572509765625,
        75.0
      ],
      "bbox_max": [
        -413.2030944824219,
        1136.816650390625,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -336.5,
      "bbox_min": [
        -336.5,
        1097.7781982421875,
        75.0
      ],
      "bbox_max": [
        -336.5,
        1098.3555908203125,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        -500.0,
        1097.7781982421875,
        78.0
      ],
      "bbox_max": [
        -334.49993896484375,
        1180.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        -471.0050354003906,
        1100.0,
        120.0
      ],
      "bbox_max": [
        -445.0,
        1100.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -497.0710754394531,
        1122.90625,
        120.0
      ],
      "bbox_max": [
        -450.44464111328125,
        1177.071044921875,
        131.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.1574774533510208,
        0.5934208035469055,
        -0.7893368005752563
      ],
      "plane_d": -646.87548828125,
      "bbox_min": [
        -497.0710754394531,
        1122.90625,
        120.0
      ],
      "bbox_max": [
        -450.44464111328125,
        1177.071044921875,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        -0.9238786101341248,
        -0.0
      ],
      "plane_d": 884.1832275390625,
      "bbox_min": [
        -497.0710754394531,
        1160.0,
        120.0
      ],
      "bbox_max": [
        -480.0,
        1177.071044921875,
        131.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1259.215087890625,
      "bbox_min": [
        -490.0,
        1160.0,
        120.0
      ],
      "bbox_max": [
        -480.0,
        1177.071044921875,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": 891.2019653320312,
      "bbox_min": [
        -482.9289245605469,
        1162.928955078125,
        120.0
      ],
      "bbox_max": [
        -480.0,
        1177.071044921875,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238794445991516,
        0.3826836347579956,
        0.0
      ],
      "plane_d": -4.277719497680664,
      "bbox_min": [
        -482.9289245605469,
        1170.0,
        120.0
      ],
      "bbox_max": [
        -480.0,
        1177.071044921875,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -500.0,
        1097.7781982421875,
        78.0
      ],
      "bbox_max": [
        -335.5,
        1180.0,
        120.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -0.5020793676376343,
        -0.8648215532302856,
        -0.0
      ],
      "plane_d": 773.7288208007812,
      "bbox_min": [
        -446.6790466308594,
        1097.7781982421875,
        78.0
      ],
      "bbox_max": [
        -335.5,
        1149.61962890625,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648231029510498,
        -0.5020767450332642,
        0.0
      ],
      "plane_d": 926.982421875,
      "bbox_min": [
        -413.2030944824219,
        1097.7781982421875,
        78.0
      ],
      "bbox_max": [
        -335.5,
        1141.04345703125,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -336.5,
      "bbox_min": [
        -336.5,
        1097.7781982421875,
        78.0
      ],
      "bbox_max": [
        -335.5,
        1098.9329833984375,
        78.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -78.5,
      "bbox_min": [
        -336.5,
        1098.6800537109375,
        78.5
      ],
      "bbox_max": [
        -336.0618896484375,
        1098.9329833984375,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5020793676376343,
        0.8648215532302856,
        -0.0
      ],
      "plane_d": -758.7286987304688,
      "bbox_min": [
        -446.6790466308594,
        1115.0986328125,
        78.0
      ],
      "bbox_max": [
        -420.7344055175781,
        1136.647216796875,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648231029510498,
        -0.5020767450332642,
        0.0
      ],
      "plane_d": 926.9824829101562,
      "bbox_min": [
        -424.5,
        1115.0986328125,
        78.0
      ],
      "bbox_max": [
        -420.7344055175781,
        1121.5848388671875,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999999403953552,
        0.866025447845459,
        -0.0
      ],
      "plane_d": -753.4537963867188,
      "bbox_min": [
        -497.0710754394531,
        1097.7781982421875,
        95.0
      ],
      "bbox_max": [
        -394.5001220703125,
        1177.071044921875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2564944922924042,
        0.9665457010269165,
        0.0
      ],
      "plane_d": -1207.8887939453125,
      "bbox_min": [
        -481.35125732421875,
        1100.0,
        95.0
      ],
      "bbox_max": [
        -430.0,
        1130.134765625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        -475.1471862792969,
        1100.0,
        95.0
      ],
      "bbox_max": [
        -430.0,
        1121.160888671875,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 105.0,
      "bbox_min": [
        -455.0,
        1100.0,
        95.0
      ],
      "bbox_max": [
        -430.0,
        1121.160888671875,
        107.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 107.0,
      "bbox_min": [
        -455.0,
        1100.0,
        107.0
      ],
      "bbox_max": [
        -445.0,
        1110.0,
        107.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1115.0,
      "bbox_min": [
        -445.0,
        1105.0,
        95.0
      ],
      "bbox_max": [
        -430.0,
        1121.160888671875,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 435.0,
      "bbox_min": [
        -435.0,
        1115.0,
        95.0
      ],
      "bbox_max": [
        -430.0,
        1121.160888671875,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -430.0,
      "bbox_min": [
        -430.0,
        1115.0,
        95.0
      ],
      "bbox_max": [
        -430.0,
        1118.2740478515625,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1105.0,
      "bbox_min": [
        -445.0,
        1105.0,
        95.0
      ],
      "bbox_max": [
        -430.0,
        1115.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": -1088.9444580078125,
      "bbox_min": [
        -435.0,
        1105.0,
        95.0
      ],
      "bbox_max": [
        -430.0,
        1115.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -430.0,
      "bbox_min": [
        -430.0,
        1110.0,
        95.0
      ],
      "bbox_max": [
        -430.0,
        1115.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5020800828933716,
        0.8648211359977722,
        0.0
      ],
      "plane_d": -731.2279052734375,
      "bbox_min": [
        -481.35125732421875,
        1122.90625,
        95.0
      ],
      "bbox_max": [
        -477.7826843261719,
        1124.97802734375,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5020793676376343,
        0.8648215532302856,
        0.0
      ],
      "plane_d": -751.2286376953125,
      "bbox_min": [
        -497.0710754394531,
        1115.0986328125,
        95.0
      ],
      "bbox_max": [
        -411.8999938964844,
        1177.071044921875,
        120.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.2564944922924042,
        0.9665457010269165,
        0.0
      ],
      "plane_d": -1207.8887939453125,
      "bbox_min": [
        -450.54339599609375,
        1118.2740478515625,
        95.0
      ],
      "bbox_max": [
        -430.0,
        1130.1610107421875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 435.0,
      "bbox_min": [
        -435.0,
        1118.2740478515625,
        95.0
      ],
      "bbox_max": [
        -430.0,
        1121.1944580078125,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -430.0,
      "bbox_min": [
        -435.0,
        1118.2740478515625,
        95.0
      ],
      "bbox_max": [
        -430.0,
        1121.1944580078125,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 105.0,
      "bbox_min": [
        -435.0,
        1118.2740478515625,
        105.0
      ],
      "bbox_max": [
        -430.0,
        1121.1944580078125,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        -0.9238786101341248,
        -0.0
      ],
      "plane_d": 884.1832275390625,
      "bbox_min": [
        -497.0710754394531,
        1118.2679443359375,
        95.0
      ],
      "bbox_max": [
        -411.8999938964844,
        1177.071044921875,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1259.215087890625,
      "bbox_min": [
        -490.0,
        1137.2679443359375,
        95.0
      ],
      "bbox_max": [
        -411.8999938964844,
        1177.071044921875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": 891.2019653320312,
      "bbox_min": [
        -482.9289245605469,
        1162.928955078125,
        95.0
      ],
      "bbox_max": [
        -480.0,
        1177.071044921875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238794445991516,
        0.3826836347579956,
        0.0
      ],
      "plane_d": -4.277719497680664,
      "bbox_min": [
        -482.9289245605469,
        1170.0,
        95.0
      ],
      "bbox_max": [
        -480.0,
        1177.071044921875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.7320556640625,
      "bbox_min": [
        -416.1000061035156,
        1137.2679443359375,
        95.0
      ],
      "bbox_max": [
        -411.8999938964844,
        1140.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1137.2679443359375,
      "bbox_min": [
        -416.1000061035156,
        1137.2679443359375,
        95.0
      ],
      "bbox_max": [
        -411.8999938964844,
        1140.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.855134904384613,
        -0.518405556678772,
        0.0
      ],
      "plane_d": 942.6939697265625,
      "bbox_min": [
        -416.1000061035156,
        1137.2679443359375,
        95.0
      ],
      "bbox_max": [
        -411.8999938964844,
        1140.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.855134904384613,
        0.518405556678772,
        -0.0
      ],
      "plane_d": -238.23387145996094,
      "bbox_min": [
        -416.1000061035156,
        1137.2679443359375,
        95.0
      ],
      "bbox_max": [
        -411.8999938964844,
        1140.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8551415801048279,
        -0.5183945298194885,
        0.0
      ],
      "plane_d": 234.626953125,
      "bbox_min": [
        -416.1000061035156,
        1137.2679443359375,
        95.0
      ],
      "bbox_max": [
        -415.0500183105469,
        1140.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8551415801048279,
        0.5183945298194885,
        0.0
      ],
      "plane_d": -946.2757568359375,
      "bbox_min": [
        -416.1000061035156,
        1139.0,
        95.0
      ],
      "bbox_max": [
        -415.0500183105469,
        1140.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8551415801048279,
        0.5183945298194885,
        0.0
      ],
      "plane_d": -945.8328247070312,
      "bbox_min": [
        -435.0,
        1118.2679443359375,
        95.0
      ],
      "bbox_max": [
        -422.8999938964844,
        1121.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1121.7320556640625,
      "bbox_min": [
        -427.1000061035156,
        1118.2679443359375,
        95.0
      ],
      "bbox_max": [
        -422.8999938964844,
        1121.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1118.2679443359375,
      "bbox_min": [
        -427.1000061035156,
        1118.2679443359375,
        95.0
      ],
      "bbox_max": [
        -422.8999938964844,
        1121.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.855134904384613,
        0.518405556678772,
        -0.0
      ],
      "plane_d": -218.97767639160156,
      "bbox_min": [
        -427.1000061035156,
        1118.2679443359375,
        95.0
      ],
      "bbox_max": [
        -422.8999938964844,
        1121.7320556640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.855134904384613,
        -0.518405556678772,
        0.0
      ],
      "plane_d": 942.2507934570312,
      "bbox_min": [
        -427.1000061035156,
        1118.2679443359375,
        95.0
      ],
      "bbox_max": [
        -422.8999938964844,
        1120.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8551415801048279,
        -0.5183945298194885,
        0.0
      ],
      "plane_d": 215.3708953857422,
      "bbox_min": [
        -427.1000061035156,
        1118.2679443359375,
        95.0
      ],
      "bbox_max": [
        -426.0500183105469,
        1120.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 105.0,
      "bbox_min": [
        -435.0,
        1118.291748046875,
        105.0
      ],
      "bbox_max": [
        -430.0,
        1121.1944580078125,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -75.0,
      "bbox_min": [
        -394.5001220703125,
        1074.5020751953125,
        60.0
      ],
      "bbox_max": [
        -324.4999694824219,
        1097.7781982421875,
        120.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 70.0,
      "bbox_min": [
        -384.4997253417969,
        1074.5020751953125,
        60.0
      ],
      "bbox_max": [
        -332.7183532714844,
        1097.7781982421875,
        75.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660266995429993,
        -0.4999977946281433,
        0.0
      ],
      "plane_d": 845.1751098632812,
      "bbox_min": [
        -355.21795654296875,
        1074.5020751953125,
        70.0
      ],
      "bbox_max": [
        -332.7183532714844,
        1096.7496337890625,
        75.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8289903402328491,
        0.5592629313468933,
        -0.0
      ],
      "plane_d": -306.7905578613281,
      "bbox_min": [
        -355.21795654296875,
        1074.5020751953125,
        70.0
      ],
      "bbox_max": [
        -333.60223388671875,
        1086.74951171875,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660256266593933,
        0.4999995827674866,
        0.0
      ],
      "plane_d": -835.1766967773438,
      "bbox_min": [
        -338.6153259277344,
        1083.855224609375,
        73.0
      ],
      "bbox_max": [
        -333.60223388671875,
        1086.74951171875,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 73.0,
      "bbox_min": [
        -338.6153259277344,
        1083.855224609375,
        73.0
      ],
      "bbox_max": [
        -333.60223388671875,
        1086.74951171875,
        73.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4999987781047821,
        0.8660261034965515,
        -0.0
      ],
      "plane_d": -758.4552001953125,
      "bbox_min": [
        -384.4997253417969,
        1074.5020751953125,
        60.0
      ],
      "bbox_max": [
        -332.7183532714844,
        1097.7781982421875,
        70.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660219311714172,
        -0.5000059604644775,
        0.0
      ],
      "plane_d": 845.1822509765625,
      "bbox_min": [
        -355.21795654296875,
        1074.5020751953125,
        60.0
      ],
      "bbox_max": [
        -352.7178039550781,
        1079.428955078125,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999895691871643,
        -0.866025984287262,
        0.0
      ],
      "plane_d": 778.4550170898438,
      "bbox_min": [
        -344.49957275390625,
        1096.74951171875,
        60.0
      ],
      "bbox_max": [
        -342.71783447265625,
        1097.7781982421875,
        70.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        -394.5001220703125,
        1074.5020751953125,
        75.0
      ],
      "bbox_max": [
        -324.5,
        1097.7781982421875,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4999999403953552,
        0.866025447845459,
        -0.0
      ],
      "plane_d": -753.4537963867188,
      "bbox_min": [
        -394.5001220703125,
        1074.5020751953125,
        75.0
      ],
      "bbox_max": [
        -335.5,
        1097.7781982421875,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8289903402328491,
        0.5592629313468933,
        -0.0
      ],
      "plane_d": -306.7905578613281,
      "bbox_min": [
        -355.21795654296875,
        1074.5020751953125,
        75.0
      ],
      "bbox_max": [
        -354.81549072265625,
        1075.0986328125,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1097.6800537109375,
      "bbox_min": [
        -336.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -335.5,
        1097.7781982421875,
        78.04907989501953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 335.5,
      "bbox_min": [
        -336.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -335.5,
        1097.7781982421875,
        78.04907989501953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -336.5,
      "bbox_min": [
        -336.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -335.5,
        1097.7781982421875,
        78.04907989501953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 421.1321105957031,
      "bbox_min": [
        -336.5,
        1097.6800537109375,
        78.0
      ],
      "bbox_max": [
        -335.5,
        1097.7781982421875,
        78.04907989501953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8661856651306152,
        0.4997224807739258,
        0.0
      ],
      "plane_d": -362.76519775390625,
      "bbox_min": [
        -625.0554809570312,
        1092.0047607421875,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1430.0,
        250.00003051757812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 320.5,
      "bbox_min": [
        -625.0554809570312,
        1092.0047607421875,
        60.0
      ],
      "bbox_max": [
        -239.50550842285156,
        1430.0,
        250.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9700985550880432,
        -0.2427113950252533,
        0.0
      ],
      "plane_d": 924.297119140625,
      "bbox_min": [
        -625.0554809570312,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1430.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9863939881324768,
        -0.0,
        0.16439899802207947
      ],
      "plane_d": 512.9248657226562,
      "bbox_min": [
        -625.0554809570312,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1420.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9952487945556641,
        0.09736471623182297,
        -0.0
      ],
      "plane_d": 494.5460205078125,
      "bbox_min": [
        -625.0554809570312,
        1250.0,
        60.0
      ],
      "bbox_max": [
        -530.0,
        1309.916748046875,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        -550.0,
        1250.0,
        60.0
      ],
      "bbox_max": [
        -530.0,
        1250.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9863938689231873,
        0.16439898312091827
      ],
      "plane_d": 1380.951416015625,
      "bbox_min": [
        -540.0,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1420.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        -475.0,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1370.0,
        125.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.44721361994743347,
        0.0
      ],
      "plane_d": -867.5943603515625,
      "bbox_min": [
        -475.0,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -350.0,
        1370.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268592953681946,
        -0.9238784909248352,
        -0.0
      ],
      "plane_d": 1047.3109130859375,
      "bbox_min": [
        -475.0,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -422.9404602050781,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268592953681946,
        -0.9238784909248352,
        0.0
      ],
      "plane_d": 1391.728271484375,
      "bbox_min": [
        -475.0,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -425.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238791465759277,
        0.3826843202114105,
        0.0
      ],
      "plane_d": -122.06173706054688,
      "bbox_min": [
        -475.0,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -425.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238791465759277,
        -0.3826843202114105,
        0.0
      ],
      "plane_d": 907.3590087890625,
      "bbox_min": [
        -475.0,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -425.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -64.0,
      "bbox_min": [
        -475.0,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -425.0,
        1370.0,
        64.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.38268694281578064,
        -0.9238780736923218,
        0.0
      ],
      "plane_d": 1435.9219970703125,
      "bbox_min": [
        -472.835205078125,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -433.8530578613281,
        1367.835205078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268694281578064,
        -0.9238780736923218,
        -0.0
      ],
      "plane_d": 1091.50390625,
      "bbox_min": [
        -472.835205078125,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -433.8530578613281,
        1367.835205078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238791465759277,
        0.3826843202114105,
        0.0
      ],
      "plane_d": -77.86782836914062,
      "bbox_min": [
        -472.835205078125,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -466.1469421386719,
        1361.1468505859375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238791465759277,
        -0.3826843202114105,
        0.0
      ],
      "plane_d": 951.552978515625,
      "bbox_min": [
        -472.835205078125,
        1345.0,
        60.0
      ],
      "bbox_max": [
        -466.1469421386719,
        1361.1468505859375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123719215393066,
        0.35355281829833984,
        0.7071074843406677
      ],
      "plane_d": -221.48590087890625,
      "bbox_min": [
        -422.9655456542969,
        1239.0,
        60.00611877441406
      ],
      "bbox_max": [
        -422.9404602050781,
        1239.021728515625,
        60.02784729003906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -65.0,
      "bbox_min": [
        -340.0,
        1239.0,
        65.0
      ],
      "bbox_max": [
        -320.5,
        1270.0,
        85.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 80.0,
      "bbox_min": [
        -340.0,
        1239.0,
        80.0
      ],
      "bbox_max": [
        -320.5,
        1240.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1101.0794677734375,
      "bbox_min": [
        -513.3609008789062,
        1092.0047607421875,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1239.0,
        250.00001525878906
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -75.0,
      "bbox_min": [
        -340.21795654296875,
        1092.0047607421875,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1101.080078125,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.041748055286007e-05,
        -1.0,
        0.0
      ],
      "plane_d": 1096.7530517578125,
      "bbox_min": [
        -332.7183532714844,
        1096.74951171875,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1101.0794677734375,
        75.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -326.0,
      "bbox_min": [
        -331.0,
        1096.74951171875,
        64.0
      ],
      "bbox_max": [
        -320.5,
        1101.0794677734375,
        72.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 322.0,
      "bbox_min": [
        -322.0,
        1096.7496337890625,
        64.0
      ],
      "bbox_max": [
        -320.5,
        1101.0794677734375,
        72.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 181.7264404296875,
      "bbox_min": [
        -322.0,
        1096.7496337890625,
        64.0
      ],
      "bbox_max": [
        -320.5,
        1101.0794677734375,
        72.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 277.8929748535156,
      "bbox_min": [
        -322.0,
        1096.7496337890625,
        64.0
      ],
      "bbox_max": [
        -320.5,
        1101.0794677734375,
        72.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -64.0,
      "bbox_min": [
        -321.0,
        1096.7496337890625,
        64.0
      ],
      "bbox_max": [
        -320.5,
        1101.0794677734375,
        72.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 72.0,
      "bbox_min": [
        -321.0,
        1096.7496337890625,
        72.0
      ],
      "bbox_max": [
        -320.5,
        1101.0794677734375,
        72.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 331.0,
      "bbox_min": [
        -331.0,
        1096.74951171875,
        64.0
      ],
      "bbox_max": [
        -326.0,
        1101.0794677734375,
        72.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -64.0,
      "bbox_min": [
        -331.0,
        1096.74951171875,
        64.0
      ],
      "bbox_max": [
        -326.0,
        1101.0794677734375,
        72.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 72.0,
      "bbox_min": [
        -331.0,
        1096.74951171875,
        64.0
      ],
      "bbox_max": [
        -326.0,
        1101.0794677734375,
        72.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -276.478759765625,
      "bbox_min": [
        -331.0,
        1096.74951171875,
        64.0
      ],
      "bbox_max": [
        -326.0,
        1101.0794677734375,
        72.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.0,
        -0.7071067690849304
      ],
      "plane_d": -180.31222534179688,
      "bbox_min": [
        -331.0,
        1096.74951171875,
        64.0
      ],
      "bbox_max": [
        -326.0,
        1101.0794677734375,
        72.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 284.2569274902344,
      "bbox_min": [
        -331.0,
        1096.74951171875,
        64.0
      ],
      "bbox_max": [
        -330.0,
        1101.0794677734375,
        72.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 188.09039306640625,
      "bbox_min": [
        -331.0,
        1096.74951171875,
        64.0
      ],
      "bbox_max": [
        -330.0,
        1101.0794677734375,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        -340.21795654296875,
        1092.0047607421875,
        75.0
      ],
      "bbox_max": [
        -320.5,
        1101.080078125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 327.5,
      "bbox_min": [
        -340.21795654296875,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -321.5,
        1101.080078125,
        78.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 335.5,
      "bbox_min": [
        -340.21795654296875,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -327.5,
        1101.080078125,
        78.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -336.5,
      "bbox_min": [
        -340.21795654296875,
        1098.3555908203125,
        75.0
      ],
      "bbox_max": [
        -335.5,
        1101.080078125,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -78.5,
      "bbox_min": [
        -336.5,
        1098.3555908203125,
        78.33779907226562
      ],
      "bbox_max": [
        -335.5,
        1101.080078125,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 421.1321105957031,
      "bbox_min": [
        -336.0618896484375,
        1098.3555908203125,
        78.33779907226562
      ],
      "bbox_max": [
        -335.5,
        1098.6800537109375,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1100.646484375,
      "bbox_min": [
        -340.21795654296875,
        1100.646484375,
        75.0
      ],
      "bbox_max": [
        -336.5,
        1101.0794677734375,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -78.0,
      "bbox_min": [
        -340.21795654296875,
        1100.646484375,
        78.0
      ],
      "bbox_max": [
        -336.5,
        1101.0794677734375,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1097.6800537109375,
      "bbox_min": [
        -328.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -327.5,
        1101.080078125,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -78.5,
      "bbox_min": [
        -328.5,
        1097.6800537109375,
        78.0
      ],
      "bbox_max": [
        -327.5,
        1101.080078125,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 421.1321105957031,
      "bbox_min": [
        -328.5,
        1097.6800537109375,
        78.0
      ],
      "bbox_max": [
        -327.5,
        1098.6800537109375,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -322.5,
      "bbox_min": [
        -327.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -321.5,
        1101.080078125,
        78.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 321.5,
      "bbox_min": [
        -322.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -321.5,
        1101.080078125,
        78.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1097.6800537109375,
      "bbox_min": [
        -322.5,
        1097.6800537109375,
        75.0
      ],
      "bbox_max": [
        -321.5,
        1101.080078125,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -78.5,
      "bbox_min": [
        -322.5,
        1097.6800537109375,
        78.0
      ],
      "bbox_max": [
        -321.5,
        1101.080078125,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 421.1321105957031,
      "bbox_min": [
        -322.5,
        1097.6800537109375,
        78.0
      ],
      "bbox_max": [
        -321.5,
        1098.6800537109375,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1100.646484375,
      "bbox_min": [
        -327.5,
        1100.646484375,
        75.0
      ],
      "bbox_max": [
        -322.5,
        1101.0794677734375,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -78.0,
      "bbox_min": [
        -327.5,
        1100.646484375,
        78.0
      ],
      "bbox_max": [
        -322.5,
        1101.0794677734375,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -233.222412109375,
      "bbox_min": [
        -513.3609008789062,
        1101.0794677734375,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1239.0,
        250.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -513.3609008789062,
        1123.759033203125,
        60.0
      ],
      "bbox_max": [
        -379.5000915527344,
        1208.5478515625,
        131.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.8648214340209961,
        -0.5020795464515686,
        0.0
      ],
      "plane_d": 926.9849243164062,
      "bbox_min": [
        -409.4375,
        1141.04345703125,
        60.0
      ],
      "bbox_max": [
        -399.43072509765625,
        1158.2799072265625,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5020797848701477,
        -0.8648213148117065,
        0.0
      ],
      "plane_d": 801.2283935546875,
      "bbox_min": [
        -513.3609008789062,
        1141.04345703125,
        95.0
      ],
      "bbox_max": [
        -409.4375,
        1208.5478515625,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24196197092533112,
        -0.4167741537094116,
        -0.8762155771255493
      ],
      "plane_d": 491.27337646484375,
      "bbox_min": [
        -513.3609008789062,
        1141.04345703125,
        95.0
      ],
      "bbox_max": [
        -409.4375,
        1208.5478515625,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5020793676376343,
        -0.8648215532302856,
        0.0
      ],
      "plane_d": 781.2288818359375,
      "bbox_min": [
        -513.3609008789062,
        1141.04345703125,
        95.0
      ],
      "bbox_max": [
        -409.4375,
        1208.5478515625,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2564944922924042,
        -0.9665457010269165,
        0.0
      ],
      "plane_d": 1292.7418212890625,
      "bbox_min": [
        -513.216064453125,
        1156.1058349609375,
        95.0
      ],
      "bbox_max": [
        -435.38214111328125,
        1208.5478515625,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9665453433990479,
        -0.25649577379226685,
        -0.0
      ],
      "plane_d": -124.28031921386719,
      "bbox_min": [
        -513.216064453125,
        1156.1058349609375,
        95.0
      ],
      "bbox_max": [
        -435.38214111328125,
        1208.5478515625,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15747740864753723,
        -0.5934206247329712,
        -0.7893369793891907
      ],
      "plane_d": 888.4124755859375,
      "bbox_min": [
        -513.216064453125,
        1156.1058349609375,
        120.0
      ],
      "bbox_max": [
        -435.38214111328125,
        1208.5478515625,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5934202671051025,
        -0.1574781984090805,
        -0.7893370985984802
      ],
      "plane_d": 18.417329788208008,
      "bbox_min": [
        -452.6785583496094,
        1156.1058349609375,
        120.0
      ],
      "bbox_max": [
        -435.38214111328125,
        1183.44384765625,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -513.3609008789062,
        1141.04345703125,
        95.0
      ],
      "bbox_max": [
        -409.4375,
        1201.2930908203125,
        131.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        -513.3609008789062,
        1141.04345703125,
        95.0
      ],
      "bbox_max": [
        -409.4375,
        1201.2930908203125,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4167734682559967,
        0.24196158349514008,
        -0.8762159943580627
      ],
      "plane_d": -356.0429992675781,
      "bbox_min": [
        -452.7389221191406,
        1156.04345703125,
        120.0
      ],
      "bbox_max": [
        -435.38214111328125,
        1166.1474609375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648213148117065,
        -0.5020797848701477,
        0.0
      ],
      "plane_d": 1046.985107421875,
      "bbox_min": [
        -513.3609008789062,
        1201.0435791015625,
        95.0
      ],
      "bbox_max": [
        -513.216064453125,
        1201.2930908203125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 95.0,
      "bbox_min": [
        -434.5,
        1101.0794677734375,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1239.0,
        125.006103515625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.8661860823631287,
        0.49972158670425415,
        0.0
      ],
      "plane_d": -924.9188232421875,
      "bbox_min": [
        -399.5,
        1121.5426025390625,
        60.0
      ],
      "bbox_max": [
        -355.11932373046875,
        1178.4134521484375,
        80.00614929199219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648214340209961,
        -0.5020795464515686,
        0.0
      ],
      "plane_d": 926.9849243164062,
      "bbox_min": [
        -399.43072509765625,
        1121.5426025390625,
        60.0
      ],
      "bbox_max": [
        -355.11932373046875,
        1178.2305908203125,
        80.00614929199219
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6473184823989868,
        0.7622196674346924,
        0.0
      ],
      "plane_d": -1121.38330078125,
      "bbox_min": [
        -388.82049560546875,
        1121.5426025390625,
        60.0
      ],
      "bbox_max": [
        -355.11932373046875,
        1147.25,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -64.0,
      "bbox_min": [
        -388.82049560546875,
        1121.5426025390625,
        60.0
      ],
      "bbox_max": [
        -355.11932373046875,
        1147.25,
        64.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.11961036920547485,
        -0.9928209185600281,
        0.0
      ],
      "plane_d": 1180.7080078125,
      "bbox_min": [
        -388.82049560546875,
        1121.5426025390625,
        60.0
      ],
      "bbox_max": [
        -355.11932373046875,
        1147.25,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3195746839046478,
        0.9475610852241516,
        -0.0
      ],
      "plane_d": -967.675537109375,
      "bbox_min": [
        -373.6650695800781,
        1145.6988525390625,
        60.0
      ],
      "bbox_max": [
        -369.06597900390625,
        1147.25,
        63.2073974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.319561243057251,
        -0.9475656151771545,
        0.0
      ],
      "plane_d": 964.6857299804688,
      "bbox_min": [
        -388.82049560546875,
        1121.5426025390625,
        60.0
      ],
      "bbox_max": [
        -355.11932373046875,
        1144.1903076171875,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6473259925842285,
        -0.7622132897377014,
        0.0
      ],
      "plane_d": 1118.37890625,
      "bbox_min": [
        -388.82049560546875,
        1121.5426025390625,
        60.0
      ],
      "bbox_max": [
        -355.11932373046875,
        1143.284912109375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000129342079163,
        -0.8660179376602173,
        0.0
      ],
      "plane_d": 793.711181640625,
      "bbox_min": [
        -388.82049560546875,
        1139.4071044921875,
        60.0
      ],
      "bbox_max": [
        -386.0616149902344,
        1141.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000129342079163,
        -0.8660179376602173,
        -0.0
      ],
      "plane_d": 793.7117919921875,
      "bbox_min": [
        -356.9383850097656,
        1121.5426025390625,
        60.0
      ],
      "bbox_max": [
        -355.11932373046875,
        1124.18896484375,
        61.05021667480469
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9837608337402344,
        0.17948433756828308,
        0.0
      ],
      "plane_d": -552.6298217773438,
      "bbox_min": [
        -356.9383850097656,
        1122.5928955078125,
        60.0
      ],
      "bbox_max": [
        -356.6471862792969,
        1124.18896484375,
        61.05021667480469
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8661852478981018,
        0.4997231066226959,
        0.0
      ],
      "plane_d": -924.920166015625,
      "bbox_min": [
        -399.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1239.0,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1200.361328125,
      "bbox_min": [
        -399.43072509765625,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1239.0,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 80.0,
      "bbox_min": [
        -369.5,
        1200.361328125,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1239.0,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 75.0,
      "bbox_min": [
        -340.0,
        1200.361328125,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1210.4000244140625,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        -340.0,
        1200.361328125,
        60.0
      ],
      "bbox_max": [
        -340.0,
        1210.4000244140625,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1230.0,
      "bbox_min": [
        -355.0,
        1210.4000244140625,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1239.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.44721361994743347,
        0.0
      ],
      "plane_d": -867.5943603515625,
      "bbox_min": [
        -355.0,
        1230.0,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1239.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        -340.0,
        1230.0,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1239.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1235.0,
      "bbox_min": [
        -340.0,
        1235.0,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1239.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -64.99999237060547,
      "bbox_min": [
        -340.0,
        1235.0,
        65.0
      ],
      "bbox_max": [
        -320.5,
        1239.0,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826870620250702,
        0.9238780736923218,
        0.0
      ],
      "plane_d": -1254.538818359375,
      "bbox_min": [
        -350.0,
        1210.4000244140625,
        60.0
      ],
      "bbox_max": [
        -340.0,
        1215.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9060451984405518,
        0.4231809079647064,
        -0.0
      ],
      "plane_d": -204.16278076171875,
      "bbox_min": [
        -350.0,
        1210.4000244140625,
        60.0
      ],
      "bbox_max": [
        -340.0,
        1213.5355224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9060451984405518,
        0.4231809079647064,
        0.0
      ],
      "plane_d": -829.333984375,
      "bbox_min": [
        -350.0,
        1210.4000244140625,
        60.0
      ],
      "bbox_max": [
        -348.5355224609375,
        1213.5355224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648214340209961,
        -0.5020795464515686,
        0.0
      ],
      "plane_d": 926.9849243164062,
      "bbox_min": [
        -399.43072509765625,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1200.361328125,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1147.0,
      "bbox_min": [
        -377.73565673828125,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1187.7750244140625,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -329.5,
      "bbox_min": [
        -374.43597412109375,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1147.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        -329.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1140.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -322.5,
      "bbox_min": [
        -329.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1125.5,
        78.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 321.5,
      "bbox_min": [
        -322.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1125.5,
        78.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -0.5827085971832275,
        -0.8126811981201172
      ],
      "plane_d": 702.5599365234375,
      "bbox_min": [
        -322.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -321.5,
        1125.5,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5827085971832275,
        0.8126811981201172
      ],
      "plane_d": -705.404296875,
      "bbox_min": [
        -322.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -321.5,
        1125.5,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1125.5,
      "bbox_min": [
        -322.5,
        1125.5,
        60.0
      ],
      "bbox_max": [
        -321.5,
        1125.5,
        60.99046325683594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -63.5,
      "bbox_min": [
        -322.5,
        1122.0,
        60.99046325683594
      ],
      "bbox_max": [
        -321.5,
        1125.5,
        63.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1125.5,
      "bbox_min": [
        -322.5,
        1124.5,
        60.99046325683594
      ],
      "bbox_max": [
        -321.5,
        1125.5,
        63.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": -559.6878051757812,
      "bbox_min": [
        -322.5,
        1124.5,
        63.0
      ],
      "bbox_max": [
        -321.5,
        1125.5,
        63.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5827085971832275,
        0.8126811981201172
      ],
      "plane_d": -702.5599365234375,
      "bbox_min": [
        -321.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1122.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5785005688667297,
        -0.8156819939613342
      ],
      "plane_d": 695.7045288085938,
      "bbox_min": [
        -321.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1118.0,
        72.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -328.5,
      "bbox_min": [
        -329.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -327.5,
        1125.5,
        78.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 327.5,
      "bbox_min": [
        -328.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -327.5,
        1125.5,
        78.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.5827085971832275,
        -0.8126811981201172
      ],
      "plane_d": 702.5599365234375,
      "bbox_min": [
        -328.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -327.5,
        1125.5,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5827085971832275,
        0.8126811981201172
      ],
      "plane_d": -705.404296875,
      "bbox_min": [
        -328.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -327.5,
        1125.5,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1125.5,
      "bbox_min": [
        -328.5,
        1125.5,
        60.0
      ],
      "bbox_max": [
        -327.5,
        1125.5,
        60.99046325683594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -63.5,
      "bbox_min": [
        -328.5,
        1122.0,
        60.99046325683594
      ],
      "bbox_max": [
        -327.5,
        1125.5,
        63.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1125.5,
      "bbox_min": [
        -328.5,
        1124.5,
        60.99046325683594
      ],
      "bbox_max": [
        -327.5,
        1125.5,
        63.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": -559.6878051757812,
      "bbox_min": [
        -328.5,
        1124.5,
        63.0
      ],
      "bbox_max": [
        -327.5,
        1125.5,
        63.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5827085971832275,
        0.8126811981201172
      ],
      "plane_d": -702.5599365234375,
      "bbox_min": [
        -329.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -328.5,
        1122.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5785005688667297,
        -0.8156819939613342
      ],
      "plane_d": 695.7045288085938,
      "bbox_min": [
        -329.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -328.5,
        1118.0,
        72.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5827085971832275,
        0.8126811981201172
      ],
      "plane_d": -702.5599365234375,
      "bbox_min": [
        -374.43597412109375,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -329.5,
        1147.0,
        78.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -335.5,
      "bbox_min": [
        -355.4501647949219,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -329.5,
        1122.0001220703125,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5785005688667297,
        -0.8156819939613342
      ],
      "plane_d": 695.7045288085938,
      "bbox_min": [
        -335.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -329.5,
        1118.0,
        72.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000129342079163,
        -0.8660179376602173,
        -0.0
      ],
      "plane_d": 793.7117919921875,
      "bbox_min": [
        -355.4501647949219,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -353.9970397949219,
        1122.0001220703125,
        60.71708679199219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9837599992752075,
        -0.17948898673057556,
        0.0
      ],
      "plane_d": 549.634765625,
      "bbox_min": [
        -354.17950439453125,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -353.9970397949219,
        1122.0001220703125,
        60.71708679199219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -336.5,
      "bbox_min": [
        -374.43597412109375,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -329.5,
        1147.0,
        78.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 335.5,
      "bbox_min": [
        -336.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -329.5,
        1147.0,
        78.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.5827085971832275,
        0.8126811981201172
      ],
      "plane_d": -705.404296875,
      "bbox_min": [
        -336.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -335.5,
        1147.0,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1125.5,
      "bbox_min": [
        -336.5,
        1125.5,
        60.0
      ],
      "bbox_max": [
        -335.5,
        1125.5,
        60.99046325683594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        -336.5,
        1122.0,
        60.0
      ],
      "bbox_max": [
        -335.5,
        1147.0,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -70.0,
      "bbox_min": [
        -336.5,
        1140.0,
        70.0
      ],
      "bbox_max": [
        -335.5,
        1147.0,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -63.5,
      "bbox_min": [
        -336.5,
        1122.0,
        60.99046325683594
      ],
      "bbox_max": [
        -335.5,
        1125.5,
        63.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1125.5,
      "bbox_min": [
        -336.5,
        1124.5,
        60.99046325683594
      ],
      "bbox_max": [
        -335.5,
        1125.5,
        63.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": -559.6878051757812,
      "bbox_min": [
        -336.5,
        1124.5,
        63.0
      ],
      "bbox_max": [
        -335.5,
        1125.5,
        63.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        -335.5,
        1140.0,
        60.0
      ],
      "bbox_max": [
        -329.5,
        1147.0,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -70.0,
      "bbox_min": [
        -335.5,
        1140.0,
        70.0
      ],
      "bbox_max": [
        -329.5,
        1147.0,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -344.0,
      "bbox_min": [
        -374.43597412109375,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -336.5,
        1147.0,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        -344.0,
        1140.0,
        60.0
      ],
      "bbox_max": [
        -336.5,
        1147.0,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -70.0,
      "bbox_min": [
        -344.0,
        1140.0,
        70.0
      ],
      "bbox_max": [
        -336.5,
        1147.0,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.660825788974762,
        0.7505393624305725,
        -0.0
      ],
      "plane_d": -618.0692138671875,
      "bbox_min": [
        -374.43597412109375,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -352.75,
        1147.0,
        66.5999984741211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -64.0,
      "bbox_min": [
        -374.43597412109375,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -352.75,
        1147.0,
        66.5999984741211
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.3195746839046478,
        0.9475610852241516,
        -0.0
      ],
      "plane_d": -967.675537109375,
      "bbox_min": [
        -372.923828125,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -352.75,
        1147.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9837599992752075,
        -0.17948898673057556,
        0.0
      ],
      "plane_d": 549.634765625,
      "bbox_min": [
        -372.53173828125,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -352.75,
        1143.7017822265625,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9196160435676575,
        -0.3928183913230896,
        0.0
      ],
      "plane_d": 116.0325927734375,
      "bbox_min": [
        -372.53173828125,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -354.17950439453125,
        1143.7017822265625,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.319561243057251,
        -0.9475656151771545,
        0.0
      ],
      "plane_d": 964.6857299804688,
      "bbox_min": [
        -372.53173828125,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -354.17950439453125,
        1143.7017822265625,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9837608337402344,
        0.17948433756828308,
        0.0
      ],
      "plane_d": -552.6298217773438,
      "bbox_min": [
        -356.9383850097656,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -354.17950439453125,
        1128.486083984375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000129342079163,
        -0.8660179376602173,
        -0.0
      ],
      "plane_d": 793.7117919921875,
      "bbox_min": [
        -356.9383850097656,
        1121.0,
        60.191009521484375
      ],
      "bbox_max": [
        -354.17950439453125,
        1122.5928955078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6691088676452637,
        -0.7431643605232239,
        0.0
      ],
      "plane_d": 603.8948974609375,
      "bbox_min": [
        -364.53131103515625,
        1139.4674072265625,
        63.999996185302734
      ],
      "bbox_max": [
        -361.30523681640625,
        1142.73779296875,
        66.5999984741211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7431347966194153,
        0.6691417694091797,
        0.0
      ],
      "plane_d": -1034.256591796875,
      "bbox_min": [
        -364.53131103515625,
        1139.4674072265625,
        63.999996185302734
      ],
      "bbox_max": [
        -361.30523681640625,
        1142.73779296875,
        66.5999984741211
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7431074380874634,
        -0.6691721081733704,
        0.0
      ],
      "plane_d": 1032.28125,
      "bbox_min": [
        -364.53131103515625,
        1139.4674072265625,
        63.999996185302734
      ],
      "bbox_max": [
        -361.30523681640625,
        1142.73779296875,
        66.5999984741211
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6691535115242004,
        0.7431241869926453,
        -0.0
      ],
      "plane_d": -606.432861328125,
      "bbox_min": [
        -364.53131103515625,
        1139.4674072265625,
        63.999996185302734
      ],
      "bbox_max": [
        -361.30523681640625,
        1142.73779296875,
        66.5999984741211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -66.5999984741211,
      "bbox_min": [
        -364.53131103515625,
        1139.4674072265625,
        63.999996185302734
      ],
      "bbox_max": [
        -361.30523681640625,
        1142.73779296875,
        66.5999984741211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6689731478691101,
        -0.7432865500450134,
        -0.0
      ],
      "plane_d": 605.083740234375,
      "bbox_min": [
        -364.53131103515625,
        1139.4674072265625,
        63.999996185302734
      ],
      "bbox_max": [
        -361.30523681640625,
        1142.73779296875,
        64.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7429677248001099,
        0.6693272590637207,
        0.0
      ],
      "plane_d": -1033.6075439453125,
      "bbox_min": [
        -363.8622741699219,
        1140.2108154296875,
        63.999996185302734
      ],
      "bbox_max": [
        -361.30523681640625,
        1142.73779296875,
        64.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13124099373817444,
        0.14574885368347168,
        -0.9805779457092285
      ],
      "plane_d": -55.2020378112793,
      "bbox_min": [
        -363.267578125,
        1140.2108154296875,
        63.999996185302734
      ],
      "bbox_max": [
        -361.30523681640625,
        1142.2021484375,
        64.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6692008376121521,
        0.7430815696716309,
        0.0
      ],
      "plane_d": -605.1670532226562,
      "bbox_min": [
        -362.9999084472656,
        1141.0430908203125,
        64.7599868774414
      ],
      "bbox_max": [
        -362.7027893066406,
        1141.3106689453125,
        64.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47313380241394043,
        0.525486409664154,
        0.707112729549408
      ],
      "plane_d": -473.5337829589844,
      "bbox_min": [
        -362.9999084472656,
        1140.4783935546875,
        63.999996185302734
      ],
      "bbox_max": [
        -362.1378479003906,
        1141.60791015625,
        64.7599868774414
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5255210399627686,
        -0.47310927510261536,
        0.707103431224823
      ],
      "plane_d": 684.9085693359375,
      "bbox_min": [
        -362.97027587890625,
        1140.4783935546875,
        63.999996185302734
      ],
      "bbox_max": [
        -362.1378479003906,
        1141.07275390625,
        64.69998168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7431954741477966,
        -0.6690743565559387,
        0.0
      ],
      "plane_d": 1033.001708984375,
      "bbox_min": [
        -362.97027587890625,
        1140.7459716796875,
        64.4000015258789
      ],
      "bbox_max": [
        -362.7027893066406,
        1141.0430908203125,
        64.69998168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6692008376121521,
        0.7430815696716309,
        0.0
      ],
      "plane_d": -605.1670532226562,
      "bbox_min": [
        -362.9999084472656,
        1140.8201904296875,
        64.4000015258789
      ],
      "bbox_max": [
        -362.7027893066406,
        1141.3106689453125,
        64.7599868774414
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7431954741477966,
        -0.6690743565559387,
        0.0
      ],
      "plane_d": 1033.001708984375,
      "bbox_min": [
        -362.90350341796875,
        1140.8201904296875,
        64.4000015258789
      ],
      "bbox_max": [
        -362.7027893066406,
        1141.0430908203125,
        64.7599868774414
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5253788232803345,
        0.4731574058532715,
        0.707176923751831
      ],
      "plane_d": -776.2742309570312,
      "bbox_min": [
        -363.56494140625,
        1141.0135498046875,
        63.999996185302734
      ],
      "bbox_max": [
        -362.7321472167969,
        1141.8756103515625,
        64.4000015258789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13124099373817444,
        0.14574885368347168,
        -0.9805779457092285
      ],
      "plane_d": -55.2020378112793,
      "bbox_min": [
        -364.1297912597656,
        1139.913330078125,
        64.5999984741211
      ],
      "bbox_max": [
        -362.3756103515625,
        1141.5487060546875,
        64.6800537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4731048047542572,
        -0.5256600379943848,
        0.707003116607666
      ],
      "plane_d": 382.3905944824219,
      "bbox_min": [
        -363.83251953125,
        1140.180908203125,
        63.999996185302734
      ],
      "bbox_max": [
        -362.6730041503906,
        1141.2811279296875,
        64.4000015258789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -340.0,
      "bbox_min": [
        -377.73565673828125,
        1147.0,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1187.7750244140625,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -62.0,
      "bbox_min": [
        -340.0,
        1147.0,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1181.5,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1177.5,
      "bbox_min": [
        -340.0,
        1177.5,
        60.0
      ],
      "bbox_max": [
        -320.5,
        1181.5,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1181.5,
      "bbox_min": [
        -340.0,
        1181.5,
        61.5
      ],
      "bbox_max": [
        -320.5,
        1181.5,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -65.0,
      "bbox_min": [
        -340.0,
        1147.0,
        62.0
      ],
      "bbox_max": [
        -320.5,
        1177.5,
        65.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 338.0,
      "bbox_min": [
        -340.0,
        1149.0,
        62.0
      ],
      "bbox_max": [
        -320.5,
        1177.5,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1177.5,
      "bbox_min": [
        -340.0,
        1177.5,
        62.0
      ],
      "bbox_max": [
        -338.0,
        1177.5,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1175.5,
      "bbox_min": [
        -338.0,
        1149.0,
        62.0
      ],
      "bbox_max": [
        -320.5,
        1177.5,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1177.5,
      "bbox_min": [
        -338.0,
        1177.5,
        62.0
      ],
      "bbox_max": [
        -320.5,
        1177.5,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1149.0,
      "bbox_min": [
        -338.0,
        1149.0,
        62.0
      ],
      "bbox_max": [
        -320.5,
        1149.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -344.0,
      "bbox_min": [
        -377.73565673828125,
        1147.0,
        60.0
      ],
      "bbox_max": [
        -340.0,
        1187.7750244140625,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 61.5,
      "bbox_min": [
        -344.0,
        1147.0,
        61.5
      ],
      "bbox_max": [
        -340.0,
        1181.5,
        62.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -62.0,
      "bbox_min": [
        -344.0,
        1147.0,
        61.5
      ],
      "bbox_max": [
        -340.0,
        1181.5,
        62.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": -1075.8629150390625,
      "bbox_min": [
        -344.0,
        1177.5,
        61.5
      ],
      "bbox_max": [
        -340.0,
        1181.5,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1175.0,
      "bbox_min": [
        -377.73565673828125,
        1147.0,
        60.0
      ],
      "bbox_max": [
        -351.8951721191406,
        1187.7750244140625,
        93.57749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -65.0,
      "bbox_min": [
        -377.73565673828125,
        1175.0,
        60.0
      ],
      "bbox_max": [
        -351.8951721191406,
        1187.7750244140625,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1185.794189453125,
      "bbox_min": [
        -377.464111328125,
        1175.0,
        60.0
      ],
      "bbox_max": [
        -352.535888671875,
        1185.794189453125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660244345664978,
        0.5000016689300537,
        0.0
      ],
      "plane_d": -914.3950805664062,
      "bbox_min": [
        -377.464111328125,
        1175.0,
        60.0
      ],
      "bbox_max": [
        -352.535888671875,
        1185.794189453125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660244345664978,
        0.5000016689300537,
        0.0
      ],
      "plane_d": -282.197265625,
      "bbox_min": [
        -377.464111328125,
        1175.0,
        60.0
      ],
      "bbox_max": [
        -352.535888671875,
        1185.794189453125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660243153572083,
        0.5000019073486328,
        0.0
      ],
      "plane_d": -911.3953247070312,
      "bbox_min": [
        -377.464111328125,
        1175.0,
        60.0
      ],
      "bbox_max": [
        -352.535888671875,
        1185.794189453125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 62.0,
      "bbox_min": [
        -369.5,
        1175.0,
        60.0
      ],
      "bbox_max": [
        -352.535888671875,
        1185.794189453125,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660243153572083,
        0.5000019073486328,
        -0.0
      ],
      "plane_d": -279.19757080078125,
      "bbox_min": [
        -360.5,
        1175.0,
        62.0
      ],
      "bbox_max": [
        -352.535888671875,
        1182.794189453125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -62.5,
      "bbox_min": [
        -360.5,
        1175.0,
        62.5
      ],
      "bbox_max": [
        -352.535888671875,
        1182.794189453125,
        62.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660243153572083,
        0.5000019073486328,
        -0.0
      ],
      "plane_d": -279.19757080078125,
      "bbox_min": [
        -360.5,
        1175.0,
        60.0
      ],
      "bbox_max": [
        -356.0,
        1182.794189453125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -62.5,
      "bbox_min": [
        -377.464111328125,
        1175.0,
        62.0
      ],
      "bbox_max": [
        -367.7679443359375,
        1185.794189453125,
        62.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 62.0,
      "bbox_min": [
        -377.464111328125,
        1175.0,
        62.0
      ],
      "bbox_max": [
        -367.7679443359375,
        1185.794189453125,
        62.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -364.75,
      "bbox_min": [
        -377.73565673828125,
        1175.0,
        65.0
      ],
      "bbox_max": [
        -351.8951721191406,
        1187.7750244140625,
        93.57749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.34291085600852966,
        -0.34680885076522827,
        0.8730038404464722
      ],
      "plane_d": 214.91290283203125,
      "bbox_min": [
        -364.75,
        1175.0,
        65.0
      ],
      "bbox_max": [
        -351.8951721191406,
        1187.7750244140625,
        93.57749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6092076897621155,
        0.6092076897621155,
        0.5076730847358704
      ],
      "plane_d": -528.13232421875,
      "bbox_min": [
        -364.75,
        1175.0,
        65.0
      ],
      "bbox_max": [
        -362.25,
        1177.5,
        68.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34291166067123413,
        0.34680986404418945,
        -0.8730031847953796
      ],
      "plane_d": -209.54241943359375,
      "bbox_min": [
        -364.75,
        1175.0,
        83.4843978881836
      ],
      "bbox_max": [
        -354.479248046875,
        1185.219970703125,
        93.57749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3429108262062073,
        0.3468044102191925,
        -0.8730056285858154
      ],
      "plane_d": -205.21363830566406,
      "bbox_min": [
        -364.75,
        1175.0,
        88.43566131591797
      ],
      "bbox_max": [
        -356.54644775390625,
        1183.176025390625,
        93.57749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.34291085600852966,
        0.34680885076522827,
        -0.8730038404464722
      ],
      "plane_d": -465.1112365722656,
      "bbox_min": [
        -377.73565673828125,
        1175.0,
        65.0
      ],
      "bbox_max": [
        -364.75,
        1187.7750244140625,
        93.57749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3429105877876282,
        0.34680861234664917,
        -0.8730040788650513
      ],
      "plane_d": -214.91270446777344,
      "bbox_min": [
        -375.151611328125,
        1175.0,
        77.30587768554688
      ],
      "bbox_max": [
        -364.75,
        1187.7750244140625,
        93.57749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.34291136264801025,
        0.34681081771850586,
        -0.8730028867721558
      ],
      "plane_d": -459.74237060546875,
      "bbox_min": [
        -375.151611328125,
        1175.0,
        83.45869445800781
      ],
      "bbox_max": [
        -364.75,
        1185.219970703125,
        93.57749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.34291166067123413,
        0.34680986404418945,
        -0.8730031847953796
      ],
      "plane_d": -209.54241943359375,
      "bbox_min": [
        -373.08441162109375,
        1175.0,
        83.45869445800781
      ],
      "bbox_max": [
        -364.75,
        1185.219970703125,
        93.57749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3429136872291565,
        0.34680843353271484,
        -0.8730029463768005
      ],
      "plane_d": -455.41796875,
      "bbox_min": [
        -373.08441162109375,
        1175.0,
        88.40995788574219
      ],
      "bbox_max": [
        -364.75,
        1183.176025390625,
        93.57749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3429108262062073,
        0.3468044102191925,
        -0.8730056285858154
      ],
      "plane_d": -205.21363830566406,
      "bbox_min": [
        -364.8154296875,
        1175.0,
        88.40995788574219
      ],
      "bbox_max": [
        -364.75,
        1183.176025390625,
        91.68366241455078
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6092076897621155,
        0.6092076897621155,
        0.5076730847358704
      ],
      "plane_d": -972.54931640625,
      "bbox_min": [
        -367.25,
        1175.0,
        65.0
      ],
      "bbox_max": [
        -364.75,
        1177.5,
        68.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -65.0,
      "bbox_min": [
        -377.73565673828125,
        1147.0,
        60.0
      ],
      "bbox_max": [
        -351.8951721191406,
        1175.0,
        93.57749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1164.205810546875,
      "bbox_min": [
        -377.464111328125,
        1147.0,
        60.0
      ],
      "bbox_max": [
        -352.535888671875,
        1175.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660244345664978,
        -0.5000016689300537,
        -0.0
      ],
      "plane_d": 260.60882568359375,
      "bbox_min": [
        -377.464111328125,
        1164.205810546875,
        60.0
      ],
      "bbox_max": [
        -352.535888671875,
        1175.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660244345664978,
        -0.5000016689300537,
        0.0
      ],
      "plane_d": 892.806640625,
      "bbox_min": [
        -377.464111328125,
        1164.205810546875,
        60.0
      ],
      "bbox_max": [
        -352.535888671875,
        1175.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660243153572083,
        -0.5000019073486328,
        0.0
      ],
      "plane_d": 263.6091613769531,
      "bbox_min": [
        -377.464111328125,
        1164.205810546875,
        60.0
      ],
      "bbox_max": [
        -352.535888671875,
        1175.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -62.5,
      "bbox_min": [
        -369.5,
        1164.205810546875,
        60.0
      ],
      "bbox_max": [
        -352.535888671875,
        1175.0,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660243153572083,
        -0.5000019073486328,
        0.0
      ],
      "plane_d": 895.806884765625,
      "bbox_min": [
        -360.5,
        1167.205810546875,
        60.0
      ],
      "bbox_max": [
        -352.535888671875,
        1175.0,
        62.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 62.0,
      "bbox_min": [
        -360.5,
        1167.205810546875,
        62.0
      ],
      "bbox_max": [
        -352.535888671875,
        1175.0,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660243153572083,
        -0.5000019073486328,
        0.0
      ],
      "plane_d": 895.806884765625,
      "bbox_min": [
        -360.5,
        1167.205810546875,
        62.5
      ],
      "bbox_max": [
        -356.0,
        1175.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 62.0,
      "bbox_min": [
        -377.464111328125,
        1164.205810546875,
        62.0
      ],
      "bbox_max": [
        -367.7679138183594,
        1175.0,
        62.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -62.5,
      "bbox_min": [
        -377.464111328125,
        1164.205810546875,
        62.5
      ],
      "bbox_max": [
        -367.7679138183594,
        1175.0,
        62.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -64.0,
      "bbox_min": [
        -374.520751953125,
        1147.0,
        63.2073974609375
      ],
      "bbox_max": [
        -372.9237976074219,
        1147.25,
        64.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.11962060630321503,
        0.9928196668624878,
        0.0
      ],
      "plane_d": -1183.71044921875,
      "bbox_min": [
        -374.520751953125,
        1147.1468505859375,
        63.2073974609375
      ],
      "bbox_max": [
        -373.6650695800781,
        1147.25,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -364.75,
      "bbox_min": [
        -377.73565673828125,
        1162.2249755859375,
        65.0
      ],
      "bbox_max": [
        -351.8951721191406,
        1175.0,
        93.57749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.34291085600852966,
        -0.34680885076522827,
        -0.8730038404464722
      ],
      "plane_d": 600.087890625,
      "bbox_min": [
        -364.75,
        1162.2249755859375,
        65.0
      ],
      "bbox_max": [
        -351.8951721191406,
        1175.0,
        93.57749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3429098427295685,
        -0.3468110263347626,
        -0.8730034232139587
      ],
      "plane_d": 605.4614868164062,
      "bbox_min": [
        -364.75,
        1164.780029296875,
        83.4843978881836
      ],
      "bbox_max": [
        -354.479248046875,
        1175.0,
        93.57749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3429117500782013,
        -0.34680870175361633,
        -0.8730036020278931
      ],
      "plane_d": 609.7819213867188,
      "bbox_min": [
        -364.75,
        1166.823974609375,
        88.43566131591797
      ],
      "bbox_max": [
        -356.54644775390625,
        1175.0,
        93.57749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6092076897621155,
        -0.6092076897621155,
        0.5076730847358704
      ],
      "plane_d": 903.5057983398438,
      "bbox_min": [
        -364.75,
        1172.5,
        65.0
      ],
      "bbox_max": [
        -362.25,
        1175.0,
        68.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3429112732410431,
        -0.3468084931373596,
        -0.8730038404464722
      ],
      "plane_d": 349.88897705078125,
      "bbox_min": [
        -377.73565673828125,
        1162.2249755859375,
        65.0
      ],
      "bbox_max": [
        -364.75,
        1175.0,
        93.57749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.34291085600852966,
        -0.34680885076522827,
        -0.8730038404464722
      ],
      "plane_d": 600.087890625,
      "bbox_min": [
        -375.151611328125,
        1162.2249755859375,
        77.30587768554688
      ],
      "bbox_max": [
        -364.75,
        1175.0,
        93.57749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.34291166067123413,
        -0.34680986404418945,
        -0.8730031847953796
      ],
      "plane_d": 355.2618408203125,
      "bbox_min": [
        -375.151611328125,
        1164.780029296875,
        83.45869445800781
      ],
      "bbox_max": [
        -364.75,
        1175.0,
        93.57749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3429098427295685,
        -0.3468110263347626,
        -0.8730034232139587
      ],
      "plane_d": 605.4614868164062,
      "bbox_min": [
        -373.08441162109375,
        1164.780029296875,
        83.45869445800781
      ],
      "bbox_max": [
        -364.75,
        1175.0,
        93.57749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3429108262062073,
        -0.3468044102191925,
        -0.8730056285858154
      ],
      "plane_d": 359.5783996582031,
      "bbox_min": [
        -373.08441162109375,
        1166.823974609375,
        88.40995788574219
      ],
      "bbox_max": [
        -364.75,
        1175.0,
        93.57749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3429117500782013,
        -0.34680870175361633,
        -0.8730036020278931
      ],
      "plane_d": 609.7819213867188,
      "bbox_min": [
        -364.8154296875,
        1166.823974609375,
        88.40995788574219
      ],
      "bbox_max": [
        -364.75,
        1175.0,
        91.68366241455078
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6092076897621155,
        -0.6092076897621155,
        0.5076730847358704
      ],
      "plane_d": 459.0887756347656,
      "bbox_min": [
        -367.25,
        1172.5,
        65.0
      ],
      "bbox_max": [
        -364.75,
        1175.0,
        68.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49979308247566223,
        -0.8661448359489441,
        0.0
      ],
      "plane_d": 827.0647583007812,
      "bbox_min": [
        -396.4754638671875,
        1178.6614990234375,
        80.0
      ],
      "bbox_max": [
        -387.81402587890625,
        1183.659423828125,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272398948669,
        0.44721361994743347,
        0.0
      ],
      "plane_d": -286.2167053222656,
      "bbox_min": [
        -320.5,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -299.5,
        1270.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -65.0,
      "bbox_min": [
        -320.5,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1270.0,
        85.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        -320.5,
        1239.0,
        65.0
      ],
      "bbox_max": [
        -310.0,
        1240.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -320.5,
        1239.0,
        65.0
      ],
      "bbox_max": [
        -310.0,
        1240.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 80.0,
      "bbox_min": [
        -320.5,
        1239.0,
        80.0
      ],
      "bbox_max": [
        -310.0,
        1240.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -64.99999237060547,
      "bbox_min": [
        -315.0000305175781,
        1260.0,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1270.0,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        -310.0,
        1260.0,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1263.2667236328125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1101.0794677734375,
      "bbox_min": [
        -320.5,
        1094.3140869140625,
        60.0
      ],
      "bbox_max": [
        -239.50550842285156,
        1239.0,
        250.00003051757812
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -75.0,
      "bbox_min": [
        -320.5,
        1094.3140869140625,
        60.0
      ],
      "bbox_max": [
        -308.78204345703125,
        1101.080078125,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1096.7496337890625,
      "bbox_min": [
        -320.5,
        1096.7496337890625,
        60.0
      ],
      "bbox_max": [
        -316.281494140625,
        1101.0794677734375,
        75.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -317.0,
      "bbox_min": [
        -320.5,
        1096.7496337890625,
        64.0
      ],
      "bbox_max": [
        -317.0,
        1101.0794677734375,
        72.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -64.0,
      "bbox_min": [
        -320.5,
        1096.7496337890625,
        64.0
      ],
      "bbox_max": [
        -317.0,
        1101.0794677734375,
        72.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 72.0,
      "bbox_min": [
        -320.5,
        1096.7496337890625,
        64.0
      ],
      "bbox_max": [
        -317.0,
        1101.0794677734375,
        72.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -270.1147766113281,
      "bbox_min": [
        -318.0,
        1096.7496337890625,
        64.0
      ],
      "bbox_max": [
        -317.0,
        1101.0794677734375,
        72.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.0,
        -0.7071067690849304
      ],
      "plane_d": -173.94827270507812,
      "bbox_min": [
        -318.0,
        1096.7496337890625,
        71.0
      ],
      "bbox_max": [
        -317.0,
        1101.0794677734375,
        72.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        -320.5,
        1094.3140869140625,
        75.0
      ],
      "bbox_max": [
        -308.78204345703125,
        1101.080078125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 313.5,
      "bbox_min": [
        -314.5,
        1097.7783203125,
        75.0
      ],
      "bbox_max": [
        -308.78204345703125,
        1101.080078125,
        78.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -314.5,
      "bbox_min": [
        -314.5,
        1097.7783203125,
        75.0
      ],
      "bbox_max": [
        -313.5,
        1101.080078125,
        78.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -78.5,
      "bbox_min": [
        -314.5,
        1097.7783203125,
        78.04911804199219
      ],
      "bbox_max": [
        -313.5,
        1101.080078125,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 421.1321105957031,
      "bbox_min": [
        -314.5,
        1097.7783203125,
        78.04911804199219
      ],
      "bbox_max": [
        -313.5,
        1098.6800537109375,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1100.646484375,
      "bbox_min": [
        -313.5,
        1100.646484375,
        75.0
      ],
      "bbox_max": [
        -308.78204345703125,
        1101.0794677734375,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -78.0,
      "bbox_min": [
        -313.5,
        1100.646484375,
        78.0
      ],
      "bbox_max": [
        -308.78204345703125,
        1101.0794677734375,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 95.0,
      "bbox_min": [
        -320.5,
        1101.0794677734375,
        60.0
      ],
      "bbox_max": [
        -239.50550842285156,
        1239.0,
        125.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        -240.8894805908203,
        1140.2772216796875,
        120.0
      ],
      "bbox_max": [
        -239.50550842285156,
        1141.1502685546875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8380874395370483,
        -0.5455358624458313,
        0.0
      ],
      "plane_d": 420.1756591796875,
      "bbox_min": [
        -320.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -240.8894805908203,
        1239.0,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6122786998748779,
        0.3534991443157196,
        0.7072150707244873
      ],
      "plane_d": -618.8341674804688,
      "bbox_min": [
        -299.5,
        1158.4000244140625,
        60.0
      ],
      "bbox_max": [
        -249.5,
        1239.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1210.4000244140625,
      "bbox_min": [
        -299.5,
        1210.4000244140625,
        60.0
      ],
      "bbox_max": [
        -279.5,
        1239.0,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8944272398948669,
        0.44721361994743347,
        -0.0
      ],
      "plane_d": -286.2166748046875,
      "bbox_min": [
        -299.5,
        1223.4052734375,
        60.0
      ],
      "bbox_max": [
        -295.0,
        1239.0,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 295.0,
      "bbox_min": [
        -299.2926940917969,
        1223.4052734375,
        80.0
      ],
      "bbox_max": [
        -295.0,
        1230.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 80.0,
      "bbox_min": [
        -299.2926940917969,
        1223.4052734375,
        80.0
      ],
      "bbox_max": [
        -295.0,
        1230.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1200.361328125,
      "bbox_min": [
        -320.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1239.0,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 295.0,
      "bbox_min": [
        -295.0,
        1210.4000244140625,
        80.0
      ],
      "bbox_max": [
        -286.5345458984375,
        1223.4052734375,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1210.4000244140625,
      "bbox_min": [
        -295.0,
        1210.4000244140625,
        80.0
      ],
      "bbox_max": [
        -286.5345458984375,
        1210.4000244140625,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1210.4000244140625,
      "bbox_min": [
        -320.5,
        1200.361328125,
        60.0
      ],
      "bbox_max": [
        -286.5345458984375,
        1239.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -320.5,
        1200.361328125,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1210.4000244140625,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 75.0,
      "bbox_min": [
        -320.5,
        1200.361328125,
        75.0
      ],
      "bbox_max": [
        -310.0,
        1210.4000244140625,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1230.0,
      "bbox_min": [
        -320.5,
        1210.4000244140625,
        60.0
      ],
      "bbox_max": [
        -299.2926940917969,
        1239.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        -320.5,
        1230.0,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1239.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1235.0,
      "bbox_min": [
        -320.5,
        1235.0,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1239.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -64.99999237060547,
      "bbox_min": [
        -320.5,
        1235.0,
        65.0
      ],
      "bbox_max": [
        -310.0,
        1239.0,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9060451984405518,
        0.4231809079647064,
        0.0
      ],
      "plane_d": -793.0921630859375,
      "bbox_min": [
        -310.0,
        1210.4000244140625,
        60.0
      ],
      "bbox_max": [
        -300.0,
        1213.5355224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9060451984405518,
        0.4231809079647064,
        0.0
      ],
      "plane_d": -240.40463256835938,
      "bbox_min": [
        -301.4644775390625,
        1210.4000244140625,
        60.0
      ],
      "bbox_max": [
        -300.0,
        1213.5355224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 306.0,
      "bbox_min": [
        -320.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1187.7750244140625,
        91.07749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        -320.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -306.0,
        1181.5,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5827085971832275,
        0.8126811981201172
      ],
      "plane_d": -702.5599365234375,
      "bbox_min": [
        -320.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1181.5,
        78.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 314.5,
      "bbox_min": [
        -320.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -314.5,
        1122.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5785005688667297,
        -0.8156819939613342
      ],
      "plane_d": 695.7045288085938,
      "bbox_min": [
        -320.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -314.5,
        1118.0,
        72.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -65.0,
      "bbox_min": [
        -320.5,
        1101.080078125,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1181.5,
        78.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -312.0,
      "bbox_min": [
        -320.5,
        1115.0267333984375,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1181.5,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1177.5,
      "bbox_min": [
        -312.0,
        1140.0,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1181.5,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1147.0,
      "bbox_min": [
        -312.0,
        1140.0,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1147.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        -312.0,
        1140.0,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1140.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -62.0,
      "bbox_min": [
        -312.0,
        1177.5,
        61.5
      ],
      "bbox_max": [
        -310.0,
        1181.5,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 61.5,
      "bbox_min": [
        -312.0,
        1177.5,
        61.5
      ],
      "bbox_max": [
        -310.0,
        1181.5,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1181.5,
      "bbox_min": [
        -312.0,
        1181.5,
        61.5
      ],
      "bbox_max": [
        -310.0,
        1181.5,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -62.0,
      "bbox_min": [
        -320.5,
        1115.0267333984375,
        60.0
      ],
      "bbox_max": [
        -312.0,
        1181.5,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        -320.5,
        1119.210693359375,
        60.0
      ],
      "bbox_max": [
        -312.0,
        1181.5,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1147.0,
      "bbox_min": [
        -320.5,
        1147.0,
        60.0
      ],
      "bbox_max": [
        -312.0,
        1147.0,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 61.5,
      "bbox_min": [
        -320.5,
        1177.5,
        61.5
      ],
      "bbox_max": [
        -312.0,
        1181.5,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1181.5,
      "bbox_min": [
        -320.5,
        1181.5,
        61.5
      ],
      "bbox_max": [
        -312.0,
        1181.5,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -314.5,
      "bbox_min": [
        -314.5,
        1119.210693359375,
        60.0
      ],
      "bbox_max": [
        -313.5,
        1125.5,
        62.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 313.5,
      "bbox_min": [
        -314.5,
        1119.210693359375,
        60.0
      ],
      "bbox_max": [
        -313.5,
        1125.5,
        62.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1125.5,
      "bbox_min": [
        -314.5,
        1125.5,
        60.0
      ],
      "bbox_max": [
        -313.5,
        1125.5,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        -320.5,
        1115.0267333984375,
        62.0
      ],
      "bbox_max": [
        -312.0,
        1177.5,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1149.0,
      "bbox_min": [
        -320.5,
        1147.0,
        62.0
      ],
      "bbox_max": [
        -312.0,
        1177.5,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1147.0,
      "bbox_min": [
        -320.5,
        1147.0,
        62.0
      ],
      "bbox_max": [
        -312.0,
        1147.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1175.5,
      "bbox_min": [
        -320.5,
        1175.5,
        62.0
      ],
      "bbox_max": [
        -312.0,
        1177.5,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1177.5,
      "bbox_min": [
        -320.5,
        1177.5,
        62.0
      ],
      "bbox_max": [
        -312.0,
        1177.5,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -314.5,
      "bbox_min": [
        -314.5,
        1115.0267333984375,
        62.0
      ],
      "bbox_max": [
        -313.5,
        1125.5,
        65.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 313.5,
      "bbox_min": [
        -314.5,
        1115.0267333984375,
        62.0
      ],
      "bbox_max": [
        -313.5,
        1125.5,
        65.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -63.5,
      "bbox_min": [
        -314.5,
        1119.907958984375,
        62.0
      ],
      "bbox_max": [
        -313.5,
        1125.5,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": -559.6878051757812,
      "bbox_min": [
        -314.5,
        1124.5,
        62.0
      ],
      "bbox_max": [
        -313.5,
        1125.5,
        63.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1125.5,
      "bbox_min": [
        -314.5,
        1125.5,
        62.0
      ],
      "bbox_max": [
        -313.5,
        1125.5,
        63.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5827085971832275,
        0.8126811981201172
      ],
      "plane_d": -705.404296875,
      "bbox_min": [
        -314.5,
        1119.907958984375,
        63.5
      ],
      "bbox_max": [
        -313.5,
        1122.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5827085971832275,
        0.8126811981201172
      ],
      "plane_d": -705.404296875,
      "bbox_min": [
        -320.5,
        1101.080078125,
        65.0
      ],
      "bbox_max": [
        -310.0,
        1147.0,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -314.5,
      "bbox_min": [
        -314.5,
        1101.080078125,
        65.0
      ],
      "bbox_max": [
        -313.5,
        1119.907958984375,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 313.5,
      "bbox_min": [
        -313.5,
        1101.080078125,
        65.0
      ],
      "bbox_max": [
        -313.5,
        1119.907958984375,
        78.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -70.0,
      "bbox_min": [
        -320.5,
        1140.0,
        65.0
      ],
      "bbox_max": [
        -310.0,
        1147.0,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1147.0,
      "bbox_min": [
        -320.5,
        1140.0,
        65.0
      ],
      "bbox_max": [
        -310.0,
        1147.0,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        -320.5,
        1140.0,
        65.0
      ],
      "bbox_max": [
        -310.0,
        1140.0,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -62.0,
      "bbox_min": [
        -310.0,
        1140.0,
        60.0
      ],
      "bbox_max": [
        -306.0,
        1181.5,
        70.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 61.5,
      "bbox_min": [
        -310.0,
        1140.0,
        60.0
      ],
      "bbox_max": [
        -306.0,
        1181.5,
        62.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": -616.2435302734375,
      "bbox_min": [
        -310.0,
        1140.0,
        61.5
      ],
      "bbox_max": [
        -306.0,
        1181.5,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1147.0,
      "bbox_min": [
        -310.0,
        1140.0,
        61.5
      ],
      "bbox_max": [
        -306.0,
        1147.0,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        -310.0,
        1140.0,
        61.5
      ],
      "bbox_max": [
        -306.0,
        1140.0,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1147.0,
      "bbox_min": [
        -310.0,
        1140.0,
        60.0
      ],
      "bbox_max": [
        -306.0,
        1147.0,
        61.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        -310.0,
        1140.0,
        62.0
      ],
      "bbox_max": [
        -306.0,
        1147.0,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -70.0,
      "bbox_min": [
        -310.0,
        1140.0,
        70.0
      ],
      "bbox_max": [
        -306.0,
        1147.0,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1175.0,
      "bbox_min": [
        -298.1048278808594,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1187.7750244140625,
        91.07749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -65.0,
      "bbox_min": [
        -298.1048278808594,
        1175.0,
        60.0
      ],
      "bbox_max": [
        -272.26434326171875,
        1187.7750244140625,
        91.07749938964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1185.794189453125,
      "bbox_min": [
        -297.464111328125,
        1175.0,
        60.0
      ],
      "bbox_max": [
        -272.535888671875,
        1185.794189453125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660244345664978,
        0.5000016689300537,
        0.0
      ],
      "plane_d": -845.1131591796875,
      "bbox_min": [
        -297.464111328125,
        1175.0,
        60.0
      ],
      "bbox_max": [
        -272.535888671875,
        1185.794189453125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660244345664978,
        0.5000016689300537,
        -0.0
      ],
      "plane_d": -351.4792175292969,
      "bbox_min": [
        -297.464111328125,
        1175.0,
        60.0
      ],
      "bbox_max": [
        -272.535888671875,
        1185.794189453125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660243153572083,
        0.5000019073486328,
        0.0
      ],
      "plane_d": -842.1134033203125,
      "bbox_min": [
        -297.464111328125,
        1175.0,
        60.0
      ],
      "bbox_max": [
        -272.535888671875,
        1185.794189453125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -62.5,
      "bbox_min": [
        -289.5,
        1175.0,
        60.0
      ],
      "bbox_max": [
        -272.535888671875,
        1185.794189453125,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660243153572083,
        0.5000019073486328,
        0.0
      ],
      "plane_d": -348.4795227050781,
      "bbox_min": [
        -280.5,
        1175.0,
        60.0
      ],
      "bbox_max": [
        -272.535888671875,
        1182.794189453125,
        62.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 62.0,
      "bbox_min": [
        -280.5,
        1175.0,
        62.0
      ],
      "bbox_max": [
        -272.535888671875,
        1182.794189453125,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660243153572083,
        0.5000019073486328,
        0.0
      ],
      "plane_d": -348.4795227050781,
      "bbox_min": [
        -280.5,
        1175.0,
        62.5
      ],
      "bbox_max": [
        -276.0,
        1182.794189453125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -62.5,
      "bbox_min": [
        -297.464111328125,
        1175.0,
        62.0
      ],
      "bbox_max": [
        -287.7679443359375,
        1185.794189453125,
        62.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 62.0,
      "bbox_min": [
        -297.464111328125,
        1175.0,
        62.0
      ],
      "bbox_max": [
        -287.7679443359375,
        1185.794189453125,
        62.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -285.25,
      "bbox_min": [
        -298.1048278808594,
        1175.0,
        65.0
      ],
      "bbox_max": [
        -272.26434326171875,
        1187.7750244140625,
        91.07749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.34291085600852966,
        -0.34680885076522827,
        0.8730038404464722
      ],
      "plane_d": 244.40170288085938,
      "bbox_min": [
        -285.25,
        1175.0,
        65.0
      ],
      "bbox_max": [
        -272.26434326171875,
        1187.7750244140625,
        91.07749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6092076897621155,
        0.6092076897621155,
        0.5076730847358704
      ],
      "plane_d": -576.5643310546875,
      "bbox_min": [
        -285.25,
        1175.0,
        65.0
      ],
      "bbox_max": [
        -282.75,
        1177.5,
        68.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34291085600852966,
        0.34680885076522827,
        -0.8730038404464722
      ],
      "plane_d": -439.9874572753906,
      "bbox_min": [
        -285.25,
        1175.0,
        74.80587768554688
      ],
      "bbox_max": [
        -274.848388671875,
        1187.7750244140625,
        91.07749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.34291136264801025,
        -0.34681081771850586,
        0.8730028867721558
      ],
      "plane_d": 239.03250122070312,
      "bbox_min": [
        -285.25,
        1175.0,
        80.95869445800781
      ],
      "bbox_max": [
        -274.848388671875,
        1185.219970703125,
        91.07749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3429098427295685,
        0.3468110263347626,
        -0.8730034232139587
      ],
      "plane_d": -434.61834716796875,
      "bbox_min": [
        -285.25,
        1175.0,
        80.95869445800781
      ],
      "bbox_max": [
        -276.91558837890625,
        1185.219970703125,
        91.07749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3429136872291565,
        -0.34680843353271484,
        0.8730029463768005
      ],
      "plane_d": 234.70657348632812,
      "bbox_min": [
        -285.25,
        1175.0,
        85.90995788574219
      ],
      "bbox_max": [
        -276.91558837890625,
        1183.176025390625,
        91.07749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3429117500782013,
        0.34680870175361633,
        -0.8730036020278931
      ],
      "plane_d": -430.2936706542969,
      "bbox_min": [
        -285.25,
        1175.0,
        85.90995788574219
      ],
      "bbox_max": [
        -285.1845703125,
        1183.176025390625,
        89.18366241455078
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.34291085600852966,
        0.34680885076522827,
        -0.8730038404464722
      ],
      "plane_d": -439.9874572753906,
      "bbox_min": [
        -298.1048278808594,
        1175.0,
        65.0
      ],
      "bbox_max": [
        -285.25,
        1187.7750244140625,
        91.07749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3429098427295685,
        0.3468110263347626,
        -0.8730034232139587
      ],
      "plane_d": -434.61834716796875,
      "bbox_min": [
        -295.520751953125,
        1175.0,
        80.9843978881836
      ],
      "bbox_max": [
        -285.25,
        1185.219970703125,
        91.07749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3429117500782013,
        0.34680870175361633,
        -0.8730036020278931
      ],
      "plane_d": -430.2936706542969,
      "bbox_min": [
        -293.45355224609375,
        1175.0,
        85.93566131591797
      ],
      "bbox_max": [
        -285.25,
        1183.176025390625,
        91.07749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6092076897621155,
        0.6092076897621155,
        0.5076730847358704
      ],
      "plane_d": -924.1173095703125,
      "bbox_min": [
        -287.75,
        1175.0,
        65.0
      ],
      "bbox_max": [
        -285.25,
        1177.5,
        68.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3429105877876282,
        -0.34680861234664917,
        -0.8730040788650513
      ],
      "plane_d": 375.0131530761719,
      "bbox_min": [
        -298.1048278808594,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1175.0,
        91.07749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3429112732410431,
        0.3468084931373596,
        0.8730038404464722
      ],
      "plane_d": -570.5988159179688,
      "bbox_min": [
        -295.520751953125,
        1162.2249755859375,
        74.80587768554688
      ],
      "bbox_max": [
        -272.26434326171875,
        1175.0,
        91.07749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.34291166067123413,
        -0.34680986404418945,
        -0.8730031847953796
      ],
      "plane_d": 380.38568115234375,
      "bbox_min": [
        -295.520751953125,
        1164.780029296875,
        74.83157348632812
      ],
      "bbox_max": [
        -274.848388671875,
        1175.0,
        91.07749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.34291166067123413,
        0.34680986404418945,
        0.8730031847953796
      ],
      "plane_d": -575.971923828125,
      "bbox_min": [
        -293.45355224609375,
        1164.780029296875,
        80.95869445800781
      ],
      "bbox_max": [
        -274.848388671875,
        1175.0,
        91.07749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3429108262062073,
        -0.3468044102191925,
        -0.8730056285858154
      ],
      "plane_d": 384.7021789550781,
      "bbox_min": [
        -293.45355224609375,
        1166.823974609375,
        80.98442077636719
      ],
      "bbox_max": [
        -276.91558837890625,
        1175.0,
        91.07749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3429108262062073,
        0.3468044102191925,
        0.8730056285858154
      ],
      "plane_d": -580.2879638671875,
      "bbox_min": [
        -285.25,
        1166.823974609375,
        85.90995788574219
      ],
      "bbox_max": [
        -276.91558837890625,
        1175.0,
        91.07749938964844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -285.25,
      "bbox_min": [
        -285.25,
        1172.5,
        85.93565368652344
      ],
      "bbox_max": [
        -285.25,
        1175.0,
        88.75
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -285.25,
      "bbox_min": [
        -285.25,
        1172.5,
        80.98442077636719
      ],
      "bbox_max": [
        -285.25,
        1175.0,
        86.92877197265625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -285.25,
      "bbox_min": [
        -285.25,
        1172.5,
        74.83157348632812
      ],
      "bbox_max": [
        -285.25,
        1175.0,
        81.97756958007812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1164.205810546875,
      "bbox_min": [
        -297.464111328125,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1175.0,
        75.82475280761719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -65.0,
      "bbox_min": [
        -297.464111328125,
        1164.205810546875,
        60.0
      ],
      "bbox_max": [
        -272.535888671875,
        1175.0,
        75.82475280761719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660244345664978,
        -0.5000016689300537,
        0.0
      ],
      "plane_d": 329.8907775878906,
      "bbox_min": [
        -297.464111328125,
        1164.205810546875,
        60.0
      ],
      "bbox_max": [
        -272.535888671875,
        1175.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660244345664978,
        -0.5000016689300537,
        0.0
      ],
      "plane_d": 823.5247192382812,
      "bbox_min": [
        -297.464111328125,
        1164.205810546875,
        60.0
      ],
      "bbox_max": [
        -272.535888671875,
        1175.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660243153572083,
        -0.5000019073486328,
        -0.0
      ],
      "plane_d": 332.8910827636719,
      "bbox_min": [
        -297.464111328125,
        1164.205810546875,
        60.0
      ],
      "bbox_max": [
        -272.535888671875,
        1175.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -62.5,
      "bbox_min": [
        -289.5,
        1164.205810546875,
        60.0
      ],
      "bbox_max": [
        -272.535888671875,
        1175.0,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660243153572083,
        -0.5000019073486328,
        0.0
      ],
      "plane_d": 826.5249633789062,
      "bbox_min": [
        -280.5,
        1167.205810546875,
        60.0
      ],
      "bbox_max": [
        -272.535888671875,
        1175.0,
        62.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 62.0,
      "bbox_min": [
        -280.5,
        1167.205810546875,
        62.0
      ],
      "bbox_max": [
        -272.535888671875,
        1175.0,
        62.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660243153572083,
        -0.5000019073486328,
        0.0
      ],
      "plane_d": 826.5249633789062,
      "bbox_min": [
        -280.5,
        1167.205810546875,
        62.5
      ],
      "bbox_max": [
        -276.0,
        1175.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -62.5,
      "bbox_min": [
        -297.464111328125,
        1164.205810546875,
        62.0
      ],
      "bbox_max": [
        -287.7679138183594,
        1175.0,
        62.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 62.0,
      "bbox_min": [
        -297.464111328125,
        1164.205810546875,
        62.0
      ],
      "bbox_max": [
        -287.7679138183594,
        1175.0,
        62.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -285.25,
      "bbox_min": [
        -287.75,
        1172.5,
        65.0
      ],
      "bbox_max": [
        -282.75,
        1175.0,
        75.82475280761719
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6092076897621155,
        -0.6092076897621155,
        0.5076730847358704
      ],
      "plane_d": 855.07373046875,
      "bbox_min": [
        -285.25,
        1172.5,
        65.0
      ],
      "bbox_max": [
        -282.75,
        1175.0,
        68.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6092076897621155,
        -0.6092076897621155,
        0.5076730847358704
      ],
      "plane_d": 507.5207824707031,
      "bbox_min": [
        -287.75,
        1172.5,
        65.0
      ],
      "bbox_max": [
        -285.25,
        1175.0,
        68.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -64.0,
      "bbox_min": [
        -297.25,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1147.25,
        66.5999984741211
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.3195746839046478,
        0.9475610852241516,
        0.0
      ],
      "plane_d": -1175.3990478515625,
      "bbox_min": [
        -297.25,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1147.25,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.660825788974762,
        0.7505393624305725,
        0.0
      ],
      "plane_d": -1047.60595703125,
      "bbox_min": [
        -297.25,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1147.25,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11962060630321503,
        0.9928196668624878,
        0.0
      ],
      "plane_d": -1105.95703125,
      "bbox_min": [
        -297.25,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1147.25,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9196140766143799,
        0.3928230106830597,
        0.0
      ],
      "plane_d": -716.7876586914062,
      "bbox_min": [
        -297.25,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1146.1553955078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6608288884162903,
        -0.7505365610122681,
        0.0
      ],
      "plane_d": 1044.603759765625,
      "bbox_min": [
        -297.25,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1146.1553955078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.319561243057251,
        -0.9475656151771545,
        0.0
      ],
      "plane_d": 1172.4005126953125,
      "bbox_min": [
        -297.25,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1146.1553955078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9837599992752075,
        -0.17948898673057556,
        -0.0
      ],
      "plane_d": -89.80921936035156,
      "bbox_min": [
        -297.25,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1146.1553955078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6473184823989868,
        0.7622196674346924,
        0.0
      ],
      "plane_d": -700.6263427734375,
      "bbox_min": [
        -295.82049560546875,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1146.1553955078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11961036920547485,
        -0.9928209185600281,
        -0.0
      ],
      "plane_d": 1102.9613037109375,
      "bbox_min": [
        -295.82049560546875,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1144.1903076171875,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9196160435676575,
        -0.3928183913230896,
        0.0
      ],
      "plane_d": 713.7830200195312,
      "bbox_min": [
        -295.82049560546875,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1143.284912109375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6473259925842285,
        -0.7622132897377014,
        -0.0
      ],
      "plane_d": 697.6170654296875,
      "bbox_min": [
        -295.82049560546875,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1143.284912109375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000129342079163,
        -0.8660179376602173,
        0.0
      ],
      "plane_d": 1118.7196044921875,
      "bbox_min": [
        -263.9383850097656,
        1139.4071044921875,
        60.0
      ],
      "bbox_max": [
        -261.17950439453125,
        1141.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9837608337402344,
        0.17948433756828308,
        0.0
      ],
      "plane_d": 86.814697265625,
      "bbox_min": [
        -295.82049560546875,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -293.0616149902344,
        1128.486083984375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000129342079163,
        -0.8660179376602173,
        0.0
      ],
      "plane_d": 1118.72021484375,
      "bbox_min": [
        -295.82049560546875,
        1121.0,
        60.0
      ],
      "bbox_max": [
        -293.0616149902344,
        1122.5928955078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12866723537445068,
        0.14801400899887085,
        0.9805797338485718
      ],
      "plane_d": -271.0050964355469,
      "bbox_min": [
        -288.42059326171875,
        1139.689453125,
        63.999996185302734
      ],
      "bbox_max": [
        -285.2054443359375,
        1142.9638671875,
        66.5999984741211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6560683846473694,
        -0.7547014355659485,
        0.0
      ],
      "plane_d": 1048.2298583984375,
      "bbox_min": [
        -288.42059326171875,
        1139.689453125,
        63.999996185302734
      ],
      "bbox_max": [
        -285.2054443359375,
        1142.9638671875,
        66.5999984741211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7547014355659485,
        -0.6560683846473694,
        0.0
      ],
      "plane_d": 531.3302001953125,
      "bbox_min": [
        -288.42059326171875,
        1139.689453125,
        63.999996185302734
      ],
      "bbox_max": [
        -285.2054443359375,
        1142.9638671875,
        66.5999984741211
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7547165751457214,
        0.656050980091095,
        0.0
      ],
      "plane_d": -533.3059692382812,
      "bbox_min": [
        -288.42059326171875,
        1139.689453125,
        63.999996185302734
      ],
      "bbox_max": [
        -285.2054443359375,
        1142.9638671875,
        66.5999984741211
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6560608148574829,
        0.7547079920768738,
        0.0
      ],
      "plane_d": -1050.8350830078125,
      "bbox_min": [
        -288.42059326171875,
        1139.689453125,
        63.999996185302734
      ],
      "bbox_max": [
        -285.2054443359375,
        1142.9638671875,
        66.5999984741211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -66.5999984741211,
      "bbox_min": [
        -288.42059326171875,
        1139.689453125,
        63.999996185302734
      ],
      "bbox_max": [
        -285.2054443359375,
        1142.9638671875,
        66.5999984741211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6561787128448486,
        -0.7546055316925049,
        0.0
      ],
      "plane_d": 1049.152099609375,
      "bbox_min": [
        -288.42059326171875,
        1139.689453125,
        63.999996185302734
      ],
      "bbox_max": [
        -285.2054443359375,
        1142.9638671875,
        64.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.754709005355835,
        -0.6560596823692322,
        -0.0
      ],
      "plane_d": 532.1181030273438,
      "bbox_min": [
        -288.42059326171875,
        1140.444091796875,
        63.999996185302734
      ],
      "bbox_max": [
        -285.8616943359375,
        1142.9638671875,
        64.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1286649852991104,
        0.14801141619682312,
        -0.9805803894996643
      ],
      "plane_d": -142.3494110107422,
      "bbox_min": [
        -287.81683349609375,
        1140.9691162109375,
        63.999996185302734
      ],
      "bbox_max": [
        -285.8616943359375,
        1142.9638671875,
        64.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6560426354408264,
        0.7547237873077393,
        0.0
      ],
      "plane_d": -1049.64794921875,
      "bbox_min": [
        -287.029541015625,
        1141.27099609375,
        64.75997924804688
      ],
      "bbox_max": [
        -286.7277526855469,
        1141.5333251953125,
        64.99999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.463911235332489,
        0.5336705446243286,
        0.707094132900238
      ],
      "plane_d": -787.7557983398438,
      "bbox_min": [
        -287.2919616699219,
        1141.2315673828125,
        63.999996185302734
      ],
      "bbox_max": [
        -286.1634826660156,
        1142.09765625,
        64.75999450683594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5336251854896545,
        0.46411579847335815,
        0.7069941163063049
      ],
      "plane_d": -422.32891845703125,
      "bbox_min": [
        -286.7277526855469,
        1141.2315673828125,
        63.999996185302734
      ],
      "bbox_max": [
        -286.1634826660156,
        1142.09765625,
        64.69998168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7545397877693176,
        0.6562542915344238,
        0.0
      ],
      "plane_d": -532.7886352539062,
      "bbox_min": [
        -286.7277526855469,
        1141.2315673828125,
        64.4000015258789
      ],
      "bbox_max": [
        -286.4653015136719,
        1141.5333251953125,
        64.69998168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6560426354408264,
        0.7547237873077393,
        0.0
      ],
      "plane_d": -1049.64794921875,
      "bbox_min": [
        -287.029541015625,
        1141.27099609375,
        64.4000015258789
      ],
      "bbox_max": [
        -286.5308837890625,
        1141.5333251953125,
        64.75999450683594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7545397877693176,
        0.6562542915344238,
        0.0
      ],
      "plane_d": -532.7886352539062,
      "bbox_min": [
        -286.7277526855469,
        1141.3070068359375,
        64.4000015258789
      ],
      "bbox_max": [
        -286.5308837890625,
        1141.5333251953125,
        64.75997924804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5336341857910156,
        -0.4638999104499817,
        0.7071290016174316
      ],
      "plane_d": 330.7276306152344,
      "bbox_min": [
        -287.5938720703125,
        1140.70654296875,
        63.999996185302734
      ],
      "bbox_max": [
        -286.7671203613281,
        1141.5728759765625,
        64.4000015258789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1286649852991104,
        0.14801141619682312,
        -0.9805803894996643
      ],
      "plane_d": -142.3494110107422,
      "bbox_min": [
        -287.3708190917969,
        1140.142333984375,
        64.5999984741211
      ],
      "bbox_max": [
        -285.5990905761719,
        1141.756591796875,
        64.6800537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4640175700187683,
        -0.5336202383041382,
        0.707062304019928
      ],
      "plane_d": 696.3743896484375,
      "bbox_min": [
        -287.0689697265625,
        1140.40478515625,
        63.999996185302734
      ],
      "bbox_max": [
        -285.90093994140625,
        1141.4940185546875,
        64.4000015258789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.986393928527832,
        0.16439898312091827
      ],
      "plane_d": 1380.9515380859375,
      "bbox_min": [
        -400.42303466796875,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -50.843994140625,
        1430.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -350.0,
        1410.0,
        60.0
      ],
      "bbox_max": [
        -300.0,
        1430.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        -350.0,
        1410.0,
        60.0
      ],
      "bbox_max": [
        -350.0,
        1430.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9863938689231873,
        0.0,
        0.16439898312091827
      ],
      "plane_d": -78.91150665283203,
      "bbox_min": [
        -313.88458251953125,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -50.843994140625,
        1420.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        -70.0,
        1250.0,
        60.0
      ],
      "bbox_max": [
        -50.843994140625,
        1250.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268595933914185,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1142.9825439453125,
      "bbox_min": [
        -313.88458251953125,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -175.0,
        1367.835205078125,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268595933914185,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1296.0570068359375,
      "bbox_min": [
        -225.0,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -175.0,
        1367.835205078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238791465759277,
        -0.3826843202114105,
        0.0
      ],
      "plane_d": 306.83758544921875,
      "bbox_min": [
        -225.0,
        1327.3223876953125,
        60.0
      ],
      "bbox_max": [
        -175.0,
        1367.835205078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238791465759277,
        0.3826843202114105,
        0.0
      ],
      "plane_d": -722.5831909179688,
      "bbox_min": [
        -225.0,
        1327.3223876953125,
        60.0
      ],
      "bbox_max": [
        -175.0,
        1367.835205078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -64.0,
      "bbox_min": [
        -225.0,
        1327.3223876953125,
        60.0
      ],
      "bbox_max": [
        -175.0,
        1367.835205078125,
        64.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.38268694281578064,
        -0.9238780736923218,
        0.0
      ],
      "plane_d": 1187.175537109375,
      "bbox_min": [
        -216.14694213867188,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -177.164794921875,
        1367.835205078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268694281578064,
        -0.9238780736923218,
        0.0
      ],
      "plane_d": 1340.2503662109375,
      "bbox_min": [
        -216.14694213867188,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -177.164794921875,
        1367.835205078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238792061805725,
        -0.3826843500137329,
        0.0
      ],
      "plane_d": 351.0315856933594,
      "bbox_min": [
        -183.85305786132812,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -177.164794921875,
        1361.1468505859375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238792061805725,
        0.3826843500137329,
        0.0
      ],
      "plane_d": -678.3893432617188,
      "bbox_min": [
        -183.85305786132812,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -177.164794921875,
        1345.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        -313.88458251953125,
        1239.0,
        60.0
      ],
      "bbox_max": [
        -226.0344696044922,
        1270.0,
        65.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -64.99999237060547,
      "bbox_min": [
        -313.88458251953125,
        1263.2667236328125,
        65.0
      ],
      "bbox_max": [
        -310.0,
        1270.0,
        65.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6122786998748779,
        0.3534991443157196,
        0.7072150707244873
      ],
      "plane_d": -618.8341674804688,
      "bbox_min": [
        -226.05955505371094,
        1239.0,
        60.00611877441406
      ],
      "bbox_max": [
        -226.0344696044922,
        1239.021728515625,
        60.02783966064453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660252094268799,
        0.5000004768371582,
        0.0
      ],
      "plane_d": -795.2738647460938,
      "bbox_min": [
        -274.502197265625,
        1141.0762939453125,
        60.00611877441406
      ],
      "bbox_max": [
        -136.8179473876953,
        1239.0,
        250.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.0,
      "bbox_min": [
        -239.5482177734375,
        1141.0762939453125,
        95.0
      ],
      "bbox_max": [
        -136.8179473876953,
        1211.592529296875,
        131.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.26290374994277954,
        -0.4038907289505005,
        -0.8762156367301941
      ],
      "plane_d": 638.6624755859375,
      "bbox_min": [
        -239.5482177734375,
        1141.0762939453125,
        95.0
      ],
      "bbox_max": [
        -136.8179473876953,
        1211.592529296875,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5455361604690552,
        -0.838087260723114,
        0.0
      ],
      "plane_d": 1087.0657958984375,
      "bbox_min": [
        -239.5482177734375,
        1141.0762939453125,
        95.0
      ],
      "bbox_max": [
        -136.8179473876953,
        1211.592529296875,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20686259865760803,
        -0.9783700108528137,
        -0.0
      ],
      "plane_d": 1150.6346435546875,
      "bbox_min": [
        -225.0891571044922,
        1156.643310546875,
        95.0
      ],
      "bbox_max": [
        -140.31898498535156,
        1211.592529296875,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6006800532341003,
        -0.1270068734884262,
        -0.7893369197845459
      ],
      "plane_d": 371.2169189453125,
      "bbox_min": [
        -225.0891571044922,
        1156.643310546875,
        95.0
      ],
      "bbox_max": [
        -140.31898498535156,
        1211.592529296875,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12700533866882324,
        -0.600679874420166,
        -0.7893372774124146
      ],
      "plane_d": 801.1639404296875,
      "bbox_min": [
        -225.0891571044922,
        1156.643310546875,
        95.0
      ],
      "bbox_max": [
        -140.31898498535156,
        1211.592529296875,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9783694744110107,
        -0.20686496794223785,
        0.0
      ],
      "plane_d": 450.34912109375,
      "bbox_min": [
        -225.0891571044922,
        1156.643310546875,
        95.0
      ],
      "bbox_max": [
        -209.8958282470703,
        1184.3157958984375,
        120.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.39391928911209106,
        -0.9191450476646423,
        0.0
      ],
      "plane_d": 1167.984375,
      "bbox_min": [
        -225.0891571044922,
        1163.9810791015625,
        95.0
      ],
      "bbox_max": [
        -211.4473114013672,
        1178.0123291015625,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20686061680316925,
        -0.9783704280853271,
        0.0
      ],
      "plane_d": 1107.7803955078125,
      "bbox_min": [
        -225.0891571044922,
        1163.9810791015625,
        95.0
      ],
      "bbox_max": [
        -211.4473114013672,
        1178.0123291015625,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 110.0,
      "bbox_min": [
        -225.0891571044922,
        1163.9810791015625,
        110.0
      ],
      "bbox_max": [
        -211.4473114013672,
        1178.0123291015625,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 131.0,
      "bbox_min": [
        -239.5482177734375,
        1141.0762939453125,
        95.0
      ],
      "bbox_max": [
        -136.8179473876953,
        1205.7415771484375,
        131.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        -239.5482177734375,
        1141.0762939453125,
        95.0
      ],
      "bbox_max": [
        -136.8179473876953,
        1205.7415771484375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4038896858692169,
        0.26290363073349,
        -0.8762161731719971
      ],
      "plane_d": -111.8018569946289,
      "bbox_min": [
        -215.74685668945312,
        1155.2987060546875,
        120.0
      ],
      "bbox_max": [
        -197.52635192871094,
        1167.5540771484375,
        131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8380875587463379,
        -0.5455357432365417,
        0.0
      ],
      "plane_d": 540.175537109375,
      "bbox_min": [
        -140.31898498535156,
        1200.363037109375,
        95.0
      ],
      "bbox_max": [
        -136.8179473876953,
        1205.7415771484375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6122786998748779,
        0.3534991443157196,
        0.7072150707244873
      ],
      "plane_d": -618.8341674804688,
      "bbox_min": [
        -274.502197265625,
        1158.4000244140625,
        60.00611877441406
      ],
      "bbox_max": [
        -214.5,
        1239.0,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49979308247566223,
        0.8661448359489441,
        0.0
      ],
      "plane_d": -1178.0738525390625,
      "bbox_min": [
        -274.502197265625,
        1201.738525390625,
        80.0
      ],
      "bbox_max": [
        -265.84075927734375,
        1206.7364501953125,
        125.006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        0.0,
        900.0,
        60.0
      ],
      "bbox_max": [
        1070.0,
        2540.0,
        250.00003051757812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1490.0,
      "bbox_min": [
        120.0,
        1252.94091796875,
        60.0
      ],
      "bbox_max": [
        151.7926025390625,
        1490.0,
        214.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659253358840942,
        -0.2588212490081787,
        -0.0
      ],
      "plane_d": 470.9080810546875,
      "bbox_min": [
        145.8818359375,
        1252.94091796875,
        60.0
      ],
      "bbox_max": [
        151.7926025390625,
        1275.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 210.0,
      "bbox_min": [
        210.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        1070.0,
        1584.1903076171875,
        250.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        230.0,
        1223.5849609375,
        80.0
      ],
      "bbox_max": [
        1070.0,
        1584.1903076171875,
        250.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1050.0,
      "bbox_min": [
        1050.0,
        1475.0,
        82.35293579101562
      ],
      "bbox_max": [
        1070.0,
        1540.0,
        250.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1070.0,
      "bbox_min": [
        1070.0,
        1525.0,
        84.70588684082031
      ],
      "bbox_max": [
        1070.0,
        1540.0,
        250.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        230.0,
        1223.5849609375,
        160.0
      ],
      "bbox_max": [
        582.7122802734375,
        1584.1903076171875,
        250.00003051757812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9797557592391968,
        0.2001969814300537,
        0.0
      ],
      "plane_d": -75.3988037109375,
      "bbox_min": [
        230.0,
        1460.0,
        240.0
      ],
      "bbox_max": [
        246.7465057373047,
        1584.1903076171875,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999943971633911,
        0.003364049829542637,
        0.0
      ],
      "plane_d": 225.0872039794922,
      "bbox_min": [
        230.0,
        1460.0,
        240.0
      ],
      "bbox_max": [
        230.1444549560547,
        1502.9405517578125,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        270.0,
        1223.5849609375,
        160.0
      ],
      "bbox_max": [
        582.7122802734375,
        1460.0,
        250.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 270.0,
      "bbox_min": [
        270.0,
        1310.0,
        160.0
      ],
      "bbox_max": [
        582.7122802734375,
        1460.0,
        250.00003051757812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5877842307090759,
        0.8090178370475769,
        0.0
      ],
      "plane_d": -777.47216796875,
      "bbox_min": [
        290.0,
        1310.0,
        160.0
      ],
      "bbox_max": [
        582.7122802734375,
        1460.0,
        250.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9510564208030701,
        0.3090174198150635,
        0.0
      ],
      "plane_d": 88.44082641601562,
      "bbox_min": [
        518.6376342773438,
        1310.0,
        160.0
      ],
      "bbox_max": [
        530.4696044921875,
        1346.4150390625,
        250.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        290.0,
        1324.0096435546875,
        190.0
      ],
      "bbox_max": [
        312.5,
        1460.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1380.0096435546875,
      "bbox_min": [
        300.0,
        1380.0096435546875,
        240.0
      ],
      "bbox_max": [
        312.5,
        1380.0096435546875,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660250902175903,
        -0.5000007748603821,
        -0.0
      ],
      "plane_d": 947.6483764648438,
      "bbox_min": [
        290.0,
        1324.0096435546875,
        240.0
      ],
      "bbox_max": [
        300.0,
        1405.9903564453125,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660250902175903,
        0.5000007748603821,
        0.0
      ],
      "plane_d": -445.35382080078125,
      "bbox_min": [
        290.0,
        1380.0096435546875,
        240.0
      ],
      "bbox_max": [
        300.0,
        1405.9903564453125,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1380.0096435546875,
      "bbox_min": [
        297.5,
        1380.0096435546875,
        240.0
      ],
      "bbox_max": [
        300.0,
        1380.0096435546875,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660250902175903,
        0.5000007748603821,
        0.0
      ],
      "plane_d": -417.353759765625,
      "bbox_min": [
        290.0,
        1324.0096435546875,
        240.0
      ],
      "bbox_max": [
        297.5,
        1349.9903564453125,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660250902175903,
        -0.5000007748603821,
        -0.0
      ],
      "plane_d": 919.6483154296875,
      "bbox_min": [
        290.0,
        1324.0096435546875,
        240.0
      ],
      "bbox_max": [
        297.5,
        1337.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9510564208030701,
        -0.3090174198150635,
        0.0
      ],
      "plane_d": 882.6156005859375,
      "bbox_min": [
        510.5146179199219,
        1223.5849609375,
        160.0
      ],
      "bbox_max": [
        530.4696044921875,
        1310.0,
        250.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1490.0,
      "bbox_min": [
        0.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 10.0,
      "bbox_min": [
        10.0,
        1310.0,
        120.0
      ],
      "bbox_max": [
        110.0,
        1490.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6757246255874634,
        0.7371541261672974
      ],
      "plane_d": 796.7407836914062,
      "bbox_min": [
        10.0,
        1310.0,
        120.0
      ],
      "bbox_max": [
        110.0,
        1430.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        0.0,
        1050.0,
        60.0
      ],
      "bbox_max": [
        120.0,
        1270.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 80.0,
      "bbox_min": [
        0.0,
        1250.0,
        80.0
      ],
      "bbox_max": [
        120.0,
        1270.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": -693.3753051757812,
      "bbox_min": [
        0.0,
        1250.0,
        80.0
      ],
      "bbox_max": [
        22.5,
        1270.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.371390700340271,
        0.9284767508506775,
        0.0
      ],
      "plane_d": -1170.8092041015625,
      "bbox_min": [
        10.0,
        1265.0,
        80.0
      ],
      "bbox_max": [
        22.5,
        1270.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 124.0,
      "bbox_min": [
        0.0,
        1050.0,
        82.0
      ],
      "bbox_max": [
        120.0,
        1240.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 144.0,
      "bbox_min": [
        0.0,
        1050.0,
        144.0
      ],
      "bbox_max": [
        120.0,
        1240.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3205961585044861,
        0.0,
        0.9472159743309021
      ],
      "plane_d": -69.65679931640625,
      "bbox_min": [
        25.0,
        1210.0,
        82.0
      ],
      "bbox_max": [
        90.0,
        1240.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5238755941390991,
        -0.5008544921875,
        0.6889841556549072
      ],
      "plane_d": 4560.046875,
      "bbox_min": [
        0.0,
        4976.5205078125,
        249.99998474121094
      ],
      "bbox_max": [
        6306.5068359375,
        7450.0,
        1954.7119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        2769.303955078125,
        5162.82421875,
        250.0
      ],
      "bbox_max": [
        4964.0634765625,
        7185.4150390625,
        1954.7119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05136118829250336,
        -0.319204717874527,
        0.9462930560112
      ],
      "plane_d": 1763.4462890625,
      "bbox_min": [
        2769.303955078125,
        6729.98193359375,
        570.58251953125
      ],
      "bbox_max": [
        3020.6171875,
        7185.4150390625,
        723.3372802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05136118829250336,
        -0.319204717874527,
        0.9462930560112
      ],
      "plane_d": 1763.4462890625,
      "bbox_min": [
        0.0,
        5777.3857421875,
        250.0
      ],
      "bbox_max": [
        3034.4052734375,
        7450.0,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7881146669387817,
        0.06996545940637589,
        0.6115390658378601
      ],
      "plane_d": -136.38499450683594,
      "bbox_min": [
        0.0,
        6174.07177734375,
        250.00003051757812
      ],
      "bbox_max": [
        943.3017578125,
        7450.0,
        660.3674926757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        0.0,
        7410.2177734375,
        250.00003051757812
      ],
      "bbox_max": [
        200.0,
        7450.0,
        660.3674926757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01264164224267006,
        -0.2850233018398285,
        0.9584372639656067
      ],
      "plane_d": 1473.4520263671875,
      "bbox_min": [
        0.0,
        5913.06494140625,
        250.0
      ],
      "bbox_max": [
        2191.17431640625,
        7450.0,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7881146669387817,
        0.06996545940637589,
        0.6115390658378601
      ],
      "plane_d": -136.38499450683594,
      "bbox_min": [
        0.0,
        5985.7529296875,
        250.00003051757812
      ],
      "bbox_max": [
        943.3017578125,
        7450.0,
        680.7955322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        0.0,
        7410.2177734375,
        636.0927734375
      ],
      "bbox_max": [
        200.0,
        7450.0,
        680.7955322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        0.0,
        7410.2177734375,
        666.3270263671875
      ],
      "bbox_max": [
        200.0,
        7450.0,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3932375907897949,
        -0.4582340121269226,
        0.797110915184021
      ],
      "plane_d": 2052.83154296875,
      "bbox_min": [
        -2379.3076171875,
        6940.63916015625,
        250.0
      ],
      "bbox_max": [
        -2282.540771484375,
        6956.58251953125,
        297.51312255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1549.9998779296875,
      "bbox_min": [
        230.0,
        1460.0,
        250.0
      ],
      "bbox_max": [
        2130.0,
        2011.7158203125,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1830.0,
      "bbox_min": [
        1550.0,
        1654.800048828125,
        500.0
      ],
      "bbox_max": [
        2130.0,
        1940.0999755859375,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9688333868980408,
        -0.24771343171596527,
        -0.0
      ],
      "plane_d": 2410.359130859375,
      "bbox_min": [
        1660.0,
        1830.0,
        500.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2740.887451171875,
      "bbox_min": [
        1660.0,
        1830.0,
        500.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 2843.6669921875,
      "bbox_min": [
        1660.0,
        1830.0,
        980.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1865.3892822265625,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1892.56787109375,
        1830.0,
        1130.0
      ],
      "bbox_max": [
        1973.3603515625,
        1891.7369384765625,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1660.0,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        1975.4896240234375,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1885.0001220703125,
        1830.3746337890625,
        1130.0
      ],
      "bbox_max": [
        1913.2431640625,
        1851.050048828125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": 2632.51416015625,
      "bbox_min": [
        1885.0001220703125,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        1913.6177978515625,
        1837.9425048828125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1885.0001220703125,
        1830.0,
        1130.0
      ],
      "bbox_max": [
        1913.6177978515625,
        1837.9423828125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1659.9998779296875,
        1654.800048828125,
        1059.6484375
      ],
      "bbox_max": [
        2020.0,
        1830.0,
        1130.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1800.0,
        1720.0,
        1060.0
      ],
      "bbox_max": [
        1992.11669921875,
        1830.0,
        1130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9659263491630554,
        -0.2588171064853668,
        3.2501047826372087e-06
      ],
      "plane_d": 2319.75244140625,
      "bbox_min": [
        1800.0,
        1720.0,
        1060.0
      ],
      "bbox_max": [
        1930.0001220703125,
        1830.0,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1921.2918701171875,
        1772.5001220703125,
        1110.0
      ],
      "bbox_max": [
        1928.516845703125,
        1793.0001220703125,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": 2632.51416015625,
      "bbox_min": [
        1800.0,
        1720.0,
        1060.0
      ],
      "bbox_max": [
        1926.6507568359375,
        1830.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1800.0,
        1720.0,
        1110.0
      ],
      "bbox_max": [
        1926.6507568359375,
        1800.0,
        1110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 2843.6669921875,
      "bbox_min": [
        1975.4892578125,
        1829.8446044921875,
        1059.6484375
      ],
      "bbox_max": [
        1975.800048828125,
        1830.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1070.0,
      "bbox_min": [
        230.0,
        1460.0,
        250.0
      ],
      "bbox_max": [
        1075.0,
        1584.1903076171875,
        780.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1075.0,
      "bbox_min": [
        1075.0,
        1470.0,
        515.0
      ],
      "bbox_max": [
        1075.0,
        1540.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        230.0,
        1460.0,
        250.0
      ],
      "bbox_max": [
        1050.0,
        1584.1903076171875,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1050.0,
      "bbox_min": [
        1050.0,
        1475.0,
        250.00001525878906
      ],
      "bbox_max": [
        1050.0,
        1525.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        230.0,
        1460.0,
        250.0
      ],
      "bbox_max": [
        431.0,
        1584.1903076171875,
        340.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9797557592391968,
        0.2001969814300537,
        0.0
      ],
      "plane_d": -75.3988037109375,
      "bbox_min": [
        230.0,
        1460.0,
        250.0
      ],
      "bbox_max": [
        246.7465057373047,
        1584.1903076171875,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999943971633911,
        0.003364049829542637,
        0.0
      ],
      "plane_d": 225.0872039794922,
      "bbox_min": [
        230.0,
        1460.0,
        250.0
      ],
      "bbox_max": [
        230.1444549560547,
        1502.9405517578125,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1040.0,
      "bbox_min": [
        -335.0,
        1040.0,
        250.0
      ],
      "bbox_max": [
        -315.0,
        1051.800048828125,
        412.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1050.0,
      "bbox_min": [
        -335.0,
        1040.0,
        250.0
      ],
      "bbox_max": [
        -315.0,
        1051.800048828125,
        412.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 260.0,
      "bbox_min": [
        -330.0,
        1050.0,
        260.0
      ],
      "bbox_max": [
        -320.0,
        1051.800048828125,
        310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        -330.0,
        1050.0,
        310.0
      ],
      "bbox_max": [
        -320.0,
        1051.800048828125,
        310.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -315.0,
      "bbox_min": [
        -335.0,
        1040.0,
        250.0
      ],
      "bbox_max": [
        -315.0,
        1050.0,
        412.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 335.0,
      "bbox_min": [
        -335.0,
        1040.0,
        250.0
      ],
      "bbox_max": [
        -315.0,
        1050.0,
        412.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 412.0,
      "bbox_min": [
        -335.0,
        1040.0,
        412.0
      ],
      "bbox_max": [
        -315.0,
        1050.0,
        412.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9974586963653564,
        0.07124704867601395
      ],
      "plane_d": 1312.37060546875,
      "bbox_min": [
        -1866.4285888671875,
        1162.928955078125,
        250.0
      ],
      "bbox_max": [
        -482.9289245605469,
        1346.4285888671875,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9974586963653564,
        -0.0,
        0.07124704867601395
      ],
      "plane_d": 1831.0491943359375,
      "bbox_min": [
        -1860.0,
        1333.5714111328125,
        250.0
      ],
      "bbox_max": [
        -1853.5714111328125,
        1346.4285888671875,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1277.6927490234375,
      "bbox_min": [
        -500.0,
        1162.928955078125,
        250.0
      ],
      "bbox_max": [
        -482.9289245605469,
        1180.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826856315135956,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 902.6608276367188,
      "bbox_min": [
        -500.0,
        1162.928955078125,
        250.0
      ],
      "bbox_max": [
        -482.9289245605469,
        1180.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238794445991516,
        0.3826836347579956,
        -0.0
      ],
      "plane_d": 14.199869155883789,
      "bbox_min": [
        -500.0,
        1162.928955078125,
        250.0
      ],
      "bbox_max": [
        -497.0710754394531,
        1177.071044921875,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238794445991516,
        -0.3826836347579956,
        0.0
      ],
      "plane_d": 909.6795654296875,
      "bbox_min": [
        -500.0,
        1170.0,
        250.0
      ],
      "bbox_max": [
        -497.0710754394531,
        1177.071044921875,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -233.222412109375,
      "bbox_min": [
        -434.5,
        1158.39990234375,
        249.99998474121094
      ],
      "bbox_max": [
        -214.5,
        1219.021728515625,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660252094268799,
        0.5000004768371582,
        0.0
      ],
      "plane_d": -795.2738647460938,
      "bbox_min": [
        -249.5,
        1158.39990234375,
        249.99998474121094
      ],
      "bbox_max": [
        -214.5,
        1219.021728515625,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9510564208030701,
        -0.3090174198150635,
        0.0
      ],
      "plane_d": 882.6156005859375,
      "bbox_min": [
        210.0,
        980.0,
        250.0
      ],
      "bbox_max": [
        582.7122802734375,
        1384.3714599609375,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9510564208030701,
        0.3090174198150635,
        0.0
      ],
      "plane_d": 88.44082641601562,
      "bbox_min": [
        510.5146179199219,
        1285.0,
        250.0
      ],
      "bbox_max": [
        582.7122802734375,
        1384.3714599609375,
        520.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5877842307090759,
        0.8090178370475769,
        0.0
      ],
      "plane_d": -777.47216796875,
      "bbox_min": [
        530.4696044921875,
        1346.4150390625,
        250.0
      ],
      "bbox_max": [
        582.7122802734375,
        1384.3714599609375,
        520.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 210.0,
      "bbox_min": [
        210.0,
        980.0,
        250.0
      ],
      "bbox_max": [
        210.0,
        1240.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34176069498062134,
        0.1286875456571579,
        0.930934488773346
      ],
      "plane_d": 470.6300048828125,
      "bbox_min": [
        -6971.595703125,
        -2619.10009765625,
        -22.699951171875
      ],
      "bbox_max": [
        -2700.0,
        6873.154296875,
        1650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7714905142784119,
        0.08541621267795563,
        0.6304812431335449
      ],
      "plane_d": 2975.195556640625,
      "bbox_min": [
        -5545.388671875,
        -2269.10009765625,
        0.0
      ],
      "bbox_max": [
        -2700.0,
        4995.78271484375,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3910660445690155,
        0.31802985072135925,
        0.8636690974235535
      ],
      "plane_d": 372.2137451171875,
      "bbox_min": [
        -5545.388671875,
        2154.178466796875,
        150.0
      ],
      "bbox_max": [
        -4912.15185546875,
        4995.78271484375,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -2710.0,
        1337.393310546875,
        -22.699951171875
      ],
      "bbox_max": [
        -2700.0,
        6873.154296875,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9974586963653564,
        -0.0,
        0.07124704867601395
      ],
      "plane_d": 2678.888916015625,
      "bbox_min": [
        -2710.0,
        1337.393310546875,
        302.7590026855469
      ],
      "bbox_max": [
        -2707.33984375,
        1342.6600341796875,
        340.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}